/* tslint:disable */
/* eslint-disable */
/**
 * SAMPLE_PROJECT_NAME
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AINodeGeminiModelConfig
 */
export interface AINodeGeminiModelConfig {
    /**
     * 
     * @type {number}
     * @memberof AINodeGeminiModelConfig
     */
    'monthly_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof AINodeGeminiModelConfig
     */
    'tpm': number;
    /**
     * 
     * @type {number}
     * @memberof AINodeGeminiModelConfig
     */
    'rpm': number;
    /**
     * 
     * @type {string}
     * @memberof AINodeGeminiModelConfig
     */
    'pt': AINodeGeminiModelConfigPtEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AINodeGeminiModelConfigPtEnum {
    DEDICATED = 'dedicated',
    SHARED = 'shared',
    COMBINED = 'combined'
}

/**
 * 
 * @export
 * @interface AINodeModelConfig
 */
export interface AINodeModelConfig {
    /**
     * 
     * @type {number}
     * @memberof AINodeModelConfig
     */
    'monthly_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof AINodeModelConfig
     */
    'tpm': number;
    /**
     * 
     * @type {number}
     * @memberof AINodeModelConfig
     */
    'rpm': number;
}
/**
 * 
 * @export
 * @interface AWSAccount
 */
export interface AWSAccount {
    /**
     * 
     * @type {string}
     * @memberof AWSAccount
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccount
     */
    'account_id': string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccount
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AWSAccount
     */
    'is_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AWSAccount
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AWSAccount
     */
    'enabled_regions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AWSAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccount
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccount
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface AWSAccountCreate
 */
export interface AWSAccountCreate {
    /**
     * 
     * @type {string}
     * @memberof AWSAccountCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccountCreate
     */
    'account_id': string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccountCreate
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AWSAccountCreate
     */
    'is_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AWSAccountCreate
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AWSAccountCreate
     */
    'enabled_regions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AWSAccountUpdate
 */
export interface AWSAccountUpdate {
    /**
     * 
     * @type {string}
     * @memberof AWSAccountUpdate
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccountUpdate
     */
    'account_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AWSAccountUpdate
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AWSAccountUpdate
     */
    'is_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AWSAccountUpdate
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AWSAccountUpdate
     */
    'enabled_regions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AgentNodeConfig
 */
export interface AgentNodeConfig {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AgentNodeConfig
     */
    'environments_config': { [key: string]: string; };
}
/**
 * Metadata for agent delegation node.
 * @export
 * @interface AgentNodeMeta
 */
export interface AgentNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'type': AgentNodeMetaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'agent_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'agent_version_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'agent_version_known_etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentNodeMeta
     */
    'prompt': string;
    /**
     * 
     * @type {TogglableInputAttribute}
     * @memberof AgentNodeMeta
     */
    'files'?: TogglableInputAttribute;
    /**
     * 
     * @type {{ [key: string]: FieldMapping; }}
     * @memberof AgentNodeMeta
     */
    'input_mappings'?: { [key: string]: FieldMapping; };
    /**
     * 
     * @type {{ [key: string]: OutputAttribute; }}
     * @memberof AgentNodeMeta
     */
    'response': { [key: string]: OutputAttribute; };
    /**
     * 
     * @type {AgentNodeConfig}
     * @memberof AgentNodeMeta
     */
    'config': AgentNodeConfig;
}

/**
    * @export
    * @enum {string}
    */
export enum AgentNodeMetaTypeEnum {
    AGENT = 'agent'
}

/**
 * Create specification for the Agents module (API request).
 * @export
 * @interface AgentsModuleApiCreate
 */
export interface AgentsModuleApiCreate {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof AgentsModuleApiCreate
     */
    'kind'?: AgentsModuleApiCreateKindEnum;
    /**
     * 
     * @type {any}
     * @memberof AgentsModuleApiCreate
     */
    'version'?: any;
    /**
     * 
     * @type {any}
     * @memberof AgentsModuleApiCreate
     */
    'is_active'?: any;
    /**
     * 
     * @type {any}
     * @memberof AgentsModuleApiCreate
     */
    'profile_level'?: any;
    /**
     * 
     * @type {FlowApiSchemasV3ModulesAgentsAgentsModuleConfig}
     * @memberof AgentsModuleApiCreate
     */
    'config'?: FlowApiSchemasV3ModulesAgentsAgentsModuleConfig;
}

/**
    * @export
    * @enum {string}
    */
export enum AgentsModuleApiCreateKindEnum {
    AGENTS = 'agents'
}

/**
 * 
 * @export
 * @interface AgentsModuleConfigUpdate
 */
export interface AgentsModuleConfigUpdate {
    /**
     * 
     * @type {number}
     * @memberof AgentsModuleConfigUpdate
     */
    'agent_management_memory_mb'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentsModuleConfigUpdate
     */
    'agent_management_snap_start_mode'?: AgentsModuleConfigUpdateAgentManagementSnapStartModeEnum;
    /**
     * 
     * @type {number}
     * @memberof AgentsModuleConfigUpdate
     */
    'agent_management_provisioned_concurrency'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AgentsModuleConfigUpdateAgentManagementSnapStartModeEnum {
    INHERIT = 'inherit',
    ENABLED = 'enabled',
    DISABLED = 'disabled'
}

/**
 * 
 * @export
 * @interface AgentsModuleCreateRequest
 */
export interface AgentsModuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsModuleCreateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {FlowApiSchemasV2ModulesAgentsAgentsModuleConfig}
     * @memberof AgentsModuleCreateRequest
     */
    'config'?: FlowApiSchemasV2ModulesAgentsAgentsModuleConfig;
}
/**
 * 
 * @export
 * @interface AgentsModuleUpdateRequest
 */
export interface AgentsModuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentsModuleUpdateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {AgentsModuleConfigUpdate}
     * @memberof AgentsModuleUpdateRequest
     */
    'config'?: AgentsModuleConfigUpdate;
}
/**
 * 
 * @export
 * @interface AiNodeModelConfig
 */
export interface AiNodeModelConfig {
    /**
     * 
     * @type {string}
     * @memberof AiNodeModelConfig
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof AiNodeModelConfig
     */
    'model_id': string;
}
/**
 * 
 * @export
 * @interface AiNodeV2Config
 */
export interface AiNodeV2Config {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AiNodeV2Config
     */
    'environments_config': { [key: string]: string; };
    /**
     * 
     * @type {AiNodeV2TimeoutConfig}
     * @memberof AiNodeV2Config
     */
    'timeout': AiNodeV2TimeoutConfig;
    /**
     * 
     * @type {AiNodeV2ErrorConfig}
     * @memberof AiNodeV2Config
     */
    'error': AiNodeV2ErrorConfig;
}
/**
 * 
 * @export
 * @interface AiNodeV2ConversationMessage
 */
export interface AiNodeV2ConversationMessage {
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2ConversationMessage
     */
    'role': AiNodeV2ConversationMessageRoleEnum;
    /**
     * 
     * @type {Array<AiNodeV2ConversationMessageContentInner>}
     * @memberof AiNodeV2ConversationMessage
     */
    'content': Array<AiNodeV2ConversationMessageContentInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum AiNodeV2ConversationMessageRoleEnum {
    USER = 'user',
    ASSISTANT = 'assistant'
}

/**
 * @type AiNodeV2ConversationMessageContentInner
 * @export
 */
export type AiNodeV2ConversationMessageContentInner = { block_type: 'files_list' } & AiNodeV2ConversationMessageFilesListContentBlock | { block_type: 'text' } & AiNodeV2ConversationMessageTextContentBlock;

/**
 * 
 * @export
 * @interface AiNodeV2ConversationMessageFilesListContentBlock
 */
export interface AiNodeV2ConversationMessageFilesListContentBlock {
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2ConversationMessageFilesListContentBlock
     */
    'block_type': AiNodeV2ConversationMessageFilesListContentBlockBlockTypeEnum;
    /**
     * 
     * @type {TogglableInputAttribute}
     * @memberof AiNodeV2ConversationMessageFilesListContentBlock
     */
    'files': TogglableInputAttribute;
}

/**
    * @export
    * @enum {string}
    */
export enum AiNodeV2ConversationMessageFilesListContentBlockBlockTypeEnum {
    FILES_LIST = 'files_list'
}

/**
 * 
 * @export
 * @interface AiNodeV2ConversationMessageTextContentBlock
 */
export interface AiNodeV2ConversationMessageTextContentBlock {
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2ConversationMessageTextContentBlock
     */
    'block_type': AiNodeV2ConversationMessageTextContentBlockBlockTypeEnum;
    /**
     * 
     * @type {InputAttribute}
     * @memberof AiNodeV2ConversationMessageTextContentBlock
     */
    'text': InputAttribute;
}

/**
    * @export
    * @enum {string}
    */
export enum AiNodeV2ConversationMessageTextContentBlockBlockTypeEnum {
    TEXT = 'text'
}

/**
 * 
 * @export
 * @interface AiNodeV2ErrorConfig
 */
export interface AiNodeV2ErrorConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AiNodeV2ErrorConfig
     */
    'allow_errors': boolean;
}
/**
 * 
 * @export
 * @interface AiNodeV2InferenceConfig
 */
export interface AiNodeV2InferenceConfig {
    /**
     * 
     * @type {AiNodeV2ResponseFormatConfig}
     * @memberof AiNodeV2InferenceConfig
     */
    'response_format': AiNodeV2ResponseFormatConfig;
    /**
     * 
     * @type {Array<string>}
     * @memberof AiNodeV2InferenceConfig
     */
    'stop_sequences'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AiNodeV2InferenceConfig
     */
    'max_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof AiNodeV2InferenceConfig
     */
    'temperature'?: number;
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2InferenceConfig
     */
    'reasoning_effort'?: string;
    /**
     * 
     * @type {number}
     * @memberof AiNodeV2InferenceConfig
     */
    'json_extraction_max_reprompts'?: number;
}
/**
 * 
 * @export
 * @interface AiNodeV2Meta
 */
export interface AiNodeV2Meta {
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2Meta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2Meta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {AiNodeModelConfig}
     * @memberof AiNodeV2Meta
     */
    'model': AiNodeModelConfig;
    /**
     * 
     * @type {AiNodeV2PromptConfig}
     * @memberof AiNodeV2Meta
     */
    'prompts': AiNodeV2PromptConfig;
    /**
     * 
     * @type {{ [key: string]: OutputAttribute; }}
     * @memberof AiNodeV2Meta
     */
    'response': { [key: string]: OutputAttribute; };
    /**
     * 
     * @type {{ [key: string]: OutputAttribute; }}
     * @memberof AiNodeV2Meta
     */
    'insights'?: { [key: string]: OutputAttribute; };
    /**
     * 
     * @type {AiNodeV2InferenceConfig}
     * @memberof AiNodeV2Meta
     */
    'inference': AiNodeV2InferenceConfig;
    /**
     * 
     * @type {AiNodeV2Config}
     * @memberof AiNodeV2Meta
     */
    'config': AiNodeV2Config;
}
/**
 * 
 * @export
 * @interface AiNodeV2PromptConfig
 */
export interface AiNodeV2PromptConfig {
    /**
     * 
     * @type {TogglableInputAttribute}
     * @memberof AiNodeV2PromptConfig
     */
    'system_prompt': TogglableInputAttribute;
    /**
     * 
     * @type {Array<AiNodeV2ConversationMessage>}
     * @memberof AiNodeV2PromptConfig
     */
    'messages': Array<AiNodeV2ConversationMessage>;
}
/**
 * 
 * @export
 * @interface AiNodeV2ResponseFormatConfig
 */
export interface AiNodeV2ResponseFormatConfig {
    /**
     * 
     * @type {string}
     * @memberof AiNodeV2ResponseFormatConfig
     */
    'type': AiNodeV2ResponseFormatConfigTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof AiNodeV2ResponseFormatConfig
     */
    'json_schema'?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum AiNodeV2ResponseFormatConfigTypeEnum {
    TEXT = 'text',
    JSON = 'json'
}

/**
 * 
 * @export
 * @interface AiNodeV2TimeoutConfig
 */
export interface AiNodeV2TimeoutConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AiNodeV2TimeoutConfig
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof AiNodeV2TimeoutConfig
     */
    'timeout_seconds'?: number;
}
/**
 * An assign rule branch.
 * @export
 * @interface AssignRuleBranch
 */
export interface AssignRuleBranch {
    /**
     * 
     * @type {string}
     * @memberof AssignRuleBranch
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssignRuleBranch
     */
    'junction': AssignRuleBranchJunctionEnum;
    /**
     * 
     * @type {Array<AssignRuleClause>}
     * @memberof AssignRuleBranch
     */
    'clauses': Array<AssignRuleClause>;
    /**
     * 
     * @type {AssignStrategy}
     * @memberof AssignRuleBranch
     */
    'assign_strategy': AssignStrategy;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignRuleBranchJunctionEnum {
    AND = 'and',
    OR = 'or'
}

/**
 * A rule node condition
 * @export
 * @interface AssignRuleClause
 */
export interface AssignRuleClause {
    /**
     * 
     * @type {string}
     * @memberof AssignRuleClause
     */
    'id_left': string;
    /**
     * 
     * @type {string}
     * @memberof AssignRuleClause
     */
    'id_right': string;
    /**
     * 
     * @type {string}
     * @memberof AssignRuleClause
     */
    'left': string;
    /**
     * 
     * @type {string}
     * @memberof AssignRuleClause
     */
    'right': string;
    /**
     * 
     * @type {Operators}
     * @memberof AssignRuleClause
     */
    'operator': Operators;
}


/**
 * 
 * @export
 * @interface AssignStrategy
 */
export interface AssignStrategy {
    /**
     * 
     * @type {any}
     * @memberof AssignStrategy
     */
    'type': AssignStrategyTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof AssignStrategy
     */
    'assignees': any;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignStrategyTypeEnum {
    ANY = 'ANY',
    GROUP = 'GROUP',
    REVIEWER_ONLY = 'REVIEWER_ONLY'
}

/**
 * Randomly assign to users with admin, editor, or reviewer roles.
 * @export
 * @interface AssignStrategyAny
 */
export interface AssignStrategyAny {
    /**
     * 
     * @type {string}
     * @memberof AssignStrategyAny
     */
    'type': AssignStrategyAnyTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignStrategyAnyTypeEnum {
    ANY = 'ANY'
}

/**
 * Randomly assign to users in a group. Special Cases:     Empty - Set to unassigned     Single Element - Assign to one user
 * @export
 * @interface AssignStrategyGroup
 */
export interface AssignStrategyGroup {
    /**
     * 
     * @type {string}
     * @memberof AssignStrategyGroup
     */
    'type': AssignStrategyGroupTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignStrategyGroup
     */
    'assignees': Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignStrategyGroupTypeEnum {
    GROUP = 'GROUP'
}

/**
 * Randomly assign to users with reviewer roles.
 * @export
 * @interface AssignStrategyReviewerOnly
 */
export interface AssignStrategyReviewerOnly {
    /**
     * 
     * @type {string}
     * @memberof AssignStrategyReviewerOnly
     */
    'type': AssignStrategyReviewerOnlyTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignStrategyReviewerOnlyTypeEnum {
    REVIEWER_ONLY = 'REVIEWER_ONLY'
}

/**
 * Assign to a user based on a rule. The rule is processed in Runner and used in Exporter/Connect.
 * @export
 * @interface AssignStrategyRule
 */
export interface AssignStrategyRule {
    /**
     * 
     * @type {string}
     * @memberof AssignStrategyRule
     */
    'type': AssignStrategyRuleTypeEnum;
    /**
     * 
     * @type {Array<AssignRuleBranch>}
     * @memberof AssignStrategyRule
     */
    'branches': Array<AssignRuleBranch>;
    /**
     * 
     * @type {DefaultAssignStrategy}
     * @memberof AssignStrategyRule
     */
    'default_assign_strategy': DefaultAssignStrategy;
}

/**
    * @export
    * @enum {string}
    */
export enum AssignStrategyRuleTypeEnum {
    RULE = 'RULE'
}

/**
 * 
 * @export
 * @interface AssignmentNodeMeta
 */
export interface AssignmentNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof AssignmentNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {Array<Effect>}
     * @memberof AssignmentNodeMeta
     */
    'default_effects': Array<Effect>;
}
/**
 * 
 * @export
 * @interface AttributeFilter
 */
export interface AttributeFilter {
    /**
     * 
     * @type {Array<EventAttributeEnv>}
     * @memberof AttributeFilter
     */
    'decision_env'?: Array<EventAttributeEnv>;
    /**
     * 
     * @type {Array<AttributeFilterStatusInner>}
     * @memberof AttributeFilter
     */
    'status'?: Array<AttributeFilterStatusInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttributeFilter
     */
    'flow_id'?: Array<string>;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof AttributeFilter
     */
    'is_async'?: Array<boolean>;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof AttributeFilter
     */
    'is_internal'?: Array<boolean>;
}
/**
 * 
 * @export
 * @interface AttributeFilterStatusInner
 */
export interface AttributeFilterStatusInner {
}
/**
 * 
 * @export
 * @interface BaseInputField
 */
export interface BaseInputField {
    /**
     * 
     * @type {string}
     * @memberof BaseInputField
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BaseInputField
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface BranchNodeMeta
 */
export interface BranchNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof BranchNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BranchNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BranchNodeMeta
     */
    'src': string;
    /**
     * 
     * @type {boolean}
     * @memberof BranchNodeMeta
     */
    'is_split_branch_node': boolean;
}
/**
 * 
 * @export
 * @interface BreakLoop
 */
export interface BreakLoop {
    /**
     * 
     * @type {Junctions}
     * @memberof BreakLoop
     */
    'junction': Junctions;
    /**
     * 
     * @type {Array<Clause>}
     * @memberof BreakLoop
     */
    'clauses': Array<Clause>;
    /**
     * 
     * @type {string}
     * @memberof BreakLoop
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof BreakLoop
     */
    'enabled': boolean;
}


/**
 * 
 * @export
 * @interface CapacityRecommendations
 */
export interface CapacityRecommendations {
    /**
     * 
     * @type {Array<ExistingAccountRecommendation>}
     * @memberof CapacityRecommendations
     */
    'existing_accounts': Array<ExistingAccountRecommendation>;
    /**
     * 
     * @type {Array<NewAccountRecommendation>}
     * @memberof CapacityRecommendations
     */
    'new_accounts': Array<NewAccountRecommendation>;
}
/**
 * 
 * @export
 * @interface CapacityReport
 */
export interface CapacityReport {
    /**
     * 
     * @type {Array<RegionCapacityStats>}
     * @memberof CapacityReport
     */
    'regions': Array<RegionCapacityStats>;
    /**
     * 
     * @type {number}
     * @memberof CapacityReport
     */
    'threshold_percentage': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CapacityReport
     */
    'regions_at_threshold': Array<string>;
    /**
     * 
     * @type {Array<RegionCapacityIncreaseNeeded>}
     * @memberof CapacityReport
     */
    'regions_needing_capacity_increases': Array<RegionCapacityIncreaseNeeded>;
    /**
     * 
     * @type {CapacityRecommendations}
     * @memberof CapacityReport
     */
    'recommendations': CapacityRecommendations;
    /**
     * 
     * @type {number}
     * @memberof CapacityReport
     */
    'additional_accounts_needed': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CapacityReport
     */
    'regions_to_enable_in_new_accounts': { [key: string]: number; };
}
/**
 * Connect Case Creation Node Meta.
 * @export
 * @interface CaseCreationNodeMeta
 */
export interface CaseCreationNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMeta
     */
    'case_node_type'?: CaseCreationNodeMetaCaseNodeTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof CaseCreationNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {CaseCreationNodeMetaTemplate}
     * @memberof CaseCreationNodeMeta
     */
    'template'?: CaseCreationNodeMetaTemplate;
    /**
     * 
     * @type {{ [key: string]: CaseCreationNodeMetaMappedValue; }}
     * @memberof CaseCreationNodeMeta
     */
    'details_mapping': { [key: string]: CaseCreationNodeMetaMappedValue; };
    /**
     * 
     * @type {CaseCreationNodeMetaAssignedQueue}
     * @memberof CaseCreationNodeMeta
     */
    'assigned_queue'?: CaseCreationNodeMetaAssignedQueue;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMeta
     */
    'case_input_location': string;
    /**
     * 
     * @type {CaseCreationNodeMetaAdvancedSettings}
     * @memberof CaseCreationNodeMeta
     */
    'advanced_settings': CaseCreationNodeMetaAdvancedSettings;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaCaseNodeTypeEnum {
    CREATION = 'creation'
}

/**
 * 
 * @export
 * @interface CaseCreationNodeMetaAdvancedSettings
 */
export interface CaseCreationNodeMetaAdvancedSettings {
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaAdvancedSettings
     */
    'test_run': CaseCreationNodeMetaAdvancedSettingsTestRunEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaAdvancedSettings
     */
    'sandbox': CaseCreationNodeMetaAdvancedSettingsSandboxEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaAdvancedSettings
     */
    'live': CaseCreationNodeMetaAdvancedSettingsLiveEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaAdvancedSettingsTestRunEnum {
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaAdvancedSettingsSandboxEnum {
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaAdvancedSettingsLiveEnum {
    LIVE = 'live'
}

/**
 * 
 * @export
 * @interface CaseCreationNodeMetaAssignedQueue
 */
export interface CaseCreationNodeMetaAssignedQueue {
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaAssignedQueue
     */
    'type': CaseCreationNodeMetaAssignedQueueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaAssignedQueue
     */
    'value_type': CaseCreationNodeMetaAssignedQueueValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaAssignedQueue
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaAssignedQueueTypeEnum {
    NON_CONDITIONAL = 'non-conditional'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaAssignedQueueValueTypeEnum {
    FIXED = 'fixed'
}

/**
 * 
 * @export
 * @interface CaseCreationNodeMetaMappedValue
 */
export interface CaseCreationNodeMetaMappedValue {
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaMappedValue
     */
    'type': CaseCreationNodeMetaMappedValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaMappedValue
     */
    'section': CaseCreationNodeMetaMappedValueSectionEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaMappedValue
     */
    'value_type': CaseCreationNodeMetaMappedValueValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaMappedValue
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaMappedValueTypeEnum {
    NON_CONDITIONAL = 'non-conditional'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaMappedValueSectionEnum {
    PROPERTIES = 'properties',
    ADDITIONAL = 'additional',
    FILE_CATEGORIES = 'file_categories'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseCreationNodeMetaMappedValueValueTypeEnum {
    FIXED = 'fixed',
    DYNAMIC = 'dynamic'
}

/**
 * 
 * @export
 * @interface CaseCreationNodeMetaTemplate
 */
export interface CaseCreationNodeMetaTemplate {
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaTemplate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationNodeMetaTemplate
     */
    'version_id': string;
    /**
     * 
     * @type {number}
     * @memberof CaseCreationNodeMetaTemplate
     */
    'etag': number;
}
/**
 * 
 * @export
 * @interface CaseManagementModuleConfig
 */
export interface CaseManagementModuleConfig {
    /**
     * 
     * @type {number}
     * @memberof CaseManagementModuleConfig
     */
    'max_templates_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseManagementModuleConfig
     */
    'max_table_block_data_size_bytes'?: number;
}
/**
 * 
 * @export
 * @interface CaseManagementModuleConfigUpdate
 */
export interface CaseManagementModuleConfigUpdate {
    /**
     * 
     * @type {number}
     * @memberof CaseManagementModuleConfigUpdate
     */
    'max_templates_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseManagementModuleConfigUpdate
     */
    'max_table_block_data_size_bytes'?: number;
}
/**
 * 
 * @export
 * @interface CaseManagementModuleCreateRequest
 */
export interface CaseManagementModuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CaseManagementModuleCreateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {CaseManagementModuleConfig}
     * @memberof CaseManagementModuleCreateRequest
     */
    'config'?: CaseManagementModuleConfig;
}
/**
 * 
 * @export
 * @interface CaseManagementModuleSpec
 */
export interface CaseManagementModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof CaseManagementModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {ModuleStatus}
     * @memberof CaseManagementModuleSpec
     */
    'status': ModuleStatus;
    /**
     * 
     * @type {string}
     * @memberof CaseManagementModuleSpec
     */
    'stack_name': string;
    /**
     * 
     * @type {CaseManagementModuleConfig}
     * @memberof CaseManagementModuleSpec
     */
    'config': CaseManagementModuleConfig;
}


/**
 * 
 * @export
 * @interface CaseManagementModuleUpdateRequest
 */
export interface CaseManagementModuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CaseManagementModuleUpdateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {CaseManagementModuleConfigUpdate}
     * @memberof CaseManagementModuleUpdateRequest
     */
    'config'?: CaseManagementModuleConfigUpdate;
}
/**
 * Connect Case Update Node Meta.
 * @export
 * @interface CaseUpdateNodeMeta
 */
export interface CaseUpdateNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMeta
     */
    'case_node_type'?: CaseUpdateNodeMetaCaseNodeTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof CaseUpdateNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {CaseUpdateNodeMetaTemplate}
     * @memberof CaseUpdateNodeMeta
     */
    'template'?: CaseUpdateNodeMetaTemplate;
    /**
     * 
     * @type {Array<CaseUpdateNodeMetaSelection>}
     * @memberof CaseUpdateNodeMeta
     */
    'selections'?: Array<CaseUpdateNodeMetaSelection>;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMeta
     */
    'case_input_location': string;
    /**
     * 
     * @type {CaseUpdateNodeMetaAdvancedSettings}
     * @memberof CaseUpdateNodeMeta
     */
    'advanced_settings': CaseUpdateNodeMetaAdvancedSettings;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseUpdateNodeMetaCaseNodeTypeEnum {
    UPDATE = 'update'
}

/**
 * 
 * @export
 * @interface CaseUpdateNodeMetaAdvancedSettings
 */
export interface CaseUpdateNodeMetaAdvancedSettings {
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaAdvancedSettings
     */
    'test_run': CaseUpdateNodeMetaAdvancedSettingsTestRunEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaAdvancedSettings
     */
    'sandbox': CaseUpdateNodeMetaAdvancedSettingsSandboxEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaAdvancedSettings
     */
    'live': CaseUpdateNodeMetaAdvancedSettingsLiveEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseUpdateNodeMetaAdvancedSettingsTestRunEnum {
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseUpdateNodeMetaAdvancedSettingsSandboxEnum {
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum CaseUpdateNodeMetaAdvancedSettingsLiveEnum {
    LIVE = 'live'
}

/**
 * 
 * @export
 * @interface CaseUpdateNodeMetaSelection
 */
export interface CaseUpdateNodeMetaSelection {
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaSelection
     */
    'type': CaseUpdateNodeMetaSelectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaSelection
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaSelection
     */
    'status_key'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CaseUpdateNodeMetaSelectionTypeEnum {
    PROPERTIES = 'properties',
    QUEUE = 'queue',
    ASSIGNEE = 'assignee',
    BLOCK_DATA = 'block_data',
    BLOCK_CONFIG = 'block_config',
    ACTION_FORMS = 'action_forms',
    TASK_FORMS = 'task_forms'
}

/**
 * 
 * @export
 * @interface CaseUpdateNodeMetaTemplate
 */
export interface CaseUpdateNodeMetaTemplate {
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaTemplate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseUpdateNodeMetaTemplate
     */
    'version_id': string;
    /**
     * 
     * @type {number}
     * @memberof CaseUpdateNodeMetaTemplate
     */
    'etag': number;
}
/**
 * 
 * @export
 * @interface ChangeLogDb
 */
export interface ChangeLogDb {
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'flow_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'etag': string;
    /**
     * 
     * @type {FlowVersionUpdate}
     * @memberof ChangeLogDb
     */
    'diff'?: FlowVersionUpdate;
    /**
     * 
     * @type {FlowVersionV2}
     * @memberof ChangeLogDb
     */
    'checkpoint'?: FlowVersionV2;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'authored_by': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'previous_change_etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'previous_change_flow_version_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeLogDb
     */
    'previous_change_flow_id'?: string;
    /**
     * 
     * @type {CommentDb}
     * @memberof ChangeLogDb
     */
    'comment'?: CommentDb;
}
/**
 * 
 * @export
 * @interface Chart
 */
export interface Chart {
    /**
     * 
     * @type {ChartResourceType}
     * @memberof Chart
     */
    'resource_type'?: ChartResourceType;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'resource_id': string;
    /**
     * 
     * @type {number}
     * @memberof Chart
     */
    'order_index'?: number;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'description'?: string;
    /**
     * 
     * @type {ChartMark}
     * @memberof Chart
     */
    'mark': ChartMark;
    /**
     * 
     * @type {Dimensions}
     * @memberof Chart
     */
    'dimensions': Dimensions;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Chart
     */
    'version': ChartVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof Chart
     */
    'etag': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ChartVersionEnum {
    NUMBER_1 = 1
}

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ChartAggregator {
    COUNT = 'count',
    SUM = 'sum',
    MEAN = 'mean',
    MEDIAN = 'median',
    MIN = 'min',
    MAX = 'max'
}


/**
 * 
 * @export
 * @interface ChartCreateRequest
 */
export interface ChartCreateRequest {
    /**
     * 
     * @type {ChartResourceType}
     * @memberof ChartCreateRequest
     */
    'resource_type'?: ChartResourceType;
    /**
     * 
     * @type {string}
     * @memberof ChartCreateRequest
     */
    'resource_id': string;
    /**
     * 
     * @type {number}
     * @memberof ChartCreateRequest
     */
    'order_index'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChartCreateRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ChartCreateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {ChartMark}
     * @memberof ChartCreateRequest
     */
    'mark': ChartMark;
    /**
     * 
     * @type {Dimensions}
     * @memberof ChartCreateRequest
     */
    'dimensions': Dimensions;
}


/**
 * 
 * @export
 * @interface ChartDimension
 */
export interface ChartDimension {
    /**
     * 
     * @type {string}
     * @memberof ChartDimension
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChartDimension
     */
    'reduce'?: ChartDimensionReduceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ChartDimension
     */
    'exclude_rows_without_outcome'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ChartDimensionReduceEnum {
    AUTO = 'auto',
    COUNT = 'count',
    DISTINCT = 'distinct',
    SUM = 'sum',
    MIN = 'min',
    MAX = 'max',
    MEAN = 'mean',
    MEDIAN = 'median',
    MODE = 'mode',
    PROPORTION = 'proportion',
    PROPORTION_FACET = 'proportion-facet'
}

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ChartFormat {
    NUMBER = 'number',
    CURRENCY = 'currency',
    PERCENT = 'percent'
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ChartMark {
    AUTO = 'auto',
    BAR = 'bar',
    LINE = 'line',
    AREA = 'area',
    DOT = 'dot',
    RULE = 'rule',
    SUMMARY = 'summary'
}


/**
 * 
 * @export
 * @interface ChartPatch
 */
export interface ChartPatch {
    /**
     * 
     * @type {string}
     * @memberof ChartPatch
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChartPatch
     */
    'description'?: string;
    /**
     * 
     * @type {ChartMark}
     * @memberof ChartPatch
     */
    'mark'?: ChartMark;
    /**
     * 
     * @type {Dimensions}
     * @memberof ChartPatch
     */
    'dimensions'?: Dimensions;
}


/**
 * 
 * @export
 * @interface ChartReorder
 */
export interface ChartReorder {
    /**
     * 
     * @type {ChartResourceType}
     * @memberof ChartReorder
     */
    'resource_type': ChartResourceType;
    /**
     * 
     * @type {string}
     * @memberof ChartReorder
     */
    'resource_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChartReorder
     */
    'new_order': Array<string>;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ChartResourceType {
    FLOW = 'flow',
    NODE = 'node'
}


/**
 * 
 * @export
 * @interface Clause
 */
export interface Clause {
    /**
     * 
     * @type {string}
     * @memberof Clause
     */
    'id_left': string;
    /**
     * 
     * @type {string}
     * @memberof Clause
     */
    'id_right': string;
    /**
     * 
     * @type {string}
     * @memberof Clause
     */
    'left': string;
    /**
     * 
     * @type {string}
     * @memberof Clause
     */
    'right': string;
    /**
     * 
     * @type {Operators}
     * @memberof Clause
     */
    'operator': Operators;
}


/**
 * 
 * @export
 * @interface CodeNodeMeta
 */
export interface CodeNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof CodeNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CodeNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CodeNodeMeta
     */
    'src': string;
}
/**
 * 
 * @export
 * @interface CommentCreate
 */
export interface CommentCreate {
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'flow_version': string;
    /**
     * 
     * @type {CommentResourceType}
     * @memberof CommentCreate
     */
    'resource_type'?: CommentResourceType;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'resource_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'parent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'review_id'?: string;
    /**
     * 
     * @type {ReviewCommentStatus}
     * @memberof CommentCreate
     */
    'reviewer_status'?: ReviewCommentStatus;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'flow_version_etag'?: string;
}


/**
 * 
 * @export
 * @interface CommentDb
 */
export interface CommentDb {
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'author': string;
    /**
     * 
     * @type {CommentResourceType}
     * @memberof CommentDb
     */
    'resource_type'?: CommentResourceType;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'resource_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'parent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'replied_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentDb
     */
    'reply_count': number;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'resolved_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'resolved_by'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentDb
     */
    'resolved': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'review_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDb
     */
    'flow_version_etag'?: string;
    /**
     * 
     * @type {ReviewCommentStatus}
     * @memberof CommentDb
     */
    'reviewer_status'?: ReviewCommentStatus;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum CommentResourceType {
    FLOW_VERSION = 'flow-version',
    NODE = 'node',
    REVIEW = 'review'
}


/**
 * 
 * @export
 * @interface CommentSummary
 */
export interface CommentSummary {
    /**
     * 
     * @type {Array<NodeCommentSummary>}
     * @memberof CommentSummary
     */
    'nodes_comment_summary': Array<NodeCommentSummary>;
    /**
     * 
     * @type {number}
     * @memberof CommentSummary
     */
    'flow_version_count': number;
    /**
     * 
     * @type {number}
     * @memberof CommentSummary
     */
    'review_comment_count': number;
}
/**
 * 
 * @export
 * @interface CommentUpdate
 */
export interface CommentUpdate {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdate
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentUpdate
     */
    'resolved'?: boolean;
}
/**
 * 
 * @export
 * @interface ConnectModuleConfig
 */
export interface ConnectModuleConfig {
    /**
     * 
     * @type {boolean}
     * @memberof ConnectModuleConfig
     */
    'deploy_routes'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'throttling_burst_limit_connect_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'webhook_timeout_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'provisioned_concurrency_connect'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'memory_connect_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'timeout_connect_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'webhook_timeout_batch_window'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'webhook_timeout_sqs_consumption_maximum_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'throttling_rate_limit_connect_global'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectModuleConfig
     */
    'is_sam_local_deploy'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfig
     */
    'total_custom_connection_retry_count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectModuleConfig
     */
    'self_hosted_open_sanctions_enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ConnectModuleConfigUpdate
 */
export interface ConnectModuleConfigUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ConnectModuleConfigUpdate
     */
    'deploy_routes'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'throttling_burst_limit_connect_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'webhook_timeout_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'provisioned_concurrency_connect'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'memory_connect_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'timeout_connect_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'webhook_timeout_batch_window'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'webhook_timeout_sqs_consumption_maximum_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'throttling_rate_limit_connect_global'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectModuleConfigUpdate
     */
    'is_sam_local_deploy'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConnectModuleConfigUpdate
     */
    'total_custom_connection_retry_count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectModuleConfigUpdate
     */
    'self_hosted_open_sanctions_enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ConnectModuleCreateRequest
 */
export interface ConnectModuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectModuleCreateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {ConnectModuleConfig}
     * @memberof ConnectModuleCreateRequest
     */
    'config'?: ConnectModuleConfig;
}
/**
 * 
 * @export
 * @interface ConnectModuleSpec
 */
export interface ConnectModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof ConnectModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {ModuleStatus}
     * @memberof ConnectModuleSpec
     */
    'status': ModuleStatus;
    /**
     * 
     * @type {string}
     * @memberof ConnectModuleSpec
     */
    'stack_name': string;
    /**
     * 
     * @type {ConnectModuleConfig}
     * @memberof ConnectModuleSpec
     */
    'config': ConnectModuleConfig;
}


/**
 * 
 * @export
 * @interface ConnectModuleUpdateRequest
 */
export interface ConnectModuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectModuleUpdateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {ConnectModuleConfigUpdate}
     * @memberof ConnectModuleUpdateRequest
     */
    'config'?: ConnectModuleConfigUpdate;
}
/**
 * Basic connect node information used to list connect nodes on flow version without exposing details of the flow logic. Can be made available with checking `workspace` resource permission, Instead of the `workspace_data` resource permission.
 * @export
 * @interface ConnectNodeBasic
 */
export interface ConnectNodeBasic {
    /**
     * 
     * @type {string}
     * @memberof ConnectNodeBasic
     */
    'id': string;
    /**
     * 
     * @type {NodeTypes}
     * @memberof ConnectNodeBasic
     */
    'type': NodeTypes;
    /**
     * 
     * @type {string}
     * @memberof ConnectNodeBasic
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectNodeBasic
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectNodeBasic
     */
    'resource': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectNodeBasic
     */
    'connection_id': string;
}


/**
 * 
 * @export
 * @interface CopyFlowResponse
 */
export interface CopyFlowResponse {
    /**
     * 
     * @type {FlowDb}
     * @memberof CopyFlowResponse
     */
    'flow': FlowDb;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyFlowResponse
     */
    'flow_versions_ids': Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CopyFlowResponse
     */
    'datasets_to_copy': { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CopyFlowResponse
     */
    'remapped_child_flow_ids': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CustomConnectionBody
 */
export interface CustomConnectionBody {
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionBody
     */
    'id': string;
    /**
     * 
     * @type {Value}
     * @memberof CustomConnectionBody
     */
    'value': Value;
}
/**
 * 
 * @export
 * @interface CustomConnectionNodeMeta
 */
export interface CustomConnectionNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof CustomConnectionNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionNodeMeta
     */
    'media_key'?: string;
    /**
     * 
     * @type {object}
     * @memberof CustomConnectionNodeMeta
     */
    'config': object;
    /**
     * 
     * @type {string}
     * @memberof CustomConnectionNodeMeta
     */
    'verb': string;
    /**
     * 
     * @type {InputAttribute}
     * @memberof CustomConnectionNodeMeta
     */
    'path': InputAttribute;
    /**
     * 
     * @type {Array<KeyValuePair>}
     * @memberof CustomConnectionNodeMeta
     */
    'params': Array<KeyValuePair>;
    /**
     * 
     * @type {Array<KeyValuePair>}
     * @memberof CustomConnectionNodeMeta
     */
    'headers': Array<KeyValuePair>;
    /**
     * 
     * @type {CustomConnectionBody}
     * @memberof CustomConnectionNodeMeta
     */
    'body': CustomConnectionBody;
    /**
     * 
     * @type {object}
     * @memberof CustomConnectionNodeMeta
     */
    'response': object;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {Meta}
     * @memberof Data
     */
    'meta'?: Meta;
    /**
     * 
     * @type {any}
     * @memberof Data
     */
    'name': any;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof Data
     */
    'status'?: FlowVersionStatus;
    /**
     * 
     * @type {any}
     * @memberof Data
     */
    'include_comments'?: any;
    /**
     * 
     * @type {any}
     * @memberof Data
     */
    'flow_id': any;
}


/**
 * 
 * @export
 * @interface Data1
 */
export interface Data1 {
    /**
     * 
     * @type {any}
     * @memberof Data1
     */
    'type': any;
    /**
     * 
     * @type {any}
     * @memberof Data1
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Data1
     */
    'lid'?: any;
}
/**
 * 
 * @export
 * @interface DataRetentionTimedelta
 */
export interface DataRetentionTimedelta {
    /**
     * 
     * @type {number}
     * @memberof DataRetentionTimedelta
     */
    'value': number;
    /**
     * 
     * @type {DataRetentionUnit}
     * @memberof DataRetentionTimedelta
     */
    'unit': DataRetentionUnit;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum DataRetentionUnit {
    DAYS = 'days',
    MINUTES = 'minutes',
    HOURS = 'hours',
    WEEKS = 'weeks',
    MONTHS = 'months',
    YEARS = 'years'
}


/**
 * 
 * @export
 * @interface DatabaseConnectionNodeMeta
 */
export interface DatabaseConnectionNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof DatabaseConnectionNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionNodeMeta
     */
    'media_key'?: string;
    /**
     * 
     * @type {object}
     * @memberof DatabaseConnectionNodeMeta
     */
    'config': object;
    /**
     * 
     * @type {Array<DatabaseVariable>}
     * @memberof DatabaseConnectionNodeMeta
     */
    'variables': Array<DatabaseVariable>;
    /**
     * 
     * @type {InputAttribute}
     * @memberof DatabaseConnectionNodeMeta
     */
    'query': InputAttribute;
    /**
     * 
     * @type {object}
     * @memberof DatabaseConnectionNodeMeta
     */
    'response': object;
}
/**
 * 
 * @export
 * @interface DatabaseVariable
 */
export interface DatabaseVariable {
    /**
     * 
     * @type {string}
     * @memberof DatabaseVariable
     */
    'id_key': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVariable
     */
    'id_expression': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVariable
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVariable
     */
    'expression': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVariable
     */
    'id_type': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVariable
     */
    'type_'?: string;
}
/**
 * 
 * @export
 * @interface DatasetsDuplicate
 */
export interface DatasetsDuplicate {
    /**
     * 
     * @type {string}
     * @memberof DatasetsDuplicate
     */
    'target_flow_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatasetsDuplicate
     */
    'dataset_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DecisionTableCase
 */
export interface DecisionTableCase {
    /**
     * 
     * @type {string}
     * @memberof DecisionTableCase
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionTableCase
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: DecisionTablePredicate; }}
     * @memberof DecisionTableCase
     */
    'predicates': { [key: string]: DecisionTablePredicate; };
    /**
     * 
     * @type {{ [key: string]: DecisionTableEffect; }}
     * @memberof DecisionTableCase
     */
    'effects': { [key: string]: DecisionTableEffect; };
}
/**
 * 
 * @export
 * @interface DecisionTableEffect
 */
export interface DecisionTableEffect {
    /**
     * 
     * @type {string}
     * @memberof DecisionTableEffect
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionTableEffect
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface DecisionTableField
 */
export interface DecisionTableField {
    /**
     * 
     * @type {string}
     * @memberof DecisionTableField
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionTableField
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface DecisionTableNodeMeta
 */
export interface DecisionTableNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof DecisionTableNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecisionTableNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {Array<DecisionTableField>}
     * @memberof DecisionTableNodeMeta
     */
    'predicate_fields': Array<DecisionTableField>;
    /**
     * 
     * @type {Array<DecisionTableField>}
     * @memberof DecisionTableNodeMeta
     */
    'effect_fields': Array<DecisionTableField>;
    /**
     * 
     * @type {Array<DecisionTableCase>}
     * @memberof DecisionTableNodeMeta
     */
    'cases': Array<DecisionTableCase>;
    /**
     * 
     * @type {{ [key: string]: DecisionTableEffect; }}
     * @memberof DecisionTableNodeMeta
     */
    'fallback': { [key: string]: DecisionTableEffect; };
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum DecisionTableOperators {
    LT = 'lt',
    LE = 'le',
    EQ = 'eq',
    NE = 'ne',
    GE = 'ge',
    GT = 'gt',
    IS_IN = 'is_in',
    NOT_IS_IN = 'not_is_in',
    IS_NONE = 'is_none',
    IS_NOT_NONE = 'is_not_none',
    IS_ANY = 'is_any',
    CONTAINS = 'contains',
    DOES_NOT_CONTAIN = 'does_not_contain',
    MATCHES_REGEX = 'matches_regex'
}


/**
 * 
 * @export
 * @interface DecisionTablePredicate
 */
export interface DecisionTablePredicate {
    /**
     * 
     * @type {string}
     * @memberof DecisionTablePredicate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DecisionTablePredicate
     */
    'value': string;
    /**
     * 
     * @type {DecisionTableOperators}
     * @memberof DecisionTablePredicate
     */
    'operator': DecisionTableOperators;
}


/**
 * 
 * @export
 * @interface DefaultAssignStrategy
 */
export interface DefaultAssignStrategy {
    /**
     * 
     * @type {any}
     * @memberof DefaultAssignStrategy
     */
    'type': DefaultAssignStrategyTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof DefaultAssignStrategy
     */
    'assignees': any;
}

/**
    * @export
    * @enum {string}
    */
export enum DefaultAssignStrategyTypeEnum {
    ANY = 'ANY',
    GROUP = 'GROUP',
    REVIEWER_ONLY = 'REVIEWER_ONLY'
}

/**
 * @type DesiredSpec
 * @export
 */
export type DesiredSpec = { kind: 'agents' } & FlowApiSchemasV3ModulesAgentsAgentsModuleSpec | { kind: 'files' } & FlowApiSchemasV3ModulesFilesFilesModuleSpec;

/**
 * @type DesiredSpec1
 * @export
 */
export type DesiredSpec1 = { kind: 'agents' } & AgentsModuleApiCreate | { kind: 'files' } & FilesModuleApiCreate;

/**
 * 
 * @export
 * @interface Dimensions
 */
export interface Dimensions {
    /**
     * 
     * @type {ChartDimension}
     * @memberof Dimensions
     */
    'x': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof Dimensions
     */
    'y': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof Dimensions
     */
    'color': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof Dimensions
     */
    'size': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof Dimensions
     */
    'fx': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof Dimensions
     */
    'fy': ChartDimension;
    /**
     * 
     * @type {any}
     * @memberof Dimensions
     */
    'field'?: any;
    /**
     * 
     * @type {ChartAggregator}
     * @memberof Dimensions
     */
    'aggregator': ChartAggregator;
    /**
     * 
     * @type {ChartFormat}
     * @memberof Dimensions
     */
    'format': ChartFormat;
}


/**
 * 
 * @export
 * @interface EdgeDb
 */
export interface EdgeDb {
    /**
     * 
     * @type {EdgeMeta}
     * @memberof EdgeDb
     */
    'meta'?: EdgeMeta;
    /**
     * 
     * @type {string}
     * @memberof EdgeDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EdgeDb
     */
    'start_node_id': string;
    /**
     * 
     * @type {string}
     * @memberof EdgeDb
     */
    'end_node_id': string;
}
/**
 * 
 * @export
 * @interface EdgeMeta
 */
export interface EdgeMeta {
    /**
     * 
     * @type {boolean}
     * @memberof EdgeMeta
     */
    'is_split_edge'?: boolean;
}
/**
 * 
 * @export
 * @interface EdgeUpsert
 */
export interface EdgeUpsert {
    /**
     * 
     * @type {EdgeMeta}
     * @memberof EdgeUpsert
     */
    'meta'?: EdgeMeta;
    /**
     * 
     * @type {string}
     * @memberof EdgeUpsert
     */
    'start_node_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EdgeUpsert
     */
    'end_node_id'?: string;
}
/**
 * 
 * @export
 * @interface Effect
 */
export interface Effect {
    /**
     * 
     * @type {string}
     * @memberof Effect
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Effect
     */
    'target': string;
    /**
     * 
     * @type {string}
     * @memberof Effect
     */
    'value': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum EventAttributeEnv {
    SANDBOX = 'sandbox',
    LIVE = 'live'
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum EventAttributeStatus {
    SUCCESS = 'success',
    ERROR = 'error',
    PENDING = 'pending'
}


/**
 * Mode of publishing to event bridge
 * @export
 * @enum {string}
 */

export enum EventBridgePublishingMode {
    ALL = 'all',
    ERROR = 'error',
    NONE = 'none'
}


/**
 * 
 * @export
 * @interface EventFilter
 */
export interface EventFilter {
    /**
     * 
     * @type {EventType}
     * @memberof EventFilter
     */
    'type': EventType;
    /**
     * 
     * @type {AttributeFilter}
     * @memberof EventFilter
     */
    'condition': AttributeFilter;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum EventType {
    DECISION_OUTCOME = 'DecisionOutcome',
    MANUAL_REVIEW_CASE_CREATION = 'ManualReviewCaseCreation',
    JOB_RUN_EXECUTION = 'JobRunExecution'
}


/**
 * 
 * @export
 * @interface ExistingAccountRecommendation
 */
export interface ExistingAccountRecommendation {
    /**
     * 
     * @type {string}
     * @memberof ExistingAccountRecommendation
     */
    'account_id': string;
    /**
     * 
     * @type {string}
     * @memberof ExistingAccountRecommendation
     */
    'account_name': string;
    /**
     * 
     * @type {string}
     * @memberof ExistingAccountRecommendation
     */
    'aws_account_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExistingAccountRecommendation
     */
    'regions_to_enable': Array<string>;
}
/**
 * 
 * @export
 * @interface FeatureModuleConfigs
 */
export interface FeatureModuleConfigs {
    /**
     * 
     * @type {number}
     * @memberof FeatureModuleConfigs
     */
    'valkey_entity_features_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeatureModuleConfigs
     */
    'valkey_max_workers'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureModuleConfigs
     */
    'enrichment_isolation_level'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureModuleConfigs
     */
    'enrichment_stage'?: string;
    /**
     * 
     * @type {number}
     * @memberof FeatureModuleConfigs
     */
    'max_active_feature_queries'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeatureModuleConfigs
     */
    'persist_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeatureModuleConfigs
     */
    'min_events_for_concurrency'?: number;
}
/**
 * 
 * @export
 * @interface FieldMapping
 */
export interface FieldMapping {
    /**
     * 
     * @type {string}
     * @memberof FieldMapping
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FieldMapping
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof FieldMapping
     */
    'destination': string;
}
/**
 * Create specification for the Files module (API request).
 * @export
 * @interface FilesModuleApiCreate
 */
export interface FilesModuleApiCreate {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof FilesModuleApiCreate
     */
    'kind'?: FilesModuleApiCreateKindEnum;
    /**
     * 
     * @type {any}
     * @memberof FilesModuleApiCreate
     */
    'version'?: any;
    /**
     * 
     * @type {any}
     * @memberof FilesModuleApiCreate
     */
    'is_active'?: any;
    /**
     * 
     * @type {any}
     * @memberof FilesModuleApiCreate
     */
    'profile_level'?: any;
    /**
     * 
     * @type {FlowApiSchemasV3ModulesFilesFilesModuleConfig}
     * @memberof FilesModuleApiCreate
     */
    'config'?: FlowApiSchemasV3ModulesFilesFilesModuleConfig;
}

/**
    * @export
    * @enum {string}
    */
export enum FilesModuleApiCreateKindEnum {
    FILES = 'files'
}

/**
 * 
 * @export
 * @interface FilesModuleConfigUpdate
 */
export interface FilesModuleConfigUpdate {
    /**
     * 
     * @type {string}
     * @memberof FilesModuleConfigUpdate
     */
    'test_files_module_parameter'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilesModuleConfigUpdate
     */
    'use_cf_stack_refactor'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilesModuleConfigUpdate
     */
    'provisioned_concurrency_files'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilesModuleConfigUpdate
     */
    'memory_files_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilesModuleConfigUpdate
     */
    'timeout_files_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilesModuleConfigUpdate
     */
    'throttling_rate_limit_files'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilesModuleConfigUpdate
     */
    'throttling_burst_rate_limit_files'?: number;
}
/**
 * 
 * @export
 * @interface FilesModuleCreateRequest
 */
export interface FilesModuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof FilesModuleCreateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {FlowApiSchemasV2ModulesFilesFilesModuleConfig}
     * @memberof FilesModuleCreateRequest
     */
    'config'?: FlowApiSchemasV2ModulesFilesFilesModuleConfig;
}
/**
 * 
 * @export
 * @interface FilesModuleUpdateRequest
 */
export interface FilesModuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof FilesModuleUpdateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {FilesModuleConfigUpdate}
     * @memberof FilesModuleUpdateRequest
     */
    'config'?: FilesModuleConfigUpdate;
}
/**
 * 
 * @export
 * @interface FlowApiSchemasV2ModulesAgentsAgentsModuleConfig
 */
export interface FlowApiSchemasV2ModulesAgentsAgentsModuleConfig {
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleConfig
     */
    'agent_management_memory_mb'?: number;
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleConfig
     */
    'agent_management_snap_start_mode'?: FlowApiSchemasV2ModulesAgentsAgentsModuleConfigAgentManagementSnapStartModeEnum;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleConfig
     */
    'agent_management_provisioned_concurrency'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowApiSchemasV2ModulesAgentsAgentsModuleConfigAgentManagementSnapStartModeEnum {
    INHERIT = 'inherit',
    ENABLED = 'enabled',
    DISABLED = 'disabled'
}

/**
 * 
 * @export
 * @interface FlowApiSchemasV2ModulesAgentsAgentsModuleSpec
 */
export interface FlowApiSchemasV2ModulesAgentsAgentsModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {ModuleStatus}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleSpec
     */
    'status': ModuleStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleSpec
     */
    'stack_name': string;
    /**
     * 
     * @type {FlowApiSchemasV2ModulesAgentsAgentsModuleConfig}
     * @memberof FlowApiSchemasV2ModulesAgentsAgentsModuleSpec
     */
    'config': FlowApiSchemasV2ModulesAgentsAgentsModuleConfig;
}


/**
 * 
 * @export
 * @interface FlowApiSchemasV2ModulesFilesFilesModuleConfig
 */
export interface FlowApiSchemasV2ModulesFilesFilesModuleConfig {
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'test_files_module_parameter'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'use_cf_stack_refactor'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'provisioned_concurrency_files'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'memory_files_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'timeout_files_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'throttling_rate_limit_files'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleConfig
     */
    'throttling_burst_rate_limit_files'?: number;
}
/**
 * 
 * @export
 * @interface FlowApiSchemasV2ModulesFilesFilesModuleSpec
 */
export interface FlowApiSchemasV2ModulesFilesFilesModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {ModuleStatus}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleSpec
     */
    'status': ModuleStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleSpec
     */
    'stack_name': string;
    /**
     * 
     * @type {FlowApiSchemasV2ModulesFilesFilesModuleConfig}
     * @memberof FlowApiSchemasV2ModulesFilesFilesModuleSpec
     */
    'config': FlowApiSchemasV2ModulesFilesFilesModuleConfig;
}


/**
 * Configuration for the Agents module.
 * @export
 * @interface FlowApiSchemasV3ModulesAgentsAgentsModuleConfig
 */
export interface FlowApiSchemasV3ModulesAgentsAgentsModuleConfig {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleConfig
     */
    'agent_management_memory_mb'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleConfig
     */
    'agent_management_snap_start_mode'?: FlowApiSchemasV3ModulesAgentsAgentsModuleConfigAgentManagementSnapStartModeEnum;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleConfig
     */
    'agent_management_provisioned_concurrency'?: any;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowApiSchemasV3ModulesAgentsAgentsModuleConfigAgentManagementSnapStartModeEnum {
    INHERIT = 'inherit',
    ENABLED = 'enabled',
    DISABLED = 'disabled'
}

/**
 * Full specification for the Agents module (API response).
 * @export
 * @interface FlowApiSchemasV3ModulesAgentsAgentsModuleSpec
 */
export interface FlowApiSchemasV3ModulesAgentsAgentsModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleSpec
     */
    'kind'?: FlowApiSchemasV3ModulesAgentsAgentsModuleSpecKindEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {boolean}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleSpec
     */
    'is_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleSpec
     */
    'profile_level': number;
    /**
     * 
     * @type {FlowApiSchemasV3ModulesAgentsAgentsModuleConfig}
     * @memberof FlowApiSchemasV3ModulesAgentsAgentsModuleSpec
     */
    'config': FlowApiSchemasV3ModulesAgentsAgentsModuleConfig;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowApiSchemasV3ModulesAgentsAgentsModuleSpecKindEnum {
    AGENTS = 'agents'
}

/**
 * Configuration for the Files module.
 * @export
 * @interface FlowApiSchemasV3ModulesFilesFilesModuleConfig
 */
export interface FlowApiSchemasV3ModulesFilesFilesModuleConfig {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'test_files_module_parameter'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'use_cf_stack_refactor'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'provisioned_concurrency_files'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'memory_files_mb'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'timeout_files_s'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'throttling_rate_limit_files'?: any;
    /**
     * 
     * @type {any}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleConfig
     */
    'throttling_burst_rate_limit_files'?: any;
}
/**
 * Full specification for the Files module (API response).
 * @export
 * @interface FlowApiSchemasV3ModulesFilesFilesModuleSpec
 */
export interface FlowApiSchemasV3ModulesFilesFilesModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleSpec
     */
    'kind'?: FlowApiSchemasV3ModulesFilesFilesModuleSpecKindEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {boolean}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleSpec
     */
    'is_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleSpec
     */
    'profile_level': number;
    /**
     * 
     * @type {FlowApiSchemasV3ModulesFilesFilesModuleConfig}
     * @memberof FlowApiSchemasV3ModulesFilesFilesModuleSpec
     */
    'config': FlowApiSchemasV3ModulesFilesFilesModuleConfig;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowApiSchemasV3ModulesFilesFilesModuleSpecKindEnum {
    FILES = 'files'
}

/**
 * 
 * @export
 * @interface FlowCreatePopulated
 */
export interface FlowCreatePopulated {
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowCreatePopulated
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowCreatePopulated
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowCreatePopulated
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowCreatePopulated
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowCreatePopulated
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowCreatePopulated
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowCreatePopulated
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowCreatePopulated
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowCreatePopulated
     */
    'initial_version_name'?: string;
    /**
     * 
     * @type {object}
     * @memberof FlowCreatePopulated
     */
    'initial_version_meta'?: object;
}
/**
 * 
 * @export
 * @interface FlowDb
 */
export interface FlowDb {
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDb
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDb
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDb
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDb
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDb
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {FlowTrafficPolicy}
     * @memberof FlowDb
     */
    'active_traffic_policy'?: FlowTrafficPolicy;
    /**
     * 
     * @type {Array<FlowVersionDb>}
     * @memberof FlowDb
     */
    'versions'?: Array<FlowVersionDb>;
    /**
     * 
     * @type {Array<FlowTrafficPolicy>}
     * @memberof FlowDb
     */
    'traffic_policies'?: Array<FlowTrafficPolicy>;
}
/**
 * Response model for flow with active traffic policy. Consumed by router lambda to fetch only the necessary information for routing.
 * @export
 * @interface FlowDbActivePolicySummary
 */
export interface FlowDbActivePolicySummary {
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDbActivePolicySummary
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDbActivePolicySummary
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDbActivePolicySummary
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDbActivePolicySummary
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDbActivePolicySummary
     */
    'id': string;
    /**
     * 
     * @type {Array<FlowVersionDbShallow>}
     * @memberof FlowDbActivePolicySummary
     */
    'versions'?: Array<FlowVersionDbShallow>;
    /**
     * 
     * @type {FlowTrafficPolicy}
     * @memberof FlowDbActivePolicySummary
     */
    'active_traffic_policy': FlowTrafficPolicy;
}
/**
 * 
 * @export
 * @interface FlowDbDataplane
 */
export interface FlowDbDataplane {
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDbDataplane
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDbDataplane
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDbDataplane
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDbDataplane
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbDataplane
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {Array<FlowVersionDbDataplane>}
     * @memberof FlowDbDataplane
     */
    'versions'?: Array<FlowVersionDbDataplane>;
    /**
     * 
     * @type {FlowTrafficPolicy}
     * @memberof FlowDbDataplane
     */
    'active_traffic_policy'?: FlowTrafficPolicy;
}
/**
 * 
 * @export
 * @interface FlowDbShallow
 */
export interface FlowDbShallow {
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDbShallow
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDbShallow
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDbShallow
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDbShallow
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallow
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {Array<FlowVersionDbShallow>}
     * @memberof FlowDbShallow
     */
    'versions'?: Array<FlowVersionDbShallow>;
    /**
     * 
     * @type {Array<FlowTrafficPolicy>}
     * @memberof FlowDbShallow
     */
    'traffic_policies'?: Array<FlowTrafficPolicy>;
    /**
     * 
     * @type {FlowTrafficPolicy}
     * @memberof FlowDbShallow
     */
    'active_traffic_policy'?: FlowTrafficPolicy;
    /**
     * 
     * @type {Array<FlowDbShallowVersionNoPolicy>}
     * @memberof FlowDbShallow
     */
    'child_flows'?: Array<FlowDbShallowVersionNoPolicy>;
    /**
     * 
     * @type {Array<FlowDbShallowVersionNoPolicy>}
     * @memberof FlowDbShallow
     */
    'parent_flows'?: Array<FlowDbShallowVersionNoPolicy>;
}
/**
 * 
 * @export
 * @interface FlowDbShallowNoTrafficPolicies
 */
export interface FlowDbShallowNoTrafficPolicies {
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {Array<FlowVersionDbShallow>}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'versions'?: Array<FlowVersionDbShallow>;
    /**
     * 
     * @type {Array<FlowDbShallowVersionNoPolicy>}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'child_flows'?: Array<FlowDbShallowVersionNoPolicy>;
    /**
     * 
     * @type {Array<FlowDbShallowVersionNoPolicy>}
     * @memberof FlowDbShallowNoTrafficPolicies
     */
    'parent_flows'?: Array<FlowDbShallowVersionNoPolicy>;
}
/**
 * 
 * @export
 * @interface FlowDbShallowSansLinkedFlows
 */
export interface FlowDbShallowSansLinkedFlows {
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'review_configuration': FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {Array<FlowVersionDbShallowChildren>}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'versions'?: Array<FlowVersionDbShallowChildren>;
    /**
     * 
     * @type {Array<FlowTrafficPolicy>}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'traffic_policies'?: Array<FlowTrafficPolicy>;
    /**
     * 
     * @type {FlowTrafficPolicy}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'active_traffic_policy'?: FlowTrafficPolicy;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'ui_default_decision_fields_exclude': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'ui_default_inputs_include': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'ui_default_outputs_include': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowDbShallowSansLinkedFlows
     */
    'ui_default_outcomes_include': Array<string>;
}
/**
 * 
 * @export
 * @interface FlowDbShallowVersionNoPolicy
 */
export interface FlowDbShallowVersionNoPolicy {
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {Array<FlowVersionDbShallow>}
     * @memberof FlowDbShallowVersionNoPolicy
     */
    'versions'?: Array<FlowVersionDbShallow>;
}
/**
 * 
 * @export
 * @interface FlowDuplicate
 */
export interface FlowDuplicate {
    /**
     * 
     * @type {string}
     * @memberof FlowDuplicate
     */
    'new_name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDuplicate
     */
    'new_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowDuplicate
     */
    'target_workspace_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowDuplicate
     */
    'flow_version_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FlowDuplicate
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FlowDuplicate
     */
    'copy_comments'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FlowDuplicate
     */
    'list_datasets'?: boolean;
    /**
     * 
     * @type {{ [key: string]: FlowNaming; }}
     * @memberof FlowDuplicate
     */
    'child_flow_namings'?: { [key: string]: FlowNaming; };
    /**
     * 
     * @type {string}
     * @memberof FlowDuplicate
     */
    'created_by_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowDuplicate
     */
    'created_by'?: string;
}
/**
 * 
 * @export
 * @interface FlowFolderCreate
 */
export interface FlowFolderCreate {
    /**
     * 
     * @type {string}
     * @memberof FlowFolderCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderCreate
     */
    'workspace_id': string;
}
/**
 * 
 * @export
 * @interface FlowFolderDb
 */
export interface FlowFolderDb {
    /**
     * 
     * @type {string}
     * @memberof FlowFolderDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderDb
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderDb
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderDb
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderDb
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface FlowFolderListItem
 */
export interface FlowFolderListItem {
    /**
     * 
     * @type {string}
     * @memberof FlowFolderListItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderListItem
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderListItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderListItem
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowFolderListItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof FlowFolderListItem
     */
    'flow_count': number;
}
/**
 * 
 * @export
 * @interface FlowFolderListResponse
 */
export interface FlowFolderListResponse {
    /**
     * 
     * @type {Array<FlowFolderListItem>}
     * @memberof FlowFolderListResponse
     */
    'folders': Array<FlowFolderListItem>;
    /**
     * 
     * @type {number}
     * @memberof FlowFolderListResponse
     */
    'flows_outside_folders_count': number;
}
/**
 * 
 * @export
 * @interface FlowFolderUpdate
 */
export interface FlowFolderUpdate {
    /**
     * 
     * @type {string}
     * @memberof FlowFolderUpdate
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface FlowLoopMeta
 */
export interface FlowLoopMeta {
    /**
     * 
     * @type {string}
     * @memberof FlowLoopMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopMeta
     */
    'child_flow_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopMeta
     */
    'child_flow_slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopMeta
     */
    'child_flow_version_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopMeta
     */
    'child_flow_version_known_etag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FlowLoopMeta
     */
    'is_stale'?: boolean;
    /**
     * 
     * @type {{ [key: string]: FieldMapping; }}
     * @memberof FlowLoopMeta
     */
    'input_mappings': { [key: string]: FieldMapping; };
    /**
     * 
     * @type {BaseInputField}
     * @memberof FlowLoopMeta
     */
    'target_list_expression': BaseInputField;
    /**
     * 
     * @type {BaseInputField}
     * @memberof FlowLoopMeta
     */
    'output_destination_list_expression': BaseInputField;
    /**
     * 
     * @type {BreakLoop}
     * @memberof FlowLoopMeta
     */
    'break_condition': BreakLoop;
}
/**
 * 
 * @export
 * @interface FlowMeta
 */
export interface FlowMeta {
    /**
     * 
     * @type {string}
     * @memberof FlowMeta
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowMeta
     */
    'updated_by_id'?: string;
}
/**
 * 
 * @export
 * @interface FlowNaming
 */
export interface FlowNaming {
    /**
     * 
     * @type {string}
     * @memberof FlowNaming
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowNaming
     */
    'slug': string;
}
/**
 * 
 * @export
 * @interface FlowNodeMeta
 */
export interface FlowNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof FlowNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNodeMeta
     */
    'child_flow_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNodeMeta
     */
    'child_flow_slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNodeMeta
     */
    'child_flow_version_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNodeMeta
     */
    'child_flow_version_known_etag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FlowNodeMeta
     */
    'is_stale'?: boolean;
    /**
     * 
     * @type {{ [key: string]: FieldMapping; }}
     * @memberof FlowNodeMeta
     */
    'input_mappings': { [key: string]: FieldMapping; };
    /**
     * 
     * @type {{ [key: string]: FieldMapping; }}
     * @memberof FlowNodeMeta
     */
    'output_mappings': { [key: string]: FieldMapping; };
}
/**
 * 
 * @export
 * @interface FlowReviewConfiguration
 */
export interface FlowReviewConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof FlowReviewConfiguration
     */
    'requires_review'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FlowReviewConfiguration
     */
    'requires_independent_review'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FlowReviewConfiguration
     */
    'require_all_reviewers'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowReviewConfiguration
     */
    'default_reviewer_list'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FlowTags
 */
export interface FlowTags {
    /**
     * 
     * @type {string}
     * @memberof FlowTags
     */
    'type'?: FlowTagsTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowTagsTypeEnum {
    CASE_FLOW = 'case_flow'
}

/**
 * 
 * @export
 * @interface FlowTestRunConfiguration
 */
export interface FlowTestRunConfiguration {
    /**
     * 
     * @type {number}
     * @memberof FlowTestRunConfiguration
     */
    'worker_count'?: number;
}
/**
 * 
 * @export
 * @interface FlowTrafficPolicy
 */
export interface FlowTrafficPolicy {
    /**
     * 
     * @type {string}
     * @memberof FlowTrafficPolicy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowTrafficPolicy
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowTrafficPolicy
     */
    'created_by_user_id': string;
    /**
     * 
     * @type {ProbabilisticPolicy}
     * @memberof FlowTrafficPolicy
     */
    'policy': ProbabilisticPolicy;
}
/**
 * 
 * @export
 * @interface FlowTrafficPolicyProbabilisticVersionEntry
 */
export interface FlowTrafficPolicyProbabilisticVersionEntry {
    /**
     * 
     * @type {string}
     * @memberof FlowTrafficPolicyProbabilisticVersionEntry
     */
    'flow_version_id': string;
    /**
     * 
     * @type {number}
     * @memberof FlowTrafficPolicyProbabilisticVersionEntry
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface FlowUpdate
 */
export interface FlowUpdate {
    /**
     * 
     * @type {FlowMeta}
     * @memberof FlowUpdate
     */
    'meta'?: FlowMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowUpdate
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowUpdate
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowUpdate
     */
    'workspace_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowUpdate
     */
    'flow_folder_id'?: string;
    /**
     * 
     * @type {FlowTags}
     * @memberof FlowUpdate
     */
    'tags'?: FlowTags;
    /**
     * 
     * @type {string}
     * @memberof FlowUpdate
     */
    'default_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowUpdate
     */
    'default_sandbox_version'?: string;
    /**
     * 
     * @type {FlowReviewConfiguration}
     * @memberof FlowUpdate
     */
    'review_configuration'?: FlowReviewConfiguration;
    /**
     * 
     * @type {FlowTestRunConfiguration}
     * @memberof FlowUpdate
     */
    'test_run_configuration'?: FlowTestRunConfiguration;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowUpdate
     */
    'ui_default_decision_fields_exclude'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowUpdate
     */
    'ui_default_inputs_include'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowUpdate
     */
    'ui_default_outputs_include'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowUpdate
     */
    'ui_default_outcomes_include'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FlowVersionContributors
 */
export interface FlowVersionContributors {
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowVersionContributors
     */
    'contributor_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface FlowVersionCreate
 */
export interface FlowVersionCreate {
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionCreate
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionCreate
     */
    'etag'?: string;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionCreate
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionCreate
     */
    'output_schema'?: object;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof FlowVersionCreate
     */
    'parameters'?: Array<Parameter>;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionCreate
     */
    'flow_id': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionCreate
     */
    'status'?: FlowVersionStatus;
}


/**
 * 
 * @export
 * @interface FlowVersionDb
 */
export interface FlowVersionDb {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDb
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionDb
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDb
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDb
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDb
     */
    'graph_id'?: string;
    /**
     * 
     * @type {GraphDb}
     * @memberof FlowVersionDb
     */
    'graph'?: GraphDb;
    /**
     * 
     * @type {Array<ResourceLock>}
     * @memberof FlowVersionDb
     */
    'locks'?: Array<ResourceLock>;
    /**
     * 
     * @type {Array<FlowVersionDbShallowWithSchemas>}
     * @memberof FlowVersionDb
     */
    'child_versions'?: Array<FlowVersionDbShallowWithSchemas>;
    /**
     * 
     * @type {Array<FlowVersionDbShallowWithSchemas>}
     * @memberof FlowVersionDb
     */
    'parent_versions'?: Array<FlowVersionDbShallowWithSchemas>;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDb
     */
    'etag'?: string;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDb
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDb
     */
    'output_schema'?: object;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof FlowVersionDb
     */
    'parameters'?: Array<Parameter>;
}


/**
 * 
 * @export
 * @interface FlowVersionDbDataplane
 */
export interface FlowVersionDbDataplane {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionDbDataplane
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDbDataplane
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'api_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbDataplane
     */
    'graph_id'?: string;
    /**
     * 
     * @type {GraphDbDataplane}
     * @memberof FlowVersionDbDataplane
     */
    'graph'?: GraphDbDataplane;
    /**
     * 
     * @type {Array<FlowVersionDbDataplane>}
     * @memberof FlowVersionDbDataplane
     */
    'child_versions'?: Array<FlowVersionDbDataplane>;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbDataplane
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbDataplane
     */
    'output_schema'?: object;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof FlowVersionDbDataplane
     */
    'parameters'?: Array<Parameter>;
}


/**
 * 
 * @export
 * @interface FlowVersionDbShallow
 */
export interface FlowVersionDbShallow {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallow
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallow
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionDbShallow
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallow
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallow
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDbShallow
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallow
     */
    'api_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallow
     */
    'etag'?: string;
    /**
     * 
     * @type {ReviewShallow}
     * @memberof FlowVersionDbShallow
     */
    'review'?: ReviewShallow;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbShallow
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbShallow
     */
    'output_schema'?: object;
}


/**
 * 
 * @export
 * @interface FlowVersionDbShallowChildren
 */
export interface FlowVersionDbShallowChildren {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowChildren
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowChildren
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionDbShallowChildren
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowChildren
     */
    'etag'?: string;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbShallowChildren
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbShallowChildren
     */
    'output_schema'?: object;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof FlowVersionDbShallowChildren
     */
    'parameters'?: Array<Parameter>;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowChildren
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowChildren
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDbShallowChildren
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowChildren
     */
    'api_version'?: string;
    /**
     * 
     * @type {Array<FlowDbShallow>}
     * @memberof FlowVersionDbShallowChildren
     */
    'child_flows'?: Array<FlowDbShallow>;
    /**
     * 
     * @type {Array<FlowDbShallow>}
     * @memberof FlowVersionDbShallowChildren
     */
    'parent_flows'?: Array<FlowDbShallow>;
    /**
     * 
     * @type {ReviewShallow}
     * @memberof FlowVersionDbShallowChildren
     */
    'review'?: ReviewShallow;
}


/**
 * 
 * @export
 * @interface FlowVersionDbShallowWithSchemas
 */
export interface FlowVersionDbShallowWithSchemas {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'api_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'etag'?: string;
    /**
     * 
     * @type {ReviewShallow}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'review'?: ReviewShallow;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionDbShallowWithSchemas
     */
    'output_schema'?: object;
}


/**
 * 
 * @export
 * @interface FlowVersionDuplicate
 */
export interface FlowVersionDuplicate {
    /**
     * 
     * @type {Meta}
     * @memberof FlowVersionDuplicate
     */
    'meta'?: Meta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDuplicate
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDuplicate
     */
    'status'?: FlowVersionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FlowVersionDuplicate
     */
    'include_comments'?: boolean;
}


/**
 * 
 * @export
 * @interface FlowVersionDuplicateNewFlow
 */
export interface FlowVersionDuplicateNewFlow {
    /**
     * 
     * @type {Meta}
     * @memberof FlowVersionDuplicateNewFlow
     */
    'meta'?: Meta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDuplicateNewFlow
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionDuplicateNewFlow
     */
    'status'?: FlowVersionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FlowVersionDuplicateNewFlow
     */
    'include_comments'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionDuplicateNewFlow
     */
    'flow_id': string;
}


/**
 * 
 * @export
 * @interface FlowVersionMeta
 */
export interface FlowVersionMeta {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'created_by_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'published_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'published_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'published_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'published_by_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'release_note'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'created_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'archived_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'archived_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'archived_by_avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionMeta
     */
    'archived_at'?: string;
    /**
     * 
     * @type {{ [key: string]: SimulationMeta; }}
     * @memberof FlowVersionMeta
     */
    'simulations'?: { [key: string]: SimulationMeta; };
}
/**
 * States of a flow version status
 * @export
 * @enum {string}
 */

export enum FlowVersionStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    ARCHIVED = 'ARCHIVED'
}


/**
 * 
 * @export
 * @interface FlowVersionUpdate
 */
export interface FlowVersionUpdate {
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionUpdate
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionUpdate
     */
    'etag'?: string;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionUpdate
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionUpdate
     */
    'output_schema'?: object;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof FlowVersionUpdate
     */
    'parameters'?: Array<Parameter>;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionUpdate
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionUpdate
     */
    'graph_id'?: string;
    /**
     * 
     * @type {GraphMergePatch}
     * @memberof FlowVersionUpdate
     */
    'graph'?: GraphMergePatch;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionUpdate
     */
    'status'?: FlowVersionStatus;
    /**
     * 
     * @type {{ [key: string]: ResourceLockUpsert; }}
     * @memberof FlowVersionUpdate
     */
    'locks'?: { [key: string]: ResourceLockUpsert; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FlowVersionUpdate
     */
    'deleted_nodes_names'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FlowVersionUpdate
     */
    'deleted_nodegroups_names'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof FlowVersionUpdate
     */
    'operation'?: number;
}


/**
 * 
 * @export
 * @interface FlowVersionV2
 */
export interface FlowVersionV2 {
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'updated_at': string;
    /**
     * 
     * @type {FlowVersionMeta}
     * @memberof FlowVersionV2
     */
    'meta'?: FlowVersionMeta;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'name': string;
    /**
     * 
     * @type {FlowVersionStatus}
     * @memberof FlowVersionV2
     */
    'status': FlowVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'api_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'etag': string;
    /**
     * 
     * @type {ReviewShallow}
     * @memberof FlowVersionV2
     */
    'review'?: ReviewShallow;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionV2
     */
    'input_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof FlowVersionV2
     */
    'output_schema'?: object;
    /**
     * 
     * @type {string}
     * @memberof FlowVersionV2
     */
    'graph_id'?: string;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof FlowVersionV2
     */
    'parameters': Array<Parameter>;
    /**
     * 
     * @type {GraphV2}
     * @memberof FlowVersionV2
     */
    'graph': GraphV2;
    /**
     * 
     * @type {Array<ResourceLock>}
     * @memberof FlowVersionV2
     */
    'locks': Array<ResourceLock>;
    /**
     * 
     * @type {number}
     * @memberof FlowVersionV2
     */
    'operation'?: number;
}


/**
 * 
 * @export
 * @interface GraphDb
 */
export interface GraphDb {
    /**
     * 
     * @type {string}
     * @memberof GraphDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GraphDb
     */
    'updated_at': string;
    /**
     * 
     * @type {GraphMeta}
     * @memberof GraphDb
     */
    'meta'?: GraphMeta;
    /**
     * 
     * @type {string}
     * @memberof GraphDb
     */
    'id': string;
    /**
     * 
     * @type {Array<NodeDb>}
     * @memberof GraphDb
     */
    'nodes'?: Array<NodeDb>;
    /**
     * 
     * @type {Array<EdgeDb>}
     * @memberof GraphDb
     */
    'edges'?: Array<EdgeDb>;
    /**
     * 
     * @type {Array<NodeGroupDb>}
     * @memberof GraphDb
     */
    'node_groups'?: Array<NodeGroupDb>;
}
/**
 * 
 * @export
 * @interface GraphDbDataplane
 */
export interface GraphDbDataplane {
    /**
     * 
     * @type {string}
     * @memberof GraphDbDataplane
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GraphDbDataplane
     */
    'updated_at': string;
    /**
     * 
     * @type {GraphMeta}
     * @memberof GraphDbDataplane
     */
    'meta'?: GraphMeta;
    /**
     * 
     * @type {string}
     * @memberof GraphDbDataplane
     */
    'id': string;
    /**
     * 
     * @type {Array<NodeDb>}
     * @memberof GraphDbDataplane
     */
    'nodes'?: Array<NodeDb>;
    /**
     * 
     * @type {Array<EdgeDb>}
     * @memberof GraphDbDataplane
     */
    'edges'?: Array<EdgeDb>;
}
/**
 * 
 * @export
 * @interface GraphMergePatch
 */
export interface GraphMergePatch {
    /**
     * 
     * @type {{ [key: string]: NodeUpsert; }}
     * @memberof GraphMergePatch
     */
    'nodes'?: { [key: string]: NodeUpsert; };
    /**
     * 
     * @type {{ [key: string]: EdgeUpsert; }}
     * @memberof GraphMergePatch
     */
    'edges'?: { [key: string]: EdgeUpsert; };
    /**
     * 
     * @type {{ [key: string]: NodeGroupUpsert; }}
     * @memberof GraphMergePatch
     */
    'node_groups'?: { [key: string]: NodeGroupUpsert; };
}
/**
 * 
 * @export
 * @interface GraphMeta
 */
export interface GraphMeta {
    /**
     * 
     * @type {string}
     * @memberof GraphMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GraphMeta
     */
    'updated_by_id'?: string;
}
/**
 * 
 * @export
 * @interface GraphV2
 */
export interface GraphV2 {
    /**
     * 
     * @type {{ [key: string]: NodeDb; }}
     * @memberof GraphV2
     */
    'nodes': { [key: string]: NodeDb; };
    /**
     * 
     * @type {{ [key: string]: EdgeDb; }}
     * @memberof GraphV2
     */
    'edges': { [key: string]: EdgeDb; };
    /**
     * 
     * @type {{ [key: string]: NodeGroupDb; }}
     * @memberof GraphV2
     */
    'node_groups': { [key: string]: NodeGroupDb; };
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum HistoryMode {
    AURORA_READ_AURORA = 'write_aurora_read_aurora',
    BOTH_READ_AURORA = 'write_both_read_aurora',
    BOTH_READ_BOTH = 'write_both_read_both',
    ICEBERG_READ_BOTH = 'write_iceberg_read_both',
    ICEBERG_READ_ICEBERG = 'write_iceberg_read_iceberg'
}


/**
 * 
 * @export
 * @interface HistoryModuleConfig
 */
export interface HistoryModuleConfig {
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'memory_batch_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'memory_reader_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'memory_exporter_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'timeout_batch_archiver_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'timeout_reader_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'timeout_exporter_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'bytes_scanned_cutoff_per_query'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryModuleConfig
     */
    'enable_iceberg_maintenance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryModuleConfig
     */
    'use_jvm_iceberg_committer'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'batch_archiver_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'batch_archiver_commit_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'batch_archiver_commit_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'extraction_budget_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfig
     */
    'disk_batch_archiver_mb'?: number;
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleConfig
     */
    'stack_suffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleConfig
     */
    'dh_v2_available_after_iso_8601_date'?: string;
}
/**
 * 
 * @export
 * @interface HistoryModuleConfigUpdate
 */
export interface HistoryModuleConfigUpdate {
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'memory_batch_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'memory_reader_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'memory_exporter_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'timeout_batch_archiver_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'timeout_reader_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'timeout_exporter_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'bytes_scanned_cutoff_per_query'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryModuleConfigUpdate
     */
    'enable_iceberg_maintenance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryModuleConfigUpdate
     */
    'use_jvm_iceberg_committer'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'batch_archiver_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'batch_archiver_commit_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'batch_archiver_commit_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'extraction_budget_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryModuleConfigUpdate
     */
    'disk_batch_archiver_mb'?: number;
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleConfigUpdate
     */
    'stack_suffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleConfigUpdate
     */
    'dh_v2_available_after_iso_8601_date'?: string;
}
/**
 * 
 * @export
 * @interface HistoryModuleCreateRequest
 */
export interface HistoryModuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleCreateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {HistoryModuleConfig}
     * @memberof HistoryModuleCreateRequest
     */
    'config'?: HistoryModuleConfig;
}
/**
 * 
 * @export
 * @interface HistoryModuleSpec
 */
export interface HistoryModuleSpec {
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleSpec
     */
    'version': string;
    /**
     * 
     * @type {ModuleStatus}
     * @memberof HistoryModuleSpec
     */
    'status': ModuleStatus;
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleSpec
     */
    'stack_name': string;
    /**
     * 
     * @type {HistoryModuleConfig}
     * @memberof HistoryModuleSpec
     */
    'config': HistoryModuleConfig;
}


/**
 * 
 * @export
 * @interface HistoryModuleUpdateRequest
 */
export interface HistoryModuleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof HistoryModuleUpdateRequest
     */
    'version'?: string;
    /**
     * 
     * @type {HistoryModuleConfigUpdate}
     * @memberof HistoryModuleUpdateRequest
     */
    'config'?: HistoryModuleConfigUpdate;
}
/**
 * 
 * @export
 * @interface InputAttribute
 */
export interface InputAttribute {
    /**
     * 
     * @type {string}
     * @memberof InputAttribute
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InputAttribute
     */
    'expression': string;
}
/**
 * 
 * @export
 * @interface IntegrationNodeMeta
 */
export interface IntegrationNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof IntegrationNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof IntegrationNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof IntegrationNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationNodeMeta
     */
    'media_key'?: string;
    /**
     * 
     * @type {object}
     * @memberof IntegrationNodeMeta
     */
    'config': object;
    /**
     * 
     * @type {object}
     * @memberof IntegrationNodeMeta
     */
    'input': object;
    /**
     * 
     * @type {object}
     * @memberof IntegrationNodeMeta
     */
    'output': object;
    /**
     * 
     * @type {object}
     * @memberof IntegrationNodeMeta
     */
    'files'?: object;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum JobRunEventAttributeStatus {
    COMPLETED = 'completed',
    FAILED = 'failed',
    HISTORY_COMPLETE = 'history_complete'
}


/**
 * 
 * @export
 * @interface JobsConfig
 */
export interface JobsConfig {
    /**
     * 
     * @type {number}
     * @memberof JobsConfig
     */
    'max_concurrency_limit': number;
    /**
     * 
     * @type {number}
     * @memberof JobsConfig
     */
    'async_concurrency_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobsConfig
     */
    's3_bucket_dataset_max_rows'?: number;
    /**
     * 
     * @type {number}
     * @memberof JobsConfig
     */
    's3_bucket_dataset_max_bytes'?: number;
}
/**
 * Represents an error object in JSON:API format.
 * @export
 * @interface JsonApiError
 */
export interface JsonApiError {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof JsonApiError
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiError
     */
    'status': any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiError
     */
    'title': any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiError
     */
    'detail'?: any;
    /**
     * 
     * @type {JsonApiErrorSource}
     * @memberof JsonApiError
     */
    'source'?: JsonApiErrorSource;
}
/**
 * A JSON:API compliant error response.
 * @export
 * @interface JsonApiErrorResponse
 */
export interface JsonApiErrorResponse {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof JsonApiErrorResponse
     */
    'errors': any;
}
/**
 * An object containing references to the source of the error.
 * @export
 * @interface JsonApiErrorSource
 */
export interface JsonApiErrorSource {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof JsonApiErrorSource
     */
    'pointer'?: any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiErrorSource
     */
    'parameter'?: any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiErrorSource
     */
    'header'?: any;
}
/**
 * Resource identifier object
 * @export
 * @interface JsonApiIdentifier
 */
export interface JsonApiIdentifier {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof JsonApiIdentifier
     */
    'type': any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiIdentifier
     */
    'id'?: any;
    /**
     * 
     * @type {any}
     * @memberof JsonApiIdentifier
     */
    'lid'?: any;
}
/**
 * A relationship object.
 * @export
 * @interface JsonApiRelationship
 */
export interface JsonApiRelationship {
    [key: string]: any;

    /**
     * 
     * @type {Data1}
     * @memberof JsonApiRelationship
     */
    'data'?: Data1;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum Junctions {
    AND = 'and',
    OR = 'or'
}


/**
 * 
 * @export
 * @interface KeyValuePair
 */
export interface KeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof KeyValuePair
     */
    'id_key': string;
    /**
     * 
     * @type {string}
     * @memberof KeyValuePair
     */
    'id_value': string;
    /**
     * 
     * @type {string}
     * @memberof KeyValuePair
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof KeyValuePair
     */
    'value': string;
}
/**
 * Body value for the key_values input.
 * @export
 * @interface KeyValuesBodyField
 */
export interface KeyValuesBodyField {
    /**
     * 
     * @type {string}
     * @memberof KeyValuesBodyField
     */
    'selected': KeyValuesBodyFieldSelectedEnum;
    /**
     * 
     * @type {Array<KeyValuePair>}
     * @memberof KeyValuesBodyField
     */
    'key_values': Array<KeyValuePair>;
}

/**
    * @export
    * @enum {string}
    */
export enum KeyValuesBodyFieldSelectedEnum {
    KEY_VALUES = 'key_values'
}

/**
 * 
 * @export
 * @interface MLNodeMeta
 */
export interface MLNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'src': string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'model_filename': string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'model_id': string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'graph_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'producer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof MLNodeMeta
     */
    'training_data'?: string;
    /**
     * 
     * @type {Array<MLNodeTensor>}
     * @memberof MLNodeMeta
     */
    'inputs'?: Array<MLNodeTensor>;
    /**
     * 
     * @type {Array<MLNodeTensor>}
     * @memberof MLNodeMeta
     */
    'outputs'?: Array<MLNodeTensor>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MLNodeMeta
     */
    'custom_metadata'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface MLNodeTensor
 */
export interface MLNodeTensor {
    /**
     * 
     * @type {string}
     * @memberof MLNodeTensor
     */
    'name': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MLNodeTensor
     */
    'shape': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof MLNodeTensor
     */
    'dtype': string;
}
/**
 * 
 * @export
 * @interface ManifestConnectionNodeMeta
 */
export interface ManifestConnectionNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof ManifestConnectionNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManifestConnectionNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {ManifestProviderResource}
     * @memberof ManifestConnectionNodeMeta
     */
    'provider_resource': ManifestProviderResource;
    /**
     * 
     * @type {string}
     * @memberof ManifestConnectionNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof ManifestConnectionNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {string}
     * @memberof ManifestConnectionNodeMeta
     */
    'media_key'?: string;
    /**
     * 
     * @type {object}
     * @memberof ManifestConnectionNodeMeta
     */
    'config': object;
    /**
     * 
     * @type {object}
     * @memberof ManifestConnectionNodeMeta
     */
    'input': object;
    /**
     * 
     * @type {object}
     * @memberof ManifestConnectionNodeMeta
     */
    'output': object;
    /**
     * 
     * @type {object}
     * @memberof ManifestConnectionNodeMeta
     */
    'files'?: object;
}
/**
 * 
 * @export
 * @interface ManifestProviderResource
 */
export interface ManifestProviderResource {
    /**
     * 
     * @type {string}
     * @memberof ManifestProviderResource
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof ManifestProviderResource
     */
    'resource': string;
    /**
     * 
     * @type {string}
     * @memberof ManifestProviderResource
     */
    'manifest_version': string;
}
/**
 * 
 * @export
 * @interface ManualReviewDescription
 */
export interface ManualReviewDescription {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewDescription
     */
    'type': ManualReviewDescriptionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewDescription
     */
    'id_value': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewDescription
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualReviewDescriptionTypeEnum {
    DESCRIPTION = 'description'
}

/**
 * 
 * @export
 * @interface ManualReviewDivider
 */
export interface ManualReviewDivider {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewDivider
     */
    'type': ManualReviewDividerTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualReviewDividerTypeEnum {
    DIVIDER = 'divider'
}

/**
 * 
 * @export
 * @interface ManualReviewField
 */
export interface ManualReviewField {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewField
     */
    'type': ManualReviewFieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewField
     */
    'id_readable_name': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewField
     */
    'id_value': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewField
     */
    'readable_name': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewField
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualReviewFieldTypeEnum {
    FIELD = 'field'
}

/**
 * 
 * @export
 * @interface ManualReviewFile
 */
export interface ManualReviewFile {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewFile
     */
    'type': ManualReviewFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewFile
     */
    'id_value': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewFile
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualReviewFileTypeEnum {
    FILE = 'file'
}

/**
 * Connect Manual Review Node Meta.
 * @export
 * @interface ManualReviewNodeMeta
 */
export interface ManualReviewNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof ManualReviewNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {Array<ManualReviewNodeMetaHighlightsInner>}
     * @memberof ManualReviewNodeMeta
     */
    'highlights': Array<ManualReviewNodeMetaHighlightsInner>;
    /**
     * 
     * @type {ManualReviewResponseForm}
     * @memberof ManualReviewNodeMeta
     */
    'response_form': ManualReviewResponseForm;
    /**
     * 
     * @type {ManualReviewReviewerAssignStrategy}
     * @memberof ManualReviewNodeMeta
     */
    'reviewer_assign_strategy'?: ManualReviewReviewerAssignStrategy;
    /**
     * 
     * @type {ReviewerAssignStrategyV2}
     * @memberof ManualReviewNodeMeta
     */
    'reviewer_assign_strategy_v2'?: ReviewerAssignStrategyV2;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewNodeMeta
     */
    'response_metadata_key'?: string;
}


/**
 * @type ManualReviewNodeMetaHighlightsInner
 * @export
 */
export type ManualReviewNodeMetaHighlightsInner = { type: 'description' } & ManualReviewDescription | { type: 'divider' } & ManualReviewDivider | { type: 'field' } & ManualReviewField | { type: 'file' } & ManualReviewFile;

/**
 * 
 * @export
 * @interface ManualReviewResponseForm
 */
export interface ManualReviewResponseForm {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewResponseForm
     */
    'description': string;
    /**
     * 
     * @type {Array<ManualReviewResponseFormField>}
     * @memberof ManualReviewResponseForm
     */
    'fields'?: Array<ManualReviewResponseFormField>;
}
/**
 * 
 * @export
 * @interface ManualReviewResponseFormField
 */
export interface ManualReviewResponseFormField {
    /**
     * 
     * @type {string}
     * @memberof ManualReviewResponseFormField
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewResponseFormField
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewResponseFormField
     */
    'type': ManualReviewResponseFormFieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ManualReviewResponseFormField
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewResponseFormField
     */
    'name': string;
    /**
     * 
     * @type {Array<ManualReviewResponseFormFieldEnumInner>}
     * @memberof ManualReviewResponseFormField
     */
    'enum'?: Array<ManualReviewResponseFormFieldEnumInner>;
    /**
     * 
     * @type {string}
     * @memberof ManualReviewResponseFormField
     */
    'display_as'?: ManualReviewResponseFormFieldDisplayAsEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualReviewResponseFormFieldTypeEnum {
    STRING = 'string',
    NUMBER = 'number',
    INTEGER = 'integer',
    BOOLEAN = 'boolean',
    ENUM = 'enum',
    FILE = 'file'
}
/**
    * @export
    * @enum {string}
    */
export enum ManualReviewResponseFormFieldDisplayAsEnum {
    INPUT = 'input',
    TEXTAREA = 'textarea'
}

/**
 * 
 * @export
 * @interface ManualReviewResponseFormFieldEnumInner
 */
export interface ManualReviewResponseFormFieldEnumInner {
}
/**
 * For backwards compatibility.
 * @export
 * @enum {string}
 */

export enum ManualReviewReviewerAssignStrategy {
    ANY = 'ANY',
    REVIEWER_ONLY = 'REVIEWER_ONLY'
}


/**
 * 
 * @export
 * @interface MatrixTableEffect
 */
export interface MatrixTableEffect {
    /**
     * 
     * @type {string}
     * @memberof MatrixTableEffect
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MatrixTableEffect
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface MatrixTableField
 */
export interface MatrixTableField {
    /**
     * 
     * @type {string}
     * @memberof MatrixTableField
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MatrixTableField
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface MatrixTableNodeMeta
 */
export interface MatrixTableNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof MatrixTableNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixTableNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {MatrixTableField}
     * @memberof MatrixTableNodeMeta
     */
    'row_field': MatrixTableField;
    /**
     * 
     * @type {MatrixTableField}
     * @memberof MatrixTableNodeMeta
     */
    'column_field': MatrixTableField;
    /**
     * 
     * @type {MatrixTableField}
     * @memberof MatrixTableNodeMeta
     */
    'result_field': MatrixTableField;
    /**
     * 
     * @type {Array<Array<MatrixTableEffect>>}
     * @memberof MatrixTableNodeMeta
     */
    'grid_effects': Array<Array<MatrixTableEffect>>;
    /**
     * 
     * @type {Array<MatrixTablePredicate>}
     * @memberof MatrixTableNodeMeta
     */
    'column_predicates': Array<MatrixTablePredicate>;
    /**
     * 
     * @type {Array<MatrixTablePredicate>}
     * @memberof MatrixTableNodeMeta
     */
    'row_predicates': Array<MatrixTablePredicate>;
    /**
     * 
     * @type {MatrixTableEffect}
     * @memberof MatrixTableNodeMeta
     */
    'fallback': MatrixTableEffect;
}
/**
 * 
 * @export
 * @interface MatrixTablePredicate
 */
export interface MatrixTablePredicate {
    /**
     * 
     * @type {string}
     * @memberof MatrixTablePredicate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MatrixTablePredicate
     */
    'value': string;
    /**
     * 
     * @type {DecisionTableOperators}
     * @memberof MatrixTablePredicate
     */
    'operator': DecisionTableOperators;
}


/**
 * 
 * @export
 * @interface MergeNodeMeta
 */
export interface MergeNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof MergeNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MergeNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MergeNodeMeta
     */
    'src': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergeNodeMeta
     */
    'is_split_merge_node': boolean;
}
/**
 * 
 * @export
 * @interface Meta
 */
export interface Meta {
}
/**
 * 
 * @export
 * @interface Meta1
 */
export interface Meta1 {
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'created_by_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'updated_by_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'entity_schema': any;
    /**
     * 
     * @type {BaseInputField}
     * @memberof Meta1
     */
    'entity_objects_expression': BaseInputField;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'properties_to_write': any;
    /**
     * 
     * @type {BaseInputField}
     * @memberof Meta1
     */
    'entity_ids_expression': BaseInputField;
    /**
     * 
     * @type {BaseInputField}
     * @memberof Meta1
     */
    'output_destination_expression': BaseInputField;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'enrich_related_data': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'type': Meta1TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'agent_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'agent_version_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'agent_version_known_etag'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'prompt': any;
    /**
     * 
     * @type {object}
     * @memberof Meta1
     */
    'files'?: object;
    /**
     * 
     * @type {{ [key: string]: FieldMapping; }}
     * @memberof Meta1
     */
    'input_mappings': { [key: string]: FieldMapping; };
    /**
     * 
     * @type {object}
     * @memberof Meta1
     */
    'response': object;
    /**
     * 
     * @type {object}
     * @memberof Meta1
     */
    'config': object;
    /**
     * 
     * @type {AiNodeModelConfig}
     * @memberof Meta1
     */
    'model': AiNodeModelConfig;
    /**
     * 
     * @type {AiNodeV2PromptConfig}
     * @memberof Meta1
     */
    'prompts': AiNodeV2PromptConfig;
    /**
     * 
     * @type {{ [key: string]: OutputAttribute; }}
     * @memberof Meta1
     */
    'insights'?: { [key: string]: OutputAttribute; };
    /**
     * 
     * @type {AiNodeV2InferenceConfig}
     * @memberof Meta1
     */
    'inference': AiNodeV2InferenceConfig;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'src': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'is_split_merge_node': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'is_split_branch_node': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'branches': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'default_edge_id': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'default_effects': any;
    /**
     * 
     * @type {DecisionTableField}
     * @memberof Meta1
     */
    'assign_field': DecisionTableField;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'extract_scores': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'equal_weights': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'factors': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'child_flow_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'child_flow_slug'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'child_flow_version_id'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'child_flow_version_known_etag'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'is_stale'?: any;
    /**
     * 
     * @type {BaseInputField}
     * @memberof Meta1
     */
    'target_list_expression': BaseInputField;
    /**
     * 
     * @type {BaseInputField}
     * @memberof Meta1
     */
    'output_destination_list_expression': BaseInputField;
    /**
     * 
     * @type {BreakLoop}
     * @memberof Meta1
     */
    'break_condition': BreakLoop;
    /**
     * 
     * @type {{ [key: string]: FieldMapping; }}
     * @memberof Meta1
     */
    'output_mappings': { [key: string]: FieldMapping; };
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'predicate_fields': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'effect_fields': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'cases': any;
    /**
     * 
     * @type {MatrixTableEffect}
     * @memberof Meta1
     */
    'fallback': MatrixTableEffect;
    /**
     * 
     * @type {MatrixTableField}
     * @memberof Meta1
     */
    'row_field': MatrixTableField;
    /**
     * 
     * @type {MatrixTableField}
     * @memberof Meta1
     */
    'column_field': MatrixTableField;
    /**
     * 
     * @type {MatrixTableField}
     * @memberof Meta1
     */
    'result_field': MatrixTableField;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'grid_effects': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'column_predicates': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'row_predicates': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'model_filename': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'model_id': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'description'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'graph_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'producer_name'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'version'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'author'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'training_data'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'inputs'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'outputs'?: any;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Meta1
     */
    'custom_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {object}
     * @memberof Meta1
     */
    'provider_resource': object;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'connection_id': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'resource_config_id': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'media_key'?: any;
    /**
     * 
     * @type {object}
     * @memberof Meta1
     */
    'input': object;
    /**
     * 
     * @type {object}
     * @memberof Meta1
     */
    'output': object;
    /**
     * 
     * @type {InputAttribute}
     * @memberof Meta1
     */
    'correlation_id': InputAttribute;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'variables': any;
    /**
     * 
     * @type {InputAttribute}
     * @memberof Meta1
     */
    'query': InputAttribute;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'verb': any;
    /**
     * 
     * @type {InputAttribute}
     * @memberof Meta1
     */
    'path': InputAttribute;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'params': any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'headers': any;
    /**
     * 
     * @type {CustomConnectionBody}
     * @memberof Meta1
     */
    'body': CustomConnectionBody;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'highlights': any;
    /**
     * 
     * @type {ManualReviewResponseForm}
     * @memberof Meta1
     */
    'response_form': ManualReviewResponseForm;
    /**
     * 
     * @type {ManualReviewReviewerAssignStrategy}
     * @memberof Meta1
     */
    'reviewer_assign_strategy'?: ManualReviewReviewerAssignStrategy;
    /**
     * 
     * @type {ReviewerAssignStrategyV2}
     * @memberof Meta1
     */
    'reviewer_assign_strategy_v2'?: ReviewerAssignStrategyV2;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'response_metadata_key'?: any;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'case_node_type'?: Meta1CaseNodeTypeEnum;
    /**
     * 
     * @type {CaseUpdateNodeMetaTemplate}
     * @memberof Meta1
     */
    'template'?: CaseUpdateNodeMetaTemplate;
    /**
     * 
     * @type {{ [key: string]: CaseCreationNodeMetaMappedValue; }}
     * @memberof Meta1
     */
    'details_mapping': { [key: string]: CaseCreationNodeMetaMappedValue; };
    /**
     * 
     * @type {CaseCreationNodeMetaAssignedQueue}
     * @memberof Meta1
     */
    'assigned_queue'?: CaseCreationNodeMetaAssignedQueue;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'case_input_location': any;
    /**
     * 
     * @type {CaseUpdateNodeMetaAdvancedSettings}
     * @memberof Meta1
     */
    'advanced_settings': CaseUpdateNodeMetaAdvancedSettings;
    /**
     * 
     * @type {any}
     * @memberof Meta1
     */
    'selections'?: any;
}

/**
    * @export
    * @enum {string}
    */
export enum Meta1TypeEnum {
    AGENT = 'agent'
}
/**
    * @export
    * @enum {string}
    */
export enum Meta1CaseNodeTypeEnum {
    UPDATE = 'update'
}

/**
 * Full module attributes for response.  - spec: The deployed state (after successful operations). Null if nothing deployed yet. - desired_spec: The target state (spec + all pending/scheduled/in-progress operations merged).
 * @export
 * @interface ModuleAttributes
 */
export interface ModuleAttributes {
    [key: string]: any;

    /**
     * 
     * @type {Spec}
     * @memberof ModuleAttributes
     */
    'spec'?: Spec;
    /**
     * 
     * @type {DesiredSpec}
     * @memberof ModuleAttributes
     */
    'desired_spec': DesiredSpec;
}
/**
 * Attributes for creating a module. Contains desired_spec with the target state.
 * @export
 * @interface ModuleCreateAttributes
 */
export interface ModuleCreateAttributes {
    [key: string]: any;

    /**
     * 
     * @type {DesiredSpec1}
     * @memberof ModuleCreateAttributes
     */
    'desired_spec': DesiredSpec1;
}
/**
 * Relationships for module creation request.
 * @export
 * @interface ModuleCreateRelationships
 */
export interface ModuleCreateRelationships {
    [key: string]: any;

    /**
     * 
     * @type {ModuleWorkspaceRelationship}
     * @memberof ModuleCreateRelationships
     */
    'workspace': ModuleWorkspaceRelationship;
}
/**
 * JSON:API request for creating a module.
 * @export
 * @interface ModuleCreateRequest
 */
export interface ModuleCreateRequest {
    [key: string]: any;

    /**
     * 
     * @type {ModuleCreateResourceObject}
     * @memberof ModuleCreateRequest
     */
    'data': ModuleCreateResourceObject;
}
/**
 * Resource object for module creation request.
 * @export
 * @interface ModuleCreateResourceObject
 */
export interface ModuleCreateResourceObject {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleCreateResourceObject
     */
    'type'?: any;
    /**
     * 
     * @type {ModuleCreateAttributes}
     * @memberof ModuleCreateResourceObject
     */
    'attributes': ModuleCreateAttributes;
    /**
     * 
     * @type {ModuleCreateRelationships}
     * @memberof ModuleCreateResourceObject
     */
    'relationships': ModuleCreateRelationships;
}
/**
 * JSON:API response for creating a module. Includes the operation if created.
 * @export
 * @interface ModuleCreateResponse
 */
export interface ModuleCreateResponse {
    [key: string]: any;

    /**
     * 
     * @type {ModuleResourceObject}
     * @memberof ModuleCreateResponse
     */
    'data': ModuleResourceObject;
    /**
     * 
     * @type {ModuleResponseLinks}
     * @memberof ModuleCreateResponse
     */
    'links': ModuleResponseLinks;
    /**
     * 
     * @type {any}
     * @memberof ModuleCreateResponse
     */
    'included'?: any;
}
/**
 * 
 * @export
 * @interface ModuleDeployCallback
 */
export interface ModuleDeployCallback {
    /**
     * 
     * @type {ModuleStatus}
     * @memberof ModuleDeployCallback
     */
    'status': ModuleStatus;
    /**
     * 
     * @type {ModuleUpsertType}
     * @memberof ModuleDeployCallback
     */
    'upsert_type': ModuleUpsertType;
    /**
     * 
     * @type {number}
     * @memberof ModuleDeployCallback
     */
    'deployment_duration': number;
}


/**
 * Relationships for module GET response with virtual relationships.  Virtual relationships (computed at query time): - active_operations: Operations with status IN (SCHEDULED, PENDING, IN_PROGRESS) - latest_successful_operation: Most recent operation with status = COMPLETED - all_operations: All operations for the module
 * @export
 * @interface ModuleGetRelationships
 */
export interface ModuleGetRelationships {
    [key: string]: any;

    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleGetRelationships
     */
    'workspace': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleGetRelationships
     */
    'active_operations'?: JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleGetRelationships
     */
    'latest_successful_operation'?: JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleGetRelationships
     */
    'all_operations'?: JsonApiRelationship;
}
/**
 * Resource object for module GET response with virtual relationships.
 * @export
 * @interface ModuleGetResourceObject
 */
export interface ModuleGetResourceObject {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleGetResourceObject
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof ModuleGetResourceObject
     */
    'id': any;
    /**
     * 
     * @type {ModuleAttributes}
     * @memberof ModuleGetResourceObject
     */
    'attributes': ModuleAttributes;
    /**
     * 
     * @type {ModuleGetRelationships}
     * @memberof ModuleGetResourceObject
     */
    'relationships'?: ModuleGetRelationships;
    /**
     * 
     * @type {ModuleResourceLinks}
     * @memberof ModuleGetResourceObject
     */
    'links'?: ModuleResourceLinks;
}
/**
 * JSON:API response for a list of modules (GET collection).  Supports ?include=active_operations,latest_successful_operation to include related operations in the response. Operations are deduplicated across all modules.
 * @export
 * @interface ModuleListResponse
 */
export interface ModuleListResponse {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleListResponse
     */
    'data': any;
    /**
     * 
     * @type {ModuleListResponseLinks}
     * @memberof ModuleListResponse
     */
    'links': ModuleListResponseLinks;
    /**
     * 
     * @type {any}
     * @memberof ModuleListResponse
     */
    'included'?: any;
}
/**
 * Links for module list response with pagination.
 * @export
 * @interface ModuleListResponseLinks
 */
export interface ModuleListResponseLinks {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleListResponseLinks
     */
    'self': any;
    /**
     * 
     * @type {any}
     * @memberof ModuleListResponseLinks
     */
    'next'?: any;
}
/**
 * Attributes for a module operation resource.
 * @export
 * @interface ModuleOperationAttributes
 */
export interface ModuleOperationAttributes {
    [key: string]: any;

    /**
     * 
     * @type {ModuleOperationStatus}
     * @memberof ModuleOperationAttributes
     */
    'status': ModuleOperationStatus;
    /**
     * 
     * @type {object}
     * @memberof ModuleOperationAttributes
     */
    'patch': object;
}


/**
 * Attributes for creating a module operation.  The patch contains partial module updates (deep merged with current spec). Note: patch cannot contain \'kind\' - kind is immutable after module creation.
 * @export
 * @interface ModuleOperationCreateAttributes
 */
export interface ModuleOperationCreateAttributes {
    [key: string]: any;

    /**
     * 
     * @type {object}
     * @memberof ModuleOperationCreateAttributes
     */
    'patch': object;
}
/**
 * Relationships for module operation creation request.
 * @export
 * @interface ModuleOperationCreateRelationships
 */
export interface ModuleOperationCreateRelationships {
    [key: string]: any;

    /**
     * 
     * @type {ModuleOperationModuleRelationship}
     * @memberof ModuleOperationCreateRelationships
     */
    'module': ModuleOperationModuleRelationship;
}
/**
 * JSON:API request for creating a module operation.
 * @export
 * @interface ModuleOperationCreateRequest
 */
export interface ModuleOperationCreateRequest {
    [key: string]: any;

    /**
     * 
     * @type {ModuleOperationCreateResourceObject}
     * @memberof ModuleOperationCreateRequest
     */
    'data': ModuleOperationCreateResourceObject;
}
/**
 * Resource object for module operation creation request.
 * @export
 * @interface ModuleOperationCreateResourceObject
 */
export interface ModuleOperationCreateResourceObject {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleOperationCreateResourceObject
     */
    'type'?: any;
    /**
     * 
     * @type {ModuleOperationCreateAttributes}
     * @memberof ModuleOperationCreateResourceObject
     */
    'attributes': ModuleOperationCreateAttributes;
    /**
     * 
     * @type {ModuleOperationCreateRelationships}
     * @memberof ModuleOperationCreateResourceObject
     */
    'relationships': ModuleOperationCreateRelationships;
}
/**
 * JSON:API response for creating a module operation.  Includes the target module with updated desired_spec.
 * @export
 * @interface ModuleOperationCreateResponse
 */
export interface ModuleOperationCreateResponse {
    [key: string]: any;

    /**
     * 
     * @type {ModuleOperationResourceObject}
     * @memberof ModuleOperationCreateResponse
     */
    'data': ModuleOperationResourceObject;
    /**
     * 
     * @type {ModuleResponseLinks}
     * @memberof ModuleOperationCreateResponse
     */
    'links': ModuleResponseLinks;
    /**
     * 
     * @type {any}
     * @memberof ModuleOperationCreateResponse
     */
    'included'?: any;
}
/**
 * Required to-one relationship to module.
 * @export
 * @interface ModuleOperationModuleRelationship
 */
export interface ModuleOperationModuleRelationship {
    [key: string]: any;

    /**
     * 
     * @type {JsonApiIdentifier}
     * @memberof ModuleOperationModuleRelationship
     */
    'data': JsonApiIdentifier;
}
/**
 * Resource object for module operation (used in included and responses).
 * @export
 * @interface ModuleOperationResourceObject
 */
export interface ModuleOperationResourceObject {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleOperationResourceObject
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof ModuleOperationResourceObject
     */
    'id': any;
    /**
     * 
     * @type {ModuleOperationAttributes}
     * @memberof ModuleOperationResourceObject
     */
    'attributes': ModuleOperationAttributes;
    /**
     * 
     * @type {ModuleOperationResponseRelationships}
     * @memberof ModuleOperationResourceObject
     */
    'relationships'?: ModuleOperationResponseRelationships;
    /**
     * 
     * @type {ModuleResourceLinks}
     * @memberof ModuleOperationResourceObject
     */
    'links'?: ModuleResourceLinks;
}
/**
 * Relationships for module operation response.
 * @export
 * @interface ModuleOperationResponseRelationships
 */
export interface ModuleOperationResponseRelationships {
    [key: string]: any;

    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleOperationResponseRelationships
     */
    'module': JsonApiRelationship;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ModuleOperationStatus {
    SCHEDULED = 'SCHEDULED',
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED'
}


/**
 * Links for a resource object per JSON:API spec.
 * @export
 * @interface ModuleResourceLinks
 */
export interface ModuleResourceLinks {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleResourceLinks
     */
    'self'?: any;
}
/**
 * Resource object for module response (POST).
 * @export
 * @interface ModuleResourceObject
 */
export interface ModuleResourceObject {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleResourceObject
     */
    'type'?: any;
    /**
     * 
     * @type {any}
     * @memberof ModuleResourceObject
     */
    'id': any;
    /**
     * 
     * @type {ModuleAttributes}
     * @memberof ModuleResourceObject
     */
    'attributes': ModuleAttributes;
    /**
     * 
     * @type {ModuleResponseRelationships}
     * @memberof ModuleResourceObject
     */
    'relationships'?: ModuleResponseRelationships;
    /**
     * 
     * @type {ModuleResourceLinks}
     * @memberof ModuleResourceObject
     */
    'links'?: ModuleResourceLinks;
}
/**
 * JSON:API response for a single module (GET).  Supports ?include=active_operations,latest_successful_operation to include related operations in the response.
 * @export
 * @interface ModuleResponse
 */
export interface ModuleResponse {
    [key: string]: any;

    /**
     * 
     * @type {ModuleGetResourceObject}
     * @memberof ModuleResponse
     */
    'data': ModuleGetResourceObject;
    /**
     * 
     * @type {ModuleResponseLinks}
     * @memberof ModuleResponse
     */
    'links': ModuleResponseLinks;
    /**
     * 
     * @type {any}
     * @memberof ModuleResponse
     */
    'included'?: any;
}
/**
 * Links for module response.
 * @export
 * @interface ModuleResponseLinks
 */
export interface ModuleResponseLinks {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof ModuleResponseLinks
     */
    'self': any;
}
/**
 * Relationships for module response (POST).
 * @export
 * @interface ModuleResponseRelationships
 */
export interface ModuleResponseRelationships {
    [key: string]: any;

    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleResponseRelationships
     */
    'workspace': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof ModuleResponseRelationships
     */
    'latest_operation'?: JsonApiRelationship;
}
/**
 * States of a workflow status. Keep in sync with decide operator worker.  Inspired by CloudFormation states, with distinctions for creation and updating.
 * @export
 * @enum {string}
 */

export enum ModuleStatus {
    CREATE_IN_PROGRESS = 'CREATE_IN_PROGRESS',
    CREATE_COMPLETE = 'CREATE_COMPLETE',
    CREATE_FAILED = 'CREATE_FAILED',
    UPDATE_IN_PROGRESS = 'UPDATE_IN_PROGRESS',
    UPDATE_COMPLETE = 'UPDATE_COMPLETE',
    UPDATE_FAILED = 'UPDATE_FAILED'
}


/**
 * Types of module upsert.
 * @export
 * @enum {string}
 */

export enum ModuleUpsertType {
    CREATE = 'MODULE_CREATE',
    VERSION_UPDATE = 'MODULE_VERSION_UPDATE',
    CONFIG_UPDATE = 'MODULE_CONFIG_UPDATE',
    NO_CHANGE = 'MODULE_NO_CHANGE'
}


/**
 * To-one relationship for workspace (single object only, not an array).
 * @export
 * @interface ModuleWorkspaceRelationship
 */
export interface ModuleWorkspaceRelationship {
    [key: string]: any;

    /**
     * 
     * @type {JsonApiIdentifier}
     * @memberof ModuleWorkspaceRelationship
     */
    'data': JsonApiIdentifier;
}
/**
 * 
 * @export
 * @interface Modules
 */
export interface Modules {
    /**
     * 
     * @type {FlowApiSchemasV2ModulesAgentsAgentsModuleSpec}
     * @memberof Modules
     */
    'agents'?: FlowApiSchemasV2ModulesAgentsAgentsModuleSpec;
    /**
     * 
     * @type {FlowApiSchemasV2ModulesFilesFilesModuleSpec}
     * @memberof Modules
     */
    'files'?: FlowApiSchemasV2ModulesFilesFilesModuleSpec;
    /**
     * 
     * @type {CaseManagementModuleSpec}
     * @memberof Modules
     */
    'case_management'?: CaseManagementModuleSpec;
    /**
     * 
     * @type {ConnectModuleSpec}
     * @memberof Modules
     */
    'connect'?: ConnectModuleSpec;
    /**
     * 
     * @type {HistoryModuleSpec}
     * @memberof Modules
     */
    'history'?: HistoryModuleSpec;
}
/**
 * 
 * @export
 * @interface NewAccountRecommendation
 */
export interface NewAccountRecommendation {
    /**
     * 
     * @type {number}
     * @memberof NewAccountRecommendation
     */
    'account_number': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewAccountRecommendation
     */
    'regions_to_enable': Array<string>;
}
/**
 * 
 * @export
 * @interface NodeCommentSummary
 */
export interface NodeCommentSummary {
    /**
     * 
     * @type {string}
     * @memberof NodeCommentSummary
     */
    'node_id': string;
    /**
     * 
     * @type {number}
     * @memberof NodeCommentSummary
     */
    'comments': number;
}
/**
 * 
 * @export
 * @interface NodeDb
 */
export interface NodeDb {
    /**
     * 
     * @type {Meta1}
     * @memberof NodeDb
     */
    'meta'?: Meta1;
    /**
     * 
     * @type {string}
     * @memberof NodeDb
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NodeDb
     */
    'id': string;
    /**
     * 
     * @type {NodeTypes}
     * @memberof NodeDb
     */
    'type': NodeTypes;
}


/**
 * 
 * @export
 * @interface NodeGroupDb
 */
export interface NodeGroupDb {
    /**
     * 
     * @type {Meta}
     * @memberof NodeGroupDb
     */
    'meta'?: Meta;
    /**
     * 
     * @type {string}
     * @memberof NodeGroupDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NodeGroupDb
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NodeGroupDb
     */
    'node_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface NodeGroupUpsert
 */
export interface NodeGroupUpsert {
    /**
     * 
     * @type {Meta}
     * @memberof NodeGroupUpsert
     */
    'meta'?: Meta;
    /**
     * 
     * @type {string}
     * @memberof NodeGroupUpsert
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NodeGroupUpsert
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NodeGroupUpsert
     */
    'node_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface NodeMetaBase
 */
export interface NodeMetaBase {
    /**
     * 
     * @type {string}
     * @memberof NodeMetaBase
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NodeMetaBase
     */
    'updated_by_id'?: string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum NodeTypes {
    AI_NODE_V2 = 'ai_node_v2',
    AGENT_NODE = 'agent_node',
    INPUT = 'input',
    OUTPUT = 'output',
    TRANSFORM = 'transform',
    RULE_2 = 'rule_2',
    SPLIT_2 = 'split_2',
    DATA_INTEGRATION = 'data_integration',
    ML = 'ml',
    MANIFEST_CONNECTION_NODE = 'manifest_connection_node',
    CUSTOM_CONNECTION_NODE = 'custom_connection_node',
    WEBHOOK_CONNECTION_NODE = 'webhook_connection_node',
    SQL_DATABASE_CONNECTION_NODE = 'sql_database_connection_node',
    ASSIGNMENT_NODE = 'assignment_node',
    DECISION_TABLE = 'decision_table',
    MATRIX_TABLE = 'matrix_table',
    SCORECARD = 'scorecard',
    FLOW = 'flow',
    FLOW_LOOP = 'flow_loop',
    REVIEW_CONNECTION_NODE = 'review_connection_node',
    CASE_CREATION_NODE = 'case_creation_node',
    CASE_UPDATE_NODE = 'case_update_node',
    WRITE_ENTITY_NODE = 'write_entity_node',
    READ_ENTITY_NODE = 'read_entity_node'
}


/**
 * 
 * @export
 * @interface NodeTypingInfo
 */
export interface NodeTypingInfo {
    /**
     * 
     * @type {string}
     * @memberof NodeTypingInfo
     */
    'etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof NodeTypingInfo
     */
    'type'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof NodeTypingInfo
     */
    'examples'?: Array<any>;
    /**
     * 
     * @type {{ [key: string]: TypingInfo; }}
     * @memberof NodeTypingInfo
     */
    'properties'?: { [key: string]: TypingInfo; };
    /**
     * 
     * @type {TypingInfo}
     * @memberof NodeTypingInfo
     */
    'items'?: TypingInfo;
    /**
     * 
     * @type {string}
     * @memberof NodeTypingInfo
     */
    'node_id'?: string;
}
/**
 * 
 * @export
 * @interface NodeUpsert
 */
export interface NodeUpsert {
    /**
     * 
     * @type {Meta1}
     * @memberof NodeUpsert
     */
    'meta'?: Meta1;
    /**
     * 
     * @type {string}
     * @memberof NodeUpsert
     */
    'name'?: string;
    /**
     * 
     * @type {NodeTypes}
     * @memberof NodeUpsert
     */
    'type'?: NodeTypes;
}


/**
 * 
 * @export
 * @interface ObservableChartDimensions
 */
export interface ObservableChartDimensions {
    /**
     * 
     * @type {ChartDimension}
     * @memberof ObservableChartDimensions
     */
    'x': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof ObservableChartDimensions
     */
    'y': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof ObservableChartDimensions
     */
    'color': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof ObservableChartDimensions
     */
    'size': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof ObservableChartDimensions
     */
    'fx': ChartDimension;
    /**
     * 
     * @type {ChartDimension}
     * @memberof ObservableChartDimensions
     */
    'fy': ChartDimension;
}
/**
 * 
 * @export
 * @interface OperatorCallbackPayload
 */
export interface OperatorCallbackPayload {
    /**
     * 
     * @type {string}
     * @memberof OperatorCallbackPayload
     */
    'request_id': string;
    /**
     * 
     * @type {string}
     * @memberof OperatorCallbackPayload
     */
    'status': string;
    /**
     * 
     * @type {OperatorOutput}
     * @memberof OperatorCallbackPayload
     */
    'output'?: OperatorOutput;
}
/**
 * 
 * @export
 * @interface OperatorOutput
 */
export interface OperatorOutput {
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'internal_base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'sample_data_bucket': string;
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'kms_key_arn': string;
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatorOutput
     */
    'principal'?: string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum Operators {
    LT = 'lt',
    LE = 'le',
    EQ = 'eq',
    NE = 'ne',
    GE = 'ge',
    GT = 'gt',
    IS_IN = 'is_in',
    NOT_IS_IN = 'not_is_in',
    IS_NONE = 'is_none',
    IS_NOT_NONE = 'is_not_none',
    CONTAINS = 'contains',
    DOES_NOT_CONTAIN = 'does_not_contain',
    MATCHES_REGEX = 'matches_regex'
}


/**
 * 
 * @export
 * @interface OutcomeType
 */
export interface OutcomeType {
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'key': string;
    /**
     * 
     * @type {object}
     * @memberof OutcomeType
     */
    'payload_schema': object;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeType
     */
    'status'?: OutcomeTypeStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof OutcomeType
     */
    'count'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum OutcomeTypeStatusEnum {
    ACTIVE = 'active',
    DELETING = 'deleting'
}

/**
 * 
 * @export
 * @interface OutcomeTypeCreate
 */
export interface OutcomeTypeCreate {
    /**
     * 
     * @type {string}
     * @memberof OutcomeTypeCreate
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeTypeCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OutcomeTypeCreate
     */
    'key': string;
    /**
     * 
     * @type {object}
     * @memberof OutcomeTypeCreate
     */
    'payload_schema': object;
}
/**
 * 
 * @export
 * @interface OutcomeTypePatch
 */
export interface OutcomeTypePatch {
    /**
     * 
     * @type {string}
     * @memberof OutcomeTypePatch
     */
    'name'?: string;
    /**
     * 
     * @type {object}
     * @memberof OutcomeTypePatch
     */
    'payload_schema'?: object;
}
/**
 * 
 * @export
 * @interface OutputAttribute
 */
export interface OutputAttribute {
    /**
     * 
     * @type {string}
     * @memberof OutputAttribute
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAttribute
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputAttribute
     */
    'mapped_to': string;
}
/**
 * 
 * @export
 * @interface Parameter
 */
export interface Parameter {
    /**
     * 
     * @type {string}
     * @memberof Parameter
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof Parameter
     */
    'value'?: any;
    /**
     * 
     * @type {string}
     * @memberof Parameter
     */
    'expr'?: string;
    /**
     * 
     * @type {string}
     * @memberof Parameter
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ProbabilisticPolicy
 */
export interface ProbabilisticPolicy {
    /**
     * 
     * @type {string}
     * @memberof ProbabilisticPolicy
     */
    'type': ProbabilisticPolicyTypeEnum;
    /**
     * 
     * @type {Array<FlowTrafficPolicyProbabilisticVersionEntry>}
     * @memberof ProbabilisticPolicy
     */
    'flow_versions': Array<FlowTrafficPolicyProbabilisticVersionEntry>;
}

/**
    * @export
    * @enum {string}
    */
export enum ProbabilisticPolicyTypeEnum {
    PROBABILISTIC = 'probabilistic'
}

/**
 * Request model for promoting a flow version to a manifest.
 * @export
 * @interface PromoteFlowVersionRequest
 */
export interface PromoteFlowVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoteFlowVersionRequest
     */
    'flow_version_id': string;
}
/**
 * Response model for promoting a flow version to a manifest
 * @export
 * @interface PromoteFlowVersionResponse
 */
export interface PromoteFlowVersionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PromoteFlowVersionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromoteFlowVersionResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof PromoteFlowVersionResponse
     */
    'provider_name': string;
    /**
     * 
     * @type {string}
     * @memberof PromoteFlowVersionResponse
     */
    'branch_name': string;
    /**
     * 
     * @type {string}
     * @memberof PromoteFlowVersionResponse
     */
    'workflow_run_url'?: string;
}
/**
 * Body value for the raw input.
 * @export
 * @interface RawBodyField
 */
export interface RawBodyField {
    /**
     * 
     * @type {string}
     * @memberof RawBodyField
     */
    'selected': RawBodyFieldSelectedEnum;
    /**
     * 
     * @type {string}
     * @memberof RawBodyField
     */
    'raw': string;
}

/**
    * @export
    * @enum {string}
    */
export enum RawBodyFieldSelectedEnum {
    RAW = 'raw'
}

/**
 * 
 * @export
 * @interface ReadEntityNodeMeta
 */
export interface ReadEntityNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof ReadEntityNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadEntityNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadEntityNodeMeta
     */
    'entity_schema': string;
    /**
     * 
     * @type {BaseInputField}
     * @memberof ReadEntityNodeMeta
     */
    'entity_ids_expression': BaseInputField;
    /**
     * 
     * @type {BaseInputField}
     * @memberof ReadEntityNodeMeta
     */
    'output_destination_expression': BaseInputField;
    /**
     * 
     * @type {boolean}
     * @memberof ReadEntityNodeMeta
     */
    'enrich_related_data': boolean;
}
/**
 * 
 * @export
 * @interface RegionCapacityIncreaseNeeded
 */
export interface RegionCapacityIncreaseNeeded {
    /**
     * 
     * @type {string}
     * @memberof RegionCapacityIncreaseNeeded
     */
    'region': string;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityIncreaseNeeded
     */
    'current_capacity': number;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityIncreaseNeeded
     */
    'additional_capacity_needed': number;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityIncreaseNeeded
     */
    'can_enable_on_existing_accounts': number;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityIncreaseNeeded
     */
    'new_accounts_required': number;
}
/**
 * 
 * @export
 * @interface RegionCapacityStats
 */
export interface RegionCapacityStats {
    /**
     * 
     * @type {string}
     * @memberof RegionCapacityStats
     */
    'region': string;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityStats
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityStats
     */
    'allocated': number;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityStats
     */
    'available': number;
    /**
     * 
     * @type {number}
     * @memberof RegionCapacityStats
     */
    'percentage_used': number;
}
/**
 * 
 * @export
 * @interface ResourceLock
 */
export interface ResourceLock {
    /**
     * 
     * @type {string}
     * @memberof ResourceLock
     */
    'owner': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceLock
     */
    'session': string;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceLock
     */
    'resource_type': ResourceType;
    /**
     * 
     * @type {string}
     * @memberof ResourceLock
     */
    'resource_id': string;
    /**
     * 
     * @type {number}
     * @memberof ResourceLock
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof ResourceLock
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceLock
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface ResourceLockUpsert
 */
export interface ResourceLockUpsert {
    /**
     * 
     * @type {string}
     * @memberof ResourceLockUpsert
     */
    'owner': string;
    /**
     * 
     * @type {string}
     * @memberof ResourceLockUpsert
     */
    'session': string;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceLockUpsert
     */
    'resource_type': ResourceType;
    /**
     * 
     * @type {string}
     * @memberof ResourceLockUpsert
     */
    'resource_id': string;
    /**
     * 
     * @type {number}
     * @memberof ResourceLockUpsert
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof ResourceLockUpsert
     */
    'timestamp'?: string;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ResourceType {
    FLOW = 'flow',
    FLOW_VERSION = 'flow_version',
    PARAMETER = 'parameter',
    NODE = 'node',
    SCHEMA = 'schema'
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ReviewCommentStatus {
    APPROVED = 'approved',
    REQUESTED_CHANGES = 'requested_changes',
    REVIEW_REREQUESTED = 'review_rerequested',
    COMMENTED = 'commented',
    CANCELLED = 'cancelled'
}


/**
 * 
 * @export
 * @interface ReviewDb
 */
export interface ReviewDb {
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'flow_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'requestee_id': string;
    /**
     * 
     * @type {ReviewStatus}
     * @memberof ReviewDb
     */
    'review_status': ReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'request_status_changed_at': string;
    /**
     * 
     * @type {{ [key: string]: ReviewReviewerDb; }}
     * @memberof ReviewDb
     */
    'reviewers_status': { [key: string]: ReviewReviewerDb; };
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDb
     */
    'opened_at_flow_version_etag': string;
    /**
     * 
     * @type {FlowVersionContributors}
     * @memberof ReviewDb
     */
    'contributors'?: FlowVersionContributors;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ReviewRequestStatus {
    OPEN = 'open',
    CANCELLED = 'cancelled'
}


/**
 * 
 * @export
 * @interface ReviewReviewerDb
 */
export interface ReviewReviewerDb {
    /**
     * 
     * @type {string}
     * @memberof ReviewReviewerDb
     */
    'reviewer_id': string;
    /**
     * 
     * @type {ReviewerReviewStatus}
     * @memberof ReviewReviewerDb
     */
    'reviewer_status': ReviewerReviewStatus;
    /**
     * 
     * @type {string}
     * @memberof ReviewReviewerDb
     */
    'reviewer_status_changed_at': string;
}


/**
 * 
 * @export
 * @interface ReviewReviewerUpdate
 */
export interface ReviewReviewerUpdate {
    /**
     * 
     * @type {string}
     * @memberof ReviewReviewerUpdate
     */
    'reviewer_id'?: string;
    /**
     * 
     * @type {ReviewerReviewStatus}
     * @memberof ReviewReviewerUpdate
     */
    'reviewer_status': ReviewerReviewStatus;
}


/**
 * 
 * @export
 * @interface ReviewShallow
 */
export interface ReviewShallow {
    /**
     * 
     * @type {ReviewRequestStatus}
     * @memberof ReviewShallow
     */
    'request_status': ReviewRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof ReviewShallow
     */
    'requestee_id': string;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ReviewStatus {
    OPEN = 'open',
    CANCELLED = 'cancelled',
    APPROVED = 'approved'
}


/**
 * 
 * @export
 * @interface ReviewUpsert
 */
export interface ReviewUpsert {
    /**
     * 
     * @type {string}
     * @memberof ReviewUpsert
     */
    'flow_version_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewUpsert
     */
    'flow_version_etag': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewUpsert
     */
    'description'?: string;
    /**
     * 
     * @type {ReviewRequestStatus}
     * @memberof ReviewUpsert
     */
    'review_status'?: ReviewRequestStatus;
    /**
     * 
     * @type {{ [key: string]: ReviewReviewerUpdate; }}
     * @memberof ReviewUpsert
     */
    'reviewers_status'?: { [key: string]: ReviewReviewerUpdate; };
}


/**
 * @type ReviewerAssignStrategyV2
 * @export
 */
export type ReviewerAssignStrategyV2 = { type: 'ANY' } & AssignStrategyAny | { type: 'GROUP' } & AssignStrategyGroup | { type: 'REVIEWER_ONLY' } & AssignStrategyReviewerOnly | { type: 'RULE' } & AssignStrategyRule;

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum ReviewerReviewStatus {
    PENDING = 'pending',
    APPROVED = 'approved',
    REQUESTED_CHANGES = 'requested_changes',
    COMMENTED = 'commented'
}


/**
 * 
 * @export
 * @interface RuleBranch
 */
export interface RuleBranch {
    /**
     * 
     * @type {string}
     * @memberof RuleBranch
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RuleBranch
     */
    'name'?: string;
    /**
     * 
     * @type {Junctions}
     * @memberof RuleBranch
     */
    'junction': Junctions;
    /**
     * 
     * @type {Array<Clause>}
     * @memberof RuleBranch
     */
    'clauses': Array<Clause>;
    /**
     * 
     * @type {Array<Effect>}
     * @memberof RuleBranch
     */
    'effects': Array<Effect>;
}


/**
 * 
 * @export
 * @interface RuleNodeMeta
 */
export interface RuleNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof RuleNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {Array<Effect>}
     * @memberof RuleNodeMeta
     */
    'default_effects': Array<Effect>;
    /**
     * 
     * @type {Array<RuleBranch>}
     * @memberof RuleNodeMeta
     */
    'branches': Array<RuleBranch>;
}
/**
 * 
 * @export
 * @interface ScoreCardNodeMeta
 */
export interface ScoreCardNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof ScoreCardNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreCardNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {DecisionTableField}
     * @memberof ScoreCardNodeMeta
     */
    'assign_field': DecisionTableField;
    /**
     * 
     * @type {boolean}
     * @memberof ScoreCardNodeMeta
     */
    'extract_scores': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScoreCardNodeMeta
     */
    'equal_weights': boolean;
    /**
     * 
     * @type {Array<ScorecardFactor>}
     * @memberof ScoreCardNodeMeta
     */
    'factors': Array<ScorecardFactor>;
}
/**
 * 
 * @export
 * @interface ScorecardCase
 */
export interface ScorecardCase {
    /**
     * 
     * @type {string}
     * @memberof ScorecardCase
     */
    'id': string;
    /**
     * 
     * @type {DecisionTablePredicate}
     * @memberof ScorecardCase
     */
    'predicate': DecisionTablePredicate;
    /**
     * 
     * @type {DecisionTableEffect}
     * @memberof ScorecardCase
     */
    'effect': DecisionTableEffect;
}
/**
 * 
 * @export
 * @interface ScorecardFactor
 */
export interface ScorecardFactor {
    /**
     * 
     * @type {string}
     * @memberof ScorecardFactor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ScorecardFactor
     */
    'name': string;
    /**
     * 
     * @type {DecisionTableField}
     * @memberof ScorecardFactor
     */
    'input_field': DecisionTableField;
    /**
     * 
     * @type {DecisionTableField}
     * @memberof ScorecardFactor
     */
    'output_field': DecisionTableField;
    /**
     * 
     * @type {DecisionTableField}
     * @memberof ScorecardFactor
     */
    'weight': DecisionTableField;
    /**
     * 
     * @type {DecisionTableEffect}
     * @memberof ScorecardFactor
     */
    'fallback': DecisionTableEffect;
    /**
     * 
     * @type {Array<ScorecardCase>}
     * @memberof ScorecardFactor
     */
    'cases': Array<ScorecardCase>;
}
/**
 * 
 * @export
 * @interface SimulationMeta
 */
export interface SimulationMeta {
    /**
     * 
     * @type {SimulationStatus}
     * @memberof SimulationMeta
     */
    'status': SimulationStatus;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum SimulationStatus {
    RUNNING = 'running'
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum SnapStartMode {
    ENABLE = 'enable',
    DISABLE = 'disable',
    INHERIT = 'inherit'
}


/**
 * 
 * @export
 * @interface Spec
 */
export interface Spec {
    /**
     * 
     * @type {any}
     * @memberof Spec
     */
    'kind'?: SpecKindEnum;
    /**
     * 
     * @type {any}
     * @memberof Spec
     */
    'version': any;
    /**
     * 
     * @type {any}
     * @memberof Spec
     */
    'is_active': any;
    /**
     * 
     * @type {any}
     * @memberof Spec
     */
    'profile_level': any;
    /**
     * 
     * @type {FlowApiSchemasV3ModulesFilesFilesModuleConfig}
     * @memberof Spec
     */
    'config': FlowApiSchemasV3ModulesFilesFilesModuleConfig;
}

/**
    * @export
    * @enum {string}
    */
export enum SpecKindEnum {
    FILES = 'files'
}

/**
 * 
 * @export
 * @interface SplitBranch
 */
export interface SplitBranch {
    /**
     * 
     * @type {Junctions}
     * @memberof SplitBranch
     */
    'junction': Junctions;
    /**
     * 
     * @type {Array<Clause>}
     * @memberof SplitBranch
     */
    'clauses': Array<Clause>;
    /**
     * 
     * @type {string}
     * @memberof SplitBranch
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SplitBranch
     */
    'edge_id': string;
}


/**
 * 
 * @export
 * @interface SplitNodeMeta
 */
export interface SplitNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof SplitNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SplitNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {Array<SplitBranch>}
     * @memberof SplitNodeMeta
     */
    'branches': Array<SplitBranch>;
    /**
     * 
     * @type {string}
     * @memberof SplitNodeMeta
     */
    'default_edge_id': string;
}
/**
 * 
 * @export
 * @interface SummaryChartDimensions
 */
export interface SummaryChartDimensions {
    /**
     * 
     * @type {string}
     * @memberof SummaryChartDimensions
     */
    'field'?: string;
    /**
     * 
     * @type {ChartAggregator}
     * @memberof SummaryChartDimensions
     */
    'aggregator': ChartAggregator;
    /**
     * 
     * @type {ChartFormat}
     * @memberof SummaryChartDimensions
     */
    'format': ChartFormat;
}


/**
 * 
 * @export
 * @interface TogglableInputAttribute
 */
export interface TogglableInputAttribute {
    /**
     * 
     * @type {string}
     * @memberof TogglableInputAttribute
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TogglableInputAttribute
     */
    'expression': string;
    /**
     * 
     * @type {boolean}
     * @memberof TogglableInputAttribute
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface TrafficPolicyCreateService
 */
export interface TrafficPolicyCreateService {
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyCreateService
     */
    'flow_id': string;
    /**
     * 
     * @type {ProbabilisticPolicy}
     * @memberof TrafficPolicyCreateService
     */
    'policy': ProbabilisticPolicy;
}
/**
 * 
 * @export
 * @interface TrafficPolicyInDB
 */
export interface TrafficPolicyInDB {
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyInDB
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyInDB
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyInDB
     */
    'name': string;
    /**
     * 
     * @type {ProbabilisticPolicy}
     * @memberof TrafficPolicyInDB
     */
    'policy'?: ProbabilisticPolicy;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyInDB
     */
    'created_by_user_id': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyInDB
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyInDB
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<TrafficPolicyWindowInDB>}
     * @memberof TrafficPolicyInDB
     */
    'traffic_policy_windows'?: Array<TrafficPolicyWindowInDB>;
}
/**
 * 
 * @export
 * @interface TrafficPolicyWindowInDB
 */
export interface TrafficPolicyWindowInDB {
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'traffic_policy_id': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'starts_at': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'ends_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'created_by_user_id': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TrafficPolicyWindowInDB
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface TypingInfo
 */
export interface TypingInfo {
    /**
     * 
     * @type {string}
     * @memberof TypingInfo
     */
    'etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypingInfo
     */
    'type'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof TypingInfo
     */
    'examples'?: Array<any>;
    /**
     * 
     * @type {{ [key: string]: TypingInfo; }}
     * @memberof TypingInfo
     */
    'properties'?: { [key: string]: TypingInfo; };
    /**
     * 
     * @type {TypingInfo}
     * @memberof TypingInfo
     */
    'items'?: TypingInfo;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * @type Value
 * @export
 */
export type Value = { selected: 'key_values' } & KeyValuesBodyField | { selected: 'raw' } & RawBodyField;

/**
 * 
 * @export
 * @interface ViewFilter
 */
export interface ViewFilter {
    /**
     * 
     * @type {string}
     * @memberof ViewFilter
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ViewFilter
     */
    'workspace_id': string;
    /**
     * 
     * @type {string}
     * @memberof ViewFilter
     */
    'type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ViewFilter
     */
    'ui_entity_fields_exclude'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Webhook
 */
export interface Webhook {
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Webhook
     */
    'webhook_template_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'workspace_id': string;
    /**
     * 
     * @type {ResourceType}
     * @memberof Webhook
     */
    'resource_type': ResourceType;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof Webhook
     */
    'resource_config_id': string;
    /**
     * 
     * @type {Array<EventFilter>}
     * @memberof Webhook
     */
    'pattern': Array<EventFilter>;
    /**
     * 
     * @type {boolean}
     * @memberof Webhook
     */
    'active': boolean;
}


/**
 * 
 * @export
 * @interface WebhookConnectionNodeMeta
 */
export interface WebhookConnectionNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof WebhookConnectionNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookConnectionNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof WebhookConnectionNodeMeta
     */
    'provider_resource': object;
    /**
     * 
     * @type {string}
     * @memberof WebhookConnectionNodeMeta
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookConnectionNodeMeta
     */
    'resource_config_id': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookConnectionNodeMeta
     */
    'media_key'?: string;
    /**
     * 
     * @type {object}
     * @memberof WebhookConnectionNodeMeta
     */
    'config': object;
    /**
     * 
     * @type {InputAttribute}
     * @memberof WebhookConnectionNodeMeta
     */
    'correlation_id': InputAttribute;
    /**
     * 
     * @type {object}
     * @memberof WebhookConnectionNodeMeta
     */
    'response': object;
}
/**
 * 
 * @export
 * @interface WebhookUpdate
 */
export interface WebhookUpdate {
    /**
     * 
     * @type {number}
     * @memberof WebhookUpdate
     */
    'webhook_template_version'?: number;
}
/**
 * 
 * @export
 * @interface WorkspaceConfig
 */
export interface WorkspaceConfig {
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'disable_on_call_alarms'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'disable_bug_alarms'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'volume_bytes_used_threshold'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'enable_lambda_insights'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'disable_node_history'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'provisioned_concurrency_router'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'provisioned_concurrency_runner'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'provisioned_concurrency_connect'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'provisioned_concurrency_exporter'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'provisioned_concurrency_llm_inference'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'archiver_sqs_consumption_maximum_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'webhook_timeout_sqs_consumption_maximum_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'webhook_timeout_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'webhook_timeout_batch_window'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_router_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_router_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_router_sandbox'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_router_sandbox'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_router_run'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_router_run'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_connect_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_connect_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_llm_inference'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_rate_limit_llm_inference'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_exporter_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_exporter_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_exporter_s3_bucket_datasets'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_exporter_s3_bucket_datasets'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_burst_limit_exporter_jobs'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'throttling_rate_limit_exporter_jobs'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_migrator_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_connect_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_exporter_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_runner_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_router_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_llm_inference_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_batch_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'memory_reader_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'disk_batch_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_migrator_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_connect_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_exporter_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_archiver_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_router_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_llm_inference_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_batch_archiver_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'timeout_reader_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'aurora_min_capacity_acu'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'aurora_max_capocity_acu'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'ips_whitelist'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'ips_whitelist_sandbox'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'ips_whitelist_live'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WorkspaceConfig
     */
    'extra_tags'?: { [key: string]: string; };
    /**
     * 
     * @type {SnapStartMode}
     * @memberof WorkspaceConfig
     */
    'connect_snap_start_mode'?: SnapStartMode;
    /**
     * 
     * @type {SnapStartMode}
     * @memberof WorkspaceConfig
     */
    'snap_start_mode_llm_inference'?: SnapStartMode;
    /**
     * 
     * @type {SnapStartMode}
     * @memberof WorkspaceConfig
     */
    'router_snap_start_mode'?: SnapStartMode;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'ai_node_enable_files'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'ai_node_use_llm_inference_backend'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'ai_node_threshold_slack_webhook'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_threshold_disable_email_alert'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_ai_cost_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'test_run_row_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_claude_3_7_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_claude_3_7_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_claude_3_7_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_claude_3_5_sonnet_v2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_claude_3_5_sonnet_v2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_claude_3_5_sonnet_v2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_claude_3_5_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_claude_3_5_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_claude_3_5_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_claude_3_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_claude_3_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_claude_3_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_claude_3_5_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_claude_3_5_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_claude_3_5_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_claude_3_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_claude_3_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_claude_3_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_amazon_nova_pro'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_amazon_nova_pro'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_amazon_nova_pro'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_monthly_token_quota_deepseek_r1'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_token_per_minute_limit_deepseek_r1'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ai_node_request_per_minute_limit_deepseek_r1'?: number;
    /**
     * 
     * @type {{ [key: string]: AINodeModelConfig; }}
     * @memberof WorkspaceConfig
     */
    'ai_node_combined_quotas_openai_v2'?: { [key: string]: AINodeModelConfig; };
    /**
     * 
     * @type {{ [key: string]: AINodeGeminiModelConfig; }}
     * @memberof WorkspaceConfig
     */
    'ai_node_combined_quotas_gemini_v2'?: { [key: string]: AINodeGeminiModelConfig; };
    /**
     * 
     * @type {{ [key: string]: AINodeModelConfig; }}
     * @memberof WorkspaceConfig
     */
    'ai_node_combined_quotas_bedrock_v2'?: { [key: string]: AINodeModelConfig; };
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'jobs_sql_source_batch_size'?: number;
    /**
     * 
     * @type {JobsConfig}
     * @memberof WorkspaceConfig
     */
    'jobs_config'?: JobsConfig;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'jobs_concurrency_max_poller'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'slack_error_webhook'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'slack_error_format'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'enable_analytics_egress'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'ml_model_max_size_bytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'mocks_max_size_bytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'snapshot_ARN_aurora'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'aurora_generation_sufix'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'total_custom_connection_retry_count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'use_shared_aurora_in_dev'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'profile_level'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'aurora_engine_version'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'enable_mtls'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'mtls_internal_crt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'mtls_internal_key'?: string;
    /**
     * 
     * @type {EventBridgePublishingMode}
     * @memberof WorkspaceConfig
     */
    'event_bridge_publishing_mode'?: EventBridgePublishingMode;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'reserved_concurrent_executions_router'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'reserved_concurrent_executions_runner'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'pc_auto_scaling_enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'pc_auto_scaling_target_utilization'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'max_shard_size_rows'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'max_shard_size_bytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'kinesis_persist_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'kinesis_persist_batch_timeout'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'events_stream_retention_period_hours'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'use_hyphens_in_glue_database_names'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_query_execution_window_hop_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_diff_lambda_memory'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_athena_workgroup_cutoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_athena_workgroup_general_cutoff'?: number;
    /**
     * 
     * @type {FeatureModuleConfigs}
     * @memberof WorkspaceConfig
     */
    'feature_module_configs'?: FeatureModuleConfigs;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'feature_module_use_reserved_workgroup'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_reserved_workgroup_target_dpus'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_features_bucket_size_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_backup_cost_budget_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'feature_module_glue_cost_budget_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'purge_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'purge_max_batches'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'node_results'?: string;
    /**
     * 
     * @type {HistoryMode}
     * @memberof WorkspaceConfig
     */
    'history_mode'?: HistoryMode;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfig
     */
    'dh_v2_available_after_iso_8601_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'enable_dhv2_metrics'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'batch_archiver_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    'max_child_flows'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'use_cli_static_configuration'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    's3_bucket_dataset_lines_per_chunk'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfig
     */
    's3_bucket_dataset_chunks_per_upload'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'self_hosted_open_sanctions_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'route_internal_traffic_to_connect_module'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'deploy_connect_resources_in_base_stack'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfig
     */
    'enable_customer_support_widget'?: boolean;
}


/**
 * 
 * @export
 * @interface WorkspaceConfigUpdate
 */
export interface WorkspaceConfigUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'disable_on_call_alarms'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'disable_bug_alarms'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'volume_bytes_used_threshold'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'enable_lambda_insights'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'disable_node_history'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'provisioned_concurrency_router'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'provisioned_concurrency_runner'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'provisioned_concurrency_connect'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'provisioned_concurrency_exporter'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'provisioned_concurrency_llm_inference'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'archiver_sqs_consumption_maximum_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'webhook_timeout_sqs_consumption_maximum_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'webhook_timeout_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'webhook_timeout_batch_window'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_router_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_router_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_router_sandbox'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_router_sandbox'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_router_run'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_router_run'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_connect_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_connect_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_llm_inference'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_rate_limit_llm_inference'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_exporter_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_exporter_global'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_exporter_s3_bucket_datasets'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_exporter_s3_bucket_datasets'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_burst_limit_exporter_jobs'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'throttling_rate_limit_exporter_jobs'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_migrator_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_connect_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_exporter_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_runner_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_router_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_llm_inference_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_batch_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'memory_reader_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'disk_batch_archiver_mb'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_migrator_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_connect_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_exporter_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_archiver_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_router_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_llm_inference_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_batch_archiver_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'timeout_reader_s'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'aurora_min_capacity_acu'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'aurora_max_capocity_acu'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'ips_whitelist'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'ips_whitelist_sandbox'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'ips_whitelist_live'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WorkspaceConfigUpdate
     */
    'extra_tags'?: { [key: string]: string; };
    /**
     * 
     * @type {SnapStartMode}
     * @memberof WorkspaceConfigUpdate
     */
    'connect_snap_start_mode'?: SnapStartMode;
    /**
     * 
     * @type {SnapStartMode}
     * @memberof WorkspaceConfigUpdate
     */
    'snap_start_mode_llm_inference'?: SnapStartMode;
    /**
     * 
     * @type {SnapStartMode}
     * @memberof WorkspaceConfigUpdate
     */
    'router_snap_start_mode'?: SnapStartMode;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_enable_files'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_use_llm_inference_backend'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_threshold_slack_webhook'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_threshold_disable_email_alert'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_ai_cost_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'test_run_row_limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_claude_3_7_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_claude_3_7_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_claude_3_7_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_claude_3_5_sonnet_v2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_claude_3_5_sonnet_v2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_claude_3_5_sonnet_v2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_claude_3_5_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_claude_3_5_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_claude_3_5_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_claude_3_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_claude_3_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_claude_3_sonnet'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_claude_3_5_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_claude_3_5_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_claude_3_5_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_claude_3_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_claude_3_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_claude_3_haiku'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_amazon_nova_pro'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_amazon_nova_pro'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_amazon_nova_pro'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_monthly_token_quota_deepseek_r1'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_token_per_minute_limit_deepseek_r1'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_request_per_minute_limit_deepseek_r1'?: number;
    /**
     * 
     * @type {{ [key: string]: AINodeModelConfig; }}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_combined_quotas_openai_v2'?: { [key: string]: AINodeModelConfig; };
    /**
     * 
     * @type {{ [key: string]: AINodeGeminiModelConfig; }}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_combined_quotas_gemini_v2'?: { [key: string]: AINodeGeminiModelConfig; };
    /**
     * 
     * @type {{ [key: string]: AINodeModelConfig; }}
     * @memberof WorkspaceConfigUpdate
     */
    'ai_node_combined_quotas_bedrock_v2'?: { [key: string]: AINodeModelConfig; };
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'jobs_sql_source_batch_size'?: number;
    /**
     * 
     * @type {JobsConfig}
     * @memberof WorkspaceConfigUpdate
     */
    'jobs_config'?: JobsConfig;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'jobs_concurrency_max_poller'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'slack_error_webhook'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'slack_error_format'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'enable_analytics_egress'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'ml_model_max_size_bytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'mocks_max_size_bytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'snapshot_ARN_aurora'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'aurora_generation_sufix'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'total_custom_connection_retry_count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'use_shared_aurora_in_dev'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'profile_level'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'aurora_engine_version'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'enable_mtls'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'mtls_internal_crt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'mtls_internal_key'?: string;
    /**
     * 
     * @type {EventBridgePublishingMode}
     * @memberof WorkspaceConfigUpdate
     */
    'event_bridge_publishing_mode'?: EventBridgePublishingMode;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'reserved_concurrent_executions_router'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'reserved_concurrent_executions_runner'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'pc_auto_scaling_enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'pc_auto_scaling_target_utilization'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'max_shard_size_rows'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'max_shard_size_bytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'kinesis_persist_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'kinesis_persist_batch_timeout'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'events_stream_retention_period_hours'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'use_hyphens_in_glue_database_names'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_query_execution_window_hop_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_diff_lambda_memory'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_athena_workgroup_cutoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_athena_workgroup_general_cutoff'?: number;
    /**
     * 
     * @type {FeatureModuleConfigs}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_configs'?: FeatureModuleConfigs;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_use_reserved_workgroup'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_reserved_workgroup_target_dpus'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_features_bucket_size_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_backup_cost_budget_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'feature_module_glue_cost_budget_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'purge_batch_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'purge_max_batches'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'node_results'?: string;
    /**
     * 
     * @type {HistoryMode}
     * @memberof WorkspaceConfigUpdate
     */
    'history_mode'?: HistoryMode;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceConfigUpdate
     */
    'dh_v2_available_after_iso_8601_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'enable_dhv2_metrics'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'batch_archiver_concurrency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    'max_child_flows'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'use_cli_static_configuration'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    's3_bucket_dataset_lines_per_chunk'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceConfigUpdate
     */
    's3_bucket_dataset_chunks_per_upload'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'self_hosted_open_sanctions_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'route_internal_traffic_to_connect_module'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'deploy_connect_resources_in_base_stack'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceConfigUpdate
     */
    'enable_customer_support_widget'?: boolean;
}


/**
 * 
 * @export
 * @interface WorkspaceCreate
 */
export interface WorkspaceCreate {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'name': string;
    /**
     * 
     * @type {WorkspaceStatus}
     * @memberof WorkspaceCreate
     */
    'status'?: WorkspaceStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'flow_services_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'internal_base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'aws_account_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceCreate
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'aws_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'organization_id': string;
    /**
     * 
     * @type {WorkspaceConfig}
     * @memberof WorkspaceCreate
     */
    'config'?: WorkspaceConfig;
    /**
     * 
     * @type {WorkspaceFeatureGates}
     * @memberof WorkspaceCreate
     */
    'feature_gates'?: WorkspaceFeatureGates;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCreate
     */
    'sample_data_s3_bucket'?: string;
}


/**
 * 
 * @export
 * @interface WorkspaceDataplane
 */
export interface WorkspaceDataplane {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'name': string;
    /**
     * 
     * @type {WorkspaceStatus}
     * @memberof WorkspaceDataplane
     */
    'status': WorkspaceStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'flow_services_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'internal_base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'aws_account_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDataplane
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'sample_data_s3_bucket'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'sample_data_kms_key_arn'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'aws_region': string;
    /**
     * 
     * @type {WorkspaceConfig}
     * @memberof WorkspaceDataplane
     */
    'config'?: WorkspaceConfig;
    /**
     * 
     * @type {WorkspaceFeatureGates}
     * @memberof WorkspaceDataplane
     */
    'feature_gates'?: WorkspaceFeatureGates;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDataplane
     */
    'state_suffix'?: string;
    /**
     * 
     * @type {WorkspaceSettings}
     * @memberof WorkspaceDataplane
     */
    'settings'?: WorkspaceSettings;
}


/**
 * 
 * @export
 * @interface WorkspaceDb
 */
export interface WorkspaceDb {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'internal_base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'aws_account_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDb
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDb
     */
    'aws_region': string;
    /**
     * 
     * @type {Modules}
     * @memberof WorkspaceDb
     */
    'modules': Modules;
}
/**
 * 
 * @export
 * @interface WorkspaceFeatureGates
 */
export interface WorkspaceFeatureGates {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof WorkspaceFeatureGates
     */
    'entity'?: any;
    /**
     * 
     * @type {any}
     * @memberof WorkspaceFeatureGates
     */
    'feature'?: any;
}
/**
 * 
 * @export
 * @interface WorkspaceInfo
 */
export interface WorkspaceInfo {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceInfo
     */
    'flow_services_version': string;
}
/**
 * 
 * @export
 * @interface WorkspacePatch
 */
export interface WorkspacePatch {
    /**
     * 
     * @type {string}
     * @memberof WorkspacePatch
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspacePatch
     */
    'flow_services_version'?: string;
    /**
     * 
     * @type {WorkspaceSettingsCreateApi}
     * @memberof WorkspacePatch
     */
    'settings'?: WorkspaceSettingsCreateApi;
    /**
     * 
     * @type {WorkspaceConfigUpdate}
     * @memberof WorkspacePatch
     */
    'config'?: WorkspaceConfigUpdate;
    /**
     * 
     * @type {WorkspaceFeatureGates}
     * @memberof WorkspacePatch
     */
    'feature_gates'?: WorkspaceFeatureGates;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspacePatch
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface WorkspaceSettings
 */
export interface WorkspaceSettings {
    /**
     * 
     * @type {DataRetentionTimedelta}
     * @memberof WorkspaceSettings
     */
    'data_retention': DataRetentionTimedelta;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettings
     */
    'data_wiping_enabled_until'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettings
     */
    'created_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettings
     */
    'created_at'?: string;
}
/**
 * 
 * @export
 * @interface WorkspaceSettingsCreateApi
 */
export interface WorkspaceSettingsCreateApi {
    /**
     * 
     * @type {DataRetentionTimedelta}
     * @memberof WorkspaceSettingsCreateApi
     */
    'data_retention': DataRetentionTimedelta;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceSettingsCreateApi
     */
    'data_wiping_enabled_until'?: string;
}
/**
 * States of a workflow status. Keep in sync with decide operator worker
 * @export
 * @enum {string}
 */

export enum WorkspaceStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE'
}


/**
 * 
 * @export
 * @interface WriteEntityNodeMeta
 */
export interface WriteEntityNodeMeta {
    /**
     * 
     * @type {string}
     * @memberof WriteEntityNodeMeta
     */
    'created_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteEntityNodeMeta
     */
    'updated_by_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteEntityNodeMeta
     */
    'entity_schema': string;
    /**
     * 
     * @type {BaseInputField}
     * @memberof WriteEntityNodeMeta
     */
    'entity_objects_expression': BaseInputField;
    /**
     * 
     * @type {Array<string>}
     * @memberof WriteEntityNodeMeta
     */
    'properties_to_write': Array<string>;
}

/**
 * AwsAccountsApi - axios parameter creator
 * @export
 */
export const AwsAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new AWS account.
         * @summary Create Aws Account
         * @param {AWSAccountCreate} aWSAccountCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAwsAccountApiV1AwsAccountsPost: async (aWSAccountCreate: AWSAccountCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aWSAccountCreate' is not null or undefined
            assertParamExists('createAwsAccountApiV1AwsAccountsPost', 'aWSAccountCreate', aWSAccountCreate)
            const localVarPath = `/api/v1/aws_accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aWSAccountCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an AWS account.
         * @summary Delete Aws Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAwsAccountApiV1AwsAccountsAccountIdDelete: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAwsAccountApiV1AwsAccountsAccountIdDelete', 'accountId', accountId)
            const localVarPath = `/api/v1/aws_accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single AWS account by ID.
         * @summary Get Aws Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAwsAccountApiV1AwsAccountsAccountIdGet: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAwsAccountApiV1AwsAccountsAccountIdGet', 'accountId', accountId)
            const localVarPath = `/api/v1/aws_accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all AWS accounts that can be used as deployment targets.
         * @summary Get Aws Accounts
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [includeDisabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAwsAccountsApiV1AwsAccountsGet: async (skip?: number, limit?: number, includeDisabled?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/aws_accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (includeDisabled !== undefined) {
                localVarQueryParameter['include_disabled'] = includeDisabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a capacity report showing usage per region and expansion recommendations. When any region hits the threshold, calculates expansion needed for ALL regions to reach target_max_usage. Recommends enabling regions on existing accounts and/or provisioning new accounts as needed.
         * @summary Get Capacity Report
         * @param {number} [threshold] 
         * @param {number} [targetMaxUsage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapacityReportApiV1AwsAccountsCapacityReportGet: async (threshold?: number, targetMaxUsage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/aws_accounts/capacity-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }

            if (targetMaxUsage !== undefined) {
                localVarQueryParameter['target_max_usage'] = targetMaxUsage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an AWS account.
         * @summary Update Aws Account
         * @param {string} accountId 
         * @param {AWSAccountUpdate} aWSAccountUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAwsAccountApiV1AwsAccountsAccountIdPatch: async (accountId: string, aWSAccountUpdate: AWSAccountUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateAwsAccountApiV1AwsAccountsAccountIdPatch', 'accountId', accountId)
            // verify required parameter 'aWSAccountUpdate' is not null or undefined
            assertParamExists('updateAwsAccountApiV1AwsAccountsAccountIdPatch', 'aWSAccountUpdate', aWSAccountUpdate)
            const localVarPath = `/api/v1/aws_accounts/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aWSAccountUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AwsAccountsApi - functional programming interface
 * @export
 */
export const AwsAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AwsAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new AWS account.
         * @summary Create Aws Account
         * @param {AWSAccountCreate} aWSAccountCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAwsAccountApiV1AwsAccountsPost(aWSAccountCreate: AWSAccountCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AWSAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAwsAccountApiV1AwsAccountsPost(aWSAccountCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AwsAccountsApi.createAwsAccountApiV1AwsAccountsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an AWS account.
         * @summary Delete Aws Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAwsAccountApiV1AwsAccountsAccountIdDelete(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAwsAccountApiV1AwsAccountsAccountIdDelete(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AwsAccountsApi.deleteAwsAccountApiV1AwsAccountsAccountIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single AWS account by ID.
         * @summary Get Aws Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAwsAccountApiV1AwsAccountsAccountIdGet(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AWSAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAwsAccountApiV1AwsAccountsAccountIdGet(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AwsAccountsApi.getAwsAccountApiV1AwsAccountsAccountIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all AWS accounts that can be used as deployment targets.
         * @summary Get Aws Accounts
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [includeDisabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAwsAccountsApiV1AwsAccountsGet(skip?: number, limit?: number, includeDisabled?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AWSAccount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAwsAccountsApiV1AwsAccountsGet(skip, limit, includeDisabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AwsAccountsApi.getAwsAccountsApiV1AwsAccountsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a capacity report showing usage per region and expansion recommendations. When any region hits the threshold, calculates expansion needed for ALL regions to reach target_max_usage. Recommends enabling regions on existing accounts and/or provisioning new accounts as needed.
         * @summary Get Capacity Report
         * @param {number} [threshold] 
         * @param {number} [targetMaxUsage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCapacityReportApiV1AwsAccountsCapacityReportGet(threshold?: number, targetMaxUsage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CapacityReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCapacityReportApiV1AwsAccountsCapacityReportGet(threshold, targetMaxUsage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AwsAccountsApi.getCapacityReportApiV1AwsAccountsCapacityReportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an AWS account.
         * @summary Update Aws Account
         * @param {string} accountId 
         * @param {AWSAccountUpdate} aWSAccountUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAwsAccountApiV1AwsAccountsAccountIdPatch(accountId: string, aWSAccountUpdate: AWSAccountUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AWSAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAwsAccountApiV1AwsAccountsAccountIdPatch(accountId, aWSAccountUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AwsAccountsApi.updateAwsAccountApiV1AwsAccountsAccountIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AwsAccountsApi - factory interface
 * @export
 */
export const AwsAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AwsAccountsApiFp(configuration)
    return {
        /**
         * Create a new AWS account.
         * @summary Create Aws Account
         * @param {AWSAccountCreate} aWSAccountCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAwsAccountApiV1AwsAccountsPost(aWSAccountCreate: AWSAccountCreate, options?: any): AxiosPromise<AWSAccount> {
            return localVarFp.createAwsAccountApiV1AwsAccountsPost(aWSAccountCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an AWS account.
         * @summary Delete Aws Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAwsAccountApiV1AwsAccountsAccountIdDelete(accountId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAwsAccountApiV1AwsAccountsAccountIdDelete(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single AWS account by ID.
         * @summary Get Aws Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAwsAccountApiV1AwsAccountsAccountIdGet(accountId: string, options?: any): AxiosPromise<AWSAccount> {
            return localVarFp.getAwsAccountApiV1AwsAccountsAccountIdGet(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all AWS accounts that can be used as deployment targets.
         * @summary Get Aws Accounts
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [includeDisabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAwsAccountsApiV1AwsAccountsGet(skip?: number, limit?: number, includeDisabled?: boolean, options?: any): AxiosPromise<Array<AWSAccount>> {
            return localVarFp.getAwsAccountsApiV1AwsAccountsGet(skip, limit, includeDisabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a capacity report showing usage per region and expansion recommendations. When any region hits the threshold, calculates expansion needed for ALL regions to reach target_max_usage. Recommends enabling regions on existing accounts and/or provisioning new accounts as needed.
         * @summary Get Capacity Report
         * @param {number} [threshold] 
         * @param {number} [targetMaxUsage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapacityReportApiV1AwsAccountsCapacityReportGet(threshold?: number, targetMaxUsage?: number, options?: any): AxiosPromise<CapacityReport> {
            return localVarFp.getCapacityReportApiV1AwsAccountsCapacityReportGet(threshold, targetMaxUsage, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an AWS account.
         * @summary Update Aws Account
         * @param {string} accountId 
         * @param {AWSAccountUpdate} aWSAccountUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAwsAccountApiV1AwsAccountsAccountIdPatch(accountId: string, aWSAccountUpdate: AWSAccountUpdate, options?: any): AxiosPromise<AWSAccount> {
            return localVarFp.updateAwsAccountApiV1AwsAccountsAccountIdPatch(accountId, aWSAccountUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AwsAccountsApi - object-oriented interface
 * @export
 * @class AwsAccountsApi
 * @extends {BaseAPI}
 */
export class AwsAccountsApi extends BaseAPI {
    /**
     * Create a new AWS account.
     * @summary Create Aws Account
     * @param {AWSAccountCreate} aWSAccountCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsAccountsApi
     */
    public createAwsAccountApiV1AwsAccountsPost(aWSAccountCreate: AWSAccountCreate, options?: RawAxiosRequestConfig) {
        return AwsAccountsApiFp(this.configuration).createAwsAccountApiV1AwsAccountsPost(aWSAccountCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an AWS account.
     * @summary Delete Aws Account
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsAccountsApi
     */
    public deleteAwsAccountApiV1AwsAccountsAccountIdDelete(accountId: string, options?: RawAxiosRequestConfig) {
        return AwsAccountsApiFp(this.configuration).deleteAwsAccountApiV1AwsAccountsAccountIdDelete(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single AWS account by ID.
     * @summary Get Aws Account
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsAccountsApi
     */
    public getAwsAccountApiV1AwsAccountsAccountIdGet(accountId: string, options?: RawAxiosRequestConfig) {
        return AwsAccountsApiFp(this.configuration).getAwsAccountApiV1AwsAccountsAccountIdGet(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all AWS accounts that can be used as deployment targets.
     * @summary Get Aws Accounts
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [includeDisabled] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsAccountsApi
     */
    public getAwsAccountsApiV1AwsAccountsGet(skip?: number, limit?: number, includeDisabled?: boolean, options?: RawAxiosRequestConfig) {
        return AwsAccountsApiFp(this.configuration).getAwsAccountsApiV1AwsAccountsGet(skip, limit, includeDisabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a capacity report showing usage per region and expansion recommendations. When any region hits the threshold, calculates expansion needed for ALL regions to reach target_max_usage. Recommends enabling regions on existing accounts and/or provisioning new accounts as needed.
     * @summary Get Capacity Report
     * @param {number} [threshold] 
     * @param {number} [targetMaxUsage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsAccountsApi
     */
    public getCapacityReportApiV1AwsAccountsCapacityReportGet(threshold?: number, targetMaxUsage?: number, options?: RawAxiosRequestConfig) {
        return AwsAccountsApiFp(this.configuration).getCapacityReportApiV1AwsAccountsCapacityReportGet(threshold, targetMaxUsage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an AWS account.
     * @summary Update Aws Account
     * @param {string} accountId 
     * @param {AWSAccountUpdate} aWSAccountUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AwsAccountsApi
     */
    public updateAwsAccountApiV1AwsAccountsAccountIdPatch(accountId: string, aWSAccountUpdate: AWSAccountUpdate, options?: RawAxiosRequestConfig) {
        return AwsAccountsApiFp(this.configuration).updateAwsAccountApiV1AwsAccountsAccountIdPatch(accountId, aWSAccountUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallbackApi - axios parameter creator
 * @export
 */
export const CallbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * TODO: Use propper auth here. Even better, use a queue to communicate.  Currently you have to know the flow UUID to be able to call this endpoint.
         * @summary Operator Callback
         * @param {OperatorCallbackPayload} operatorCallbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operatorCallbackApiV1CallbackPost: async (operatorCallbackPayload: OperatorCallbackPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operatorCallbackPayload' is not null or undefined
            assertParamExists('operatorCallbackApiV1CallbackPost', 'operatorCallbackPayload', operatorCallbackPayload)
            const localVarPath = `/api/v1/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatorCallbackPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbackApi - functional programming interface
 * @export
 */
export const CallbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbackApiAxiosParamCreator(configuration)
    return {
        /**
         * TODO: Use propper auth here. Even better, use a queue to communicate.  Currently you have to know the flow UUID to be able to call this endpoint.
         * @summary Operator Callback
         * @param {OperatorCallbackPayload} operatorCallbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operatorCallbackApiV1CallbackPost(operatorCallbackPayload: OperatorCallbackPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operatorCallbackApiV1CallbackPost(operatorCallbackPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbackApi.operatorCallbackApiV1CallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallbackApi - factory interface
 * @export
 */
export const CallbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbackApiFp(configuration)
    return {
        /**
         * TODO: Use propper auth here. Even better, use a queue to communicate.  Currently you have to know the flow UUID to be able to call this endpoint.
         * @summary Operator Callback
         * @param {OperatorCallbackPayload} operatorCallbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operatorCallbackApiV1CallbackPost(operatorCallbackPayload: OperatorCallbackPayload, options?: any): AxiosPromise<any> {
            return localVarFp.operatorCallbackApiV1CallbackPost(operatorCallbackPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallbackApi - object-oriented interface
 * @export
 * @class CallbackApi
 * @extends {BaseAPI}
 */
export class CallbackApi extends BaseAPI {
    /**
     * TODO: Use propper auth here. Even better, use a queue to communicate.  Currently you have to know the flow UUID to be able to call this endpoint.
     * @summary Operator Callback
     * @param {OperatorCallbackPayload} operatorCallbackPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackApi
     */
    public operatorCallbackApiV1CallbackPost(operatorCallbackPayload: OperatorCallbackPayload, options?: RawAxiosRequestConfig) {
        return CallbackApiFp(this.configuration).operatorCallbackApiV1CallbackPost(operatorCallbackPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChartsApi - axios parameter creator
 * @export
 */
export const ChartsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Chart
         * @param {ChartCreateRequest} chartCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChartApiV1ChartsPost: async (chartCreateRequest: ChartCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chartCreateRequest' is not null or undefined
            assertParamExists('createChartApiV1ChartsPost', 'chartCreateRequest', chartCreateRequest)
            const localVarPath = `/api/v1/charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chartCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Chart By Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChartByIdApiV1ChartsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteChartByIdApiV1ChartsIdDelete', 'id', id)
            const localVarPath = `/api/v1/charts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Chart
         * @param {string} chartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChartApiV1ChartsChartIdGet: async (chartId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chartId' is not null or undefined
            assertParamExists('getChartApiV1ChartsChartIdGet', 'chartId', chartId)
            const localVarPath = `/api/v1/charts/{chart_id}`
                .replace(`{${"chart_id"}}`, encodeURIComponent(String(chartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Charts
         * @param {ChartResourceType} resourceType 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChartsApiV1ChartsGet: async (resourceType: ChartResourceType, resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('getChartsApiV1ChartsGet', 'resourceType', resourceType)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getChartsApiV1ChartsGet', 'resourceId', resourceId)
            const localVarPath = `/api/v1/charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resource_id'] = resourceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all node charts for a given flow version - Used to do eager loading of charts in the router - Can be used by FE to get all charts for a given flow version
         * @summary Get Nodes Charts By Flow Version Id
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet: async (flowVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v1/charts/flow_versions/{flow_version_id}/charts`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch Chart By Id
         * @param {string} id 
         * @param {ChartPatch} chartPatch 
         * @param {string} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchChartByIdApiV1ChartsIdPatch: async (id: string, chartPatch: ChartPatch, ifMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchChartByIdApiV1ChartsIdPatch', 'id', id)
            // verify required parameter 'chartPatch' is not null or undefined
            assertParamExists('patchChartByIdApiV1ChartsIdPatch', 'chartPatch', chartPatch)
            const localVarPath = `/api/v1/charts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chartPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder Charts
         * @param {ChartReorder} chartReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderChartsApiV1ChartsOrderPatch: async (chartReorder: ChartReorder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chartReorder' is not null or undefined
            assertParamExists('reorderChartsApiV1ChartsOrderPatch', 'chartReorder', chartReorder)
            const localVarPath = `/api/v1/charts/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chartReorder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChartsApi - functional programming interface
 * @export
 */
export const ChartsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChartsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Chart
         * @param {ChartCreateRequest} chartCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChartApiV1ChartsPost(chartCreateRequest: ChartCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChartApiV1ChartsPost(chartCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.createChartApiV1ChartsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Chart By Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChartByIdApiV1ChartsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChartByIdApiV1ChartsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.deleteChartByIdApiV1ChartsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Chart
         * @param {string} chartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChartApiV1ChartsChartIdGet(chartId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChartApiV1ChartsChartIdGet(chartId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.getChartApiV1ChartsChartIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Charts
         * @param {ChartResourceType} resourceType 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChartsApiV1ChartsGet(resourceType: ChartResourceType, resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Chart>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChartsApiV1ChartsGet(resourceType, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.getChartsApiV1ChartsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all node charts for a given flow version - Used to do eager loading of charts in the router - Can be used by FE to get all charts for a given flow version
         * @summary Get Nodes Charts By Flow Version Id
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet(flowVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Chart>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet(flowVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch Chart By Id
         * @param {string} id 
         * @param {ChartPatch} chartPatch 
         * @param {string} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchChartByIdApiV1ChartsIdPatch(id: string, chartPatch: ChartPatch, ifMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchChartByIdApiV1ChartsIdPatch(id, chartPatch, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.patchChartByIdApiV1ChartsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder Charts
         * @param {ChartReorder} chartReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderChartsApiV1ChartsOrderPatch(chartReorder: ChartReorder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderChartsApiV1ChartsOrderPatch(chartReorder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChartsApi.reorderChartsApiV1ChartsOrderPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChartsApi - factory interface
 * @export
 */
export const ChartsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChartsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Chart
         * @param {ChartCreateRequest} chartCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChartApiV1ChartsPost(chartCreateRequest: ChartCreateRequest, options?: any): AxiosPromise<Chart> {
            return localVarFp.createChartApiV1ChartsPost(chartCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Chart By Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChartByIdApiV1ChartsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteChartByIdApiV1ChartsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Chart
         * @param {string} chartId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChartApiV1ChartsChartIdGet(chartId: string, options?: any): AxiosPromise<Chart> {
            return localVarFp.getChartApiV1ChartsChartIdGet(chartId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Charts
         * @param {ChartResourceType} resourceType 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChartsApiV1ChartsGet(resourceType: ChartResourceType, resourceId: string, options?: any): AxiosPromise<Array<Chart>> {
            return localVarFp.getChartsApiV1ChartsGet(resourceType, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all node charts for a given flow version - Used to do eager loading of charts in the router - Can be used by FE to get all charts for a given flow version
         * @summary Get Nodes Charts By Flow Version Id
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet(flowVersionId: string, options?: any): AxiosPromise<Array<Chart>> {
            return localVarFp.getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet(flowVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch Chart By Id
         * @param {string} id 
         * @param {ChartPatch} chartPatch 
         * @param {string} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchChartByIdApiV1ChartsIdPatch(id: string, chartPatch: ChartPatch, ifMatch?: string, options?: any): AxiosPromise<Chart> {
            return localVarFp.patchChartByIdApiV1ChartsIdPatch(id, chartPatch, ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder Charts
         * @param {ChartReorder} chartReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderChartsApiV1ChartsOrderPatch(chartReorder: ChartReorder, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.reorderChartsApiV1ChartsOrderPatch(chartReorder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChartsApi - object-oriented interface
 * @export
 * @class ChartsApi
 * @extends {BaseAPI}
 */
export class ChartsApi extends BaseAPI {
    /**
     * 
     * @summary Create Chart
     * @param {ChartCreateRequest} chartCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public createChartApiV1ChartsPost(chartCreateRequest: ChartCreateRequest, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).createChartApiV1ChartsPost(chartCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Chart By Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public deleteChartByIdApiV1ChartsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).deleteChartByIdApiV1ChartsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Chart
     * @param {string} chartId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public getChartApiV1ChartsChartIdGet(chartId: string, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).getChartApiV1ChartsChartIdGet(chartId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Charts
     * @param {ChartResourceType} resourceType 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public getChartsApiV1ChartsGet(resourceType: ChartResourceType, resourceId: string, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).getChartsApiV1ChartsGet(resourceType, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all node charts for a given flow version - Used to do eager loading of charts in the router - Can be used by FE to get all charts for a given flow version
     * @summary Get Nodes Charts By Flow Version Id
     * @param {string} flowVersionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet(flowVersionId: string, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).getNodesChartsByFlowVersionIdApiV1ChartsFlowVersionsFlowVersionIdChartsGet(flowVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch Chart By Id
     * @param {string} id 
     * @param {ChartPatch} chartPatch 
     * @param {string} [ifMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public patchChartByIdApiV1ChartsIdPatch(id: string, chartPatch: ChartPatch, ifMatch?: string, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).patchChartByIdApiV1ChartsIdPatch(id, chartPatch, ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder Charts
     * @param {ChartReorder} chartReorder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartsApi
     */
    public reorderChartsApiV1ChartsOrderPatch(chartReorder: ChartReorder, options?: RawAxiosRequestConfig) {
        return ChartsApiFp(this.configuration).reorderChartsApiV1ChartsOrderPatch(chartReorder, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Comment
         * @param {string} commentId 
         * @param {CommentCreate} commentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentApiV1CommentsCommentIdPut: async (commentId: string, commentCreate: CommentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('createCommentApiV1CommentsCommentIdPut', 'commentId', commentId)
            // verify required parameter 'commentCreate' is not null or undefined
            assertParamExists('createCommentApiV1CommentsCommentIdPut', 'commentCreate', commentCreate)
            const localVarPath = `/api/v1/comments/{comment_id}`
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Comment
         * @param {string} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentApiV1CommentsCommentIdDelete: async (commentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('deleteCommentApiV1CommentsCommentIdDelete', 'commentId', commentId)
            const localVarPath = `/api/v1/comments/{comment_id}`
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query comments for a flow version. It does not include replies.
         * @summary Get Comments
         * @param {string} flowVersionId 
         * @param {CommentResourceType} [resourceType] 
         * @param {string} [resourceId] 
         * @param {string} [createdBefore] 
         * @param {boolean} [resolved] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsApiV1CommentsGet: async (flowVersionId: string, resourceType?: CommentResourceType, resourceId?: string, createdBefore?: string, resolved?: boolean, search?: string, skip?: number, limit?: number, ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getCommentsApiV1CommentsGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v1/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowVersionId !== undefined) {
                localVarQueryParameter['flow_version_id'] = flowVersionId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resource_id'] = resourceId;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString() :
                    createdBefore;
            }

            if (resolved !== undefined) {
                localVarQueryParameter['resolved'] = resolved;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Comments Summary
         * @param {string} flowVersionId 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet: async (flowVersionId: string, ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v1/comments/summary/{flow_version_id}`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Replies
         * @param {string} commentId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepliesApiV1CommentsCommentIdRepliesGet: async (commentId: string, skip?: number, limit?: number, ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('getRepliesApiV1CommentsCommentIdRepliesGet', 'commentId', commentId)
            const localVarPath = `/api/v1/comments/{comment_id}/replies`
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Comment
         * @param {string} commentId 
         * @param {CommentUpdate} commentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentApiV1CommentsCommentIdPatch: async (commentId: string, commentUpdate: CommentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('updateCommentApiV1CommentsCommentIdPatch', 'commentId', commentId)
            // verify required parameter 'commentUpdate' is not null or undefined
            assertParamExists('updateCommentApiV1CommentsCommentIdPatch', 'commentUpdate', commentUpdate)
            const localVarPath = `/api/v1/comments/{comment_id}`
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Comment
         * @param {string} commentId 
         * @param {CommentCreate} commentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommentApiV1CommentsCommentIdPut(commentId: string, commentCreate: CommentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommentApiV1CommentsCommentIdPut(commentId, commentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.createCommentApiV1CommentsCommentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Comment
         * @param {string} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommentApiV1CommentsCommentIdDelete(commentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommentApiV1CommentsCommentIdDelete(commentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.deleteCommentApiV1CommentsCommentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query comments for a flow version. It does not include replies.
         * @summary Get Comments
         * @param {string} flowVersionId 
         * @param {CommentResourceType} [resourceType] 
         * @param {string} [resourceId] 
         * @param {string} [createdBefore] 
         * @param {boolean} [resolved] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentsApiV1CommentsGet(flowVersionId: string, resourceType?: CommentResourceType, resourceId?: string, createdBefore?: string, resolved?: boolean, search?: string, skip?: number, limit?: number, ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommentDb>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentsApiV1CommentsGet(flowVersionId, resourceType, resourceId, createdBefore, resolved, search, skip, limit, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.getCommentsApiV1CommentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Comments Summary
         * @param {string} flowVersionId 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet(flowVersionId: string, ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet(flowVersionId, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Replies
         * @param {string} commentId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepliesApiV1CommentsCommentIdRepliesGet(commentId: string, skip?: number, limit?: number, ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommentDb>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepliesApiV1CommentsCommentIdRepliesGet(commentId, skip, limit, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.getRepliesApiV1CommentsCommentIdRepliesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Comment
         * @param {string} commentId 
         * @param {CommentUpdate} commentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommentApiV1CommentsCommentIdPatch(commentId: string, commentUpdate: CommentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommentApiV1CommentsCommentIdPatch(commentId, commentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.updateCommentApiV1CommentsCommentIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Comment
         * @param {string} commentId 
         * @param {CommentCreate} commentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentApiV1CommentsCommentIdPut(commentId: string, commentCreate: CommentCreate, options?: any): AxiosPromise<CommentDb> {
            return localVarFp.createCommentApiV1CommentsCommentIdPut(commentId, commentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Comment
         * @param {string} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentApiV1CommentsCommentIdDelete(commentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteCommentApiV1CommentsCommentIdDelete(commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query comments for a flow version. It does not include replies.
         * @summary Get Comments
         * @param {string} flowVersionId 
         * @param {CommentResourceType} [resourceType] 
         * @param {string} [resourceId] 
         * @param {string} [createdBefore] 
         * @param {boolean} [resolved] 
         * @param {string} [search] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsApiV1CommentsGet(flowVersionId: string, resourceType?: CommentResourceType, resourceId?: string, createdBefore?: string, resolved?: boolean, search?: string, skip?: number, limit?: number, ifNoneMatch?: string, options?: any): AxiosPromise<Array<CommentDb>> {
            return localVarFp.getCommentsApiV1CommentsGet(flowVersionId, resourceType, resourceId, createdBefore, resolved, search, skip, limit, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Comments Summary
         * @param {string} flowVersionId 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet(flowVersionId: string, ifNoneMatch?: string, options?: any): AxiosPromise<CommentSummary> {
            return localVarFp.getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet(flowVersionId, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Replies
         * @param {string} commentId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepliesApiV1CommentsCommentIdRepliesGet(commentId: string, skip?: number, limit?: number, ifNoneMatch?: string, options?: any): AxiosPromise<Array<CommentDb>> {
            return localVarFp.getRepliesApiV1CommentsCommentIdRepliesGet(commentId, skip, limit, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Comment
         * @param {string} commentId 
         * @param {CommentUpdate} commentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentApiV1CommentsCommentIdPatch(commentId: string, commentUpdate: CommentUpdate, options?: any): AxiosPromise<CommentDb> {
            return localVarFp.updateCommentApiV1CommentsCommentIdPatch(commentId, commentUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI {
    /**
     * 
     * @summary Create Comment
     * @param {string} commentId 
     * @param {CommentCreate} commentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public createCommentApiV1CommentsCommentIdPut(commentId: string, commentCreate: CommentCreate, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).createCommentApiV1CommentsCommentIdPut(commentId, commentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Comment
     * @param {string} commentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public deleteCommentApiV1CommentsCommentIdDelete(commentId: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).deleteCommentApiV1CommentsCommentIdDelete(commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query comments for a flow version. It does not include replies.
     * @summary Get Comments
     * @param {string} flowVersionId 
     * @param {CommentResourceType} [resourceType] 
     * @param {string} [resourceId] 
     * @param {string} [createdBefore] 
     * @param {boolean} [resolved] 
     * @param {string} [search] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public getCommentsApiV1CommentsGet(flowVersionId: string, resourceType?: CommentResourceType, resourceId?: string, createdBefore?: string, resolved?: boolean, search?: string, skip?: number, limit?: number, ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).getCommentsApiV1CommentsGet(flowVersionId, resourceType, resourceId, createdBefore, resolved, search, skip, limit, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Comments Summary
     * @param {string} flowVersionId 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet(flowVersionId: string, ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).getCommentsSummaryApiV1CommentsSummaryFlowVersionIdGet(flowVersionId, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Replies
     * @param {string} commentId 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public getRepliesApiV1CommentsCommentIdRepliesGet(commentId: string, skip?: number, limit?: number, ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).getRepliesApiV1CommentsCommentIdRepliesGet(commentId, skip, limit, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Comment
     * @param {string} commentId 
     * @param {CommentUpdate} commentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public updateCommentApiV1CommentsCommentIdPatch(commentId: string, commentUpdate: CommentUpdate, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).updateCommentApiV1CommentsCommentIdPatch(commentId, commentUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Healthz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthzHealthzGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Info
         * @param {boolean} [includeAlembicRevision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoInfoGet: async (includeAlembicRevision?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeAlembicRevision !== undefined) {
                localVarQueryParameter['include_alembic_revision'] = includeAlembicRevision;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Healthz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthzHealthzGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthzHealthzGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthzHealthzGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Info
         * @param {boolean} [includeAlembicRevision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoInfoGet(includeAlembicRevision?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoInfoGet(includeAlembicRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.infoInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Healthz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthzHealthzGet(options?: any): AxiosPromise<void> {
            return localVarFp.healthzHealthzGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Info
         * @param {boolean} [includeAlembicRevision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoInfoGet(includeAlembicRevision?: boolean, options?: any): AxiosPromise<any> {
            return localVarFp.infoInfoGet(includeAlembicRevision, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Healthz
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthzHealthzGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthzHealthzGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Info
     * @param {boolean} [includeAlembicRevision] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public infoInfoGet(includeAlembicRevision?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).infoInfoGet(includeAlembicRevision, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FlowVersionsApi - axios parameter creator
 * @export
 */
export const FlowVersionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Flow Version
         * @param {FlowVersionCreate} flowVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowVersionApiV1FlowVersionsPost: async (flowVersionCreate: FlowVersionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionCreate' is not null or undefined
            assertParamExists('createFlowVersionApiV1FlowVersionsPost', 'flowVersionCreate', flowVersionCreate)
            const localVarPath = `/api/v1/flow_versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowVersionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Flow Version
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowVersionApiV1FlowVersionsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFlowVersionApiV1FlowVersionsIdDelete', 'id', id)
            const localVarPath = `/api/v1/flow_versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate
         * @param {string} id 
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateApiV1FlowVersionsIdDuplicatePost: async (id: string, data: Data, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('duplicateApiV1FlowVersionsIdDuplicatePost', 'id', id)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('duplicateApiV1FlowVersionsIdDuplicatePost', 'data', data)
            const localVarPath = `/api/v1/flow_versions/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of user IDs who have contributed to the flow version (made changes). This includes users who authored change logs for this flow version.
         * @summary Get Contributors
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorsApiV1FlowVersionsContributorsGet: async (flowVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getContributorsApiV1FlowVersionsContributorsGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v1/flow_versions/contributors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowVersionId !== undefined) {
                localVarQueryParameter['flow_version_id'] = flowVersionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Of Flow Version
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet: async (id: string, ifMatch?: any, ifNoneMatch?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet', 'id', id)
            const localVarPath = `/api/v1/flow_versions/{id}/flow`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = typeof ifMatch === 'string'
                    ? ifMatch
                    : JSON.stringify(ifMatch);
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = typeof ifNoneMatch === 'string'
                    ? ifNoneMatch
                    : JSON.stringify(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Version
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionApiV1FlowVersionsIdGet: async (id: string, ifMatch?: any, ifNoneMatch?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFlowVersionApiV1FlowVersionsIdGet', 'id', id)
            const localVarPath = `/api/v1/flow_versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = typeof ifMatch === 'string'
                    ? ifMatch
                    : JSON.stringify(ifMatch);
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = typeof ifNoneMatch === 'string'
                    ? ifNoneMatch
                    : JSON.stringify(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Version Changes
         * @param {string} flowVersionId 
         * @param {string} [afterEtag] 
         * @param {string} [beforeEtag] 
         * @param {number} [skip] 
         * @param {number} [maxLimit] 
         * @param {number} [aggregationTime] 
         * @param {boolean} [includeLogic] 
         * @param {boolean} [includeReviewComments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet: async (flowVersionId: string, afterEtag?: string, beforeEtag?: string, skip?: number, maxLimit?: number, aggregationTime?: number, includeLogic?: boolean, includeReviewComments?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v2/flow_versions/{flow_version_id}/changes`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (afterEtag !== undefined) {
                localVarQueryParameter['after_etag'] = afterEtag;
            }

            if (beforeEtag !== undefined) {
                localVarQueryParameter['before_etag'] = beforeEtag;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (maxLimit !== undefined) {
                localVarQueryParameter['max_limit'] = maxLimit;
            }

            if (aggregationTime !== undefined) {
                localVarQueryParameter['aggregation_time'] = aggregationTime;
            }

            if (includeLogic !== undefined) {
                localVarQueryParameter['include_logic'] = includeLogic;
            }

            if (includeReviewComments !== undefined) {
                localVarQueryParameter['include_review_comments'] = includeReviewComments;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Version Mockable Nodes
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet: async (flowVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v2/flow_versions/{flow_version_id}/mockable_nodes`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Version Revision
         * @param {string} flowVersionId 
         * @param {string} etag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet: async (flowVersionId: string, etag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'etag' is not null or undefined
            assertParamExists('getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet', 'etag', etag)
            const localVarPath = `/api/v2/flow_versions/{flow_version_id}/revision/{etag}`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"etag"}}`, encodeURIComponent(String(etag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get revision connect nodes. Used on the exporter to get the connect nodes of a specific revision, without exposing more than necessary information to the reviewer. This allows us to check only the workspace resource permission.
         * @summary Get Flow Version Revision Connect Nodes
         * @param {string} flowVersionId 
         * @param {string} etag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet: async (flowVersionId: string, etag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'etag' is not null or undefined
            assertParamExists('getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet', 'etag', etag)
            const localVarPath = `/api/v2/flow_versions/{flow_version_id}/revision/{etag}/graph/connect_nodes`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"etag"}}`, encodeURIComponent(String(etag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow Version V2
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionV2ApiV2FlowVersionsIdGet: async (id: string, ifMatch?: any, ifNoneMatch?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFlowVersionV2ApiV2FlowVersionsIdGet', 'id', id)
            const localVarPath = `/api/v2/flow_versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = typeof ifMatch === 'string'
                    ? ifMatch
                    : JSON.stringify(ifMatch);
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = typeof ifNoneMatch === 'string'
                    ? ifNoneMatch
                    : JSON.stringify(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Flow Version
         * @param {string} id 
         * @param {string} byEtag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFlowVersionApiV2FlowVersionsIdPut: async (id: string, byEtag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putFlowVersionApiV2FlowVersionsIdPut', 'id', id)
            // verify required parameter 'byEtag' is not null or undefined
            assertParamExists('putFlowVersionApiV2FlowVersionsIdPut', 'byEtag', byEtag)
            const localVarPath = `/api/v2/flow_versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (byEtag !== undefined) {
                localVarQueryParameter['by_etag'] = byEtag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a flow version Supports deep partial updates of the inner graph resource using a JSON MERGE PATCH see https://bit.ly/3mOv0ac
         * @summary Update Flow Version
         * @param {string} id 
         * @param {FlowVersionUpdate} flowVersionUpdate 
         * @param {boolean} [enableTrafficPolicies] 
         * @param {string} [session] 
         * @param {string} [ifMatch] 
         * @param {string} [xIfMatch] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowVersionApiV1FlowVersionsIdPatch: async (id: string, flowVersionUpdate: FlowVersionUpdate, enableTrafficPolicies?: boolean, session?: string, ifMatch?: string, xIfMatch?: string, ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFlowVersionApiV1FlowVersionsIdPatch', 'id', id)
            // verify required parameter 'flowVersionUpdate' is not null or undefined
            assertParamExists('updateFlowVersionApiV1FlowVersionsIdPatch', 'flowVersionUpdate', flowVersionUpdate)
            const localVarPath = `/api/v1/flow_versions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (enableTrafficPolicies !== undefined) {
                localVarQueryParameter['enable_traffic_policies'] = enableTrafficPolicies;
            }

            if (session != null) {
                localVarHeaderParameter['session'] = String(session);
            }

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }

            if (xIfMatch != null) {
                localVarHeaderParameter['x-if-match'] = String(xIfMatch);
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowVersionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowVersionsApi - functional programming interface
 * @export
 */
export const FlowVersionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlowVersionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Flow Version
         * @param {FlowVersionCreate} flowVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFlowVersionApiV1FlowVersionsPost(flowVersionCreate: FlowVersionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFlowVersionApiV1FlowVersionsPost(flowVersionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.createFlowVersionApiV1FlowVersionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Flow Version
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFlowVersionApiV1FlowVersionsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFlowVersionApiV1FlowVersionsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.deleteFlowVersionApiV1FlowVersionsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate
         * @param {string} id 
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateApiV1FlowVersionsIdDuplicatePost(id: string, data: Data, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateApiV1FlowVersionsIdDuplicatePost(id, data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.duplicateApiV1FlowVersionsIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of user IDs who have contributed to the flow version (made changes). This includes users who authored change logs for this flow version.
         * @summary Get Contributors
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContributorsApiV1FlowVersionsContributorsGet(flowVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionContributors>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContributorsApiV1FlowVersionsContributorsGet(flowVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getContributorsApiV1FlowVersionsContributorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Of Flow Version
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowDbShallow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet(id, ifMatch, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Version
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionApiV1FlowVersionsIdGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionApiV1FlowVersionsIdGet(id, ifMatch, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowVersionApiV1FlowVersionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Version Changes
         * @param {string} flowVersionId 
         * @param {string} [afterEtag] 
         * @param {string} [beforeEtag] 
         * @param {number} [skip] 
         * @param {number} [maxLimit] 
         * @param {number} [aggregationTime] 
         * @param {boolean} [includeLogic] 
         * @param {boolean} [includeReviewComments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet(flowVersionId: string, afterEtag?: string, beforeEtag?: string, skip?: number, maxLimit?: number, aggregationTime?: number, includeLogic?: boolean, includeReviewComments?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChangeLogDb>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet(flowVersionId, afterEtag, beforeEtag, skip, maxLimit, aggregationTime, includeLogic, includeReviewComments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Version Mockable Nodes
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet(flowVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NodeDb>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet(flowVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Version Revision
         * @param {string} flowVersionId 
         * @param {string} etag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet(flowVersionId: string, etag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet(flowVersionId, etag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get revision connect nodes. Used on the exporter to get the connect nodes of a specific revision, without exposing more than necessary information to the reviewer. This allows us to check only the workspace resource permission.
         * @summary Get Flow Version Revision Connect Nodes
         * @param {string} flowVersionId 
         * @param {string} etag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet(flowVersionId: string, etag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectNodeBasic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet(flowVersionId, etag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow Version V2
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowVersionV2ApiV2FlowVersionsIdGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowVersionV2ApiV2FlowVersionsIdGet(id, ifMatch, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.getFlowVersionV2ApiV2FlowVersionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Flow Version
         * @param {string} id 
         * @param {string} byEtag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFlowVersionApiV2FlowVersionsIdPut(id: string, byEtag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFlowVersionApiV2FlowVersionsIdPut(id, byEtag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.putFlowVersionApiV2FlowVersionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a flow version Supports deep partial updates of the inner graph resource using a JSON MERGE PATCH see https://bit.ly/3mOv0ac
         * @summary Update Flow Version
         * @param {string} id 
         * @param {FlowVersionUpdate} flowVersionUpdate 
         * @param {boolean} [enableTrafficPolicies] 
         * @param {string} [session] 
         * @param {string} [ifMatch] 
         * @param {string} [xIfMatch] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFlowVersionApiV1FlowVersionsIdPatch(id: string, flowVersionUpdate: FlowVersionUpdate, enableTrafficPolicies?: boolean, session?: string, ifMatch?: string, xIfMatch?: string, ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowVersionDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFlowVersionApiV1FlowVersionsIdPatch(id, flowVersionUpdate, enableTrafficPolicies, session, ifMatch, xIfMatch, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowVersionsApi.updateFlowVersionApiV1FlowVersionsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FlowVersionsApi - factory interface
 * @export
 */
export const FlowVersionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlowVersionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Flow Version
         * @param {FlowVersionCreate} flowVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowVersionApiV1FlowVersionsPost(flowVersionCreate: FlowVersionCreate, options?: any): AxiosPromise<FlowVersionDb> {
            return localVarFp.createFlowVersionApiV1FlowVersionsPost(flowVersionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Flow Version
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowVersionApiV1FlowVersionsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFlowVersionApiV1FlowVersionsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate
         * @param {string} id 
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateApiV1FlowVersionsIdDuplicatePost(id: string, data: Data, options?: any): AxiosPromise<FlowVersionDb> {
            return localVarFp.duplicateApiV1FlowVersionsIdDuplicatePost(id, data, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of user IDs who have contributed to the flow version (made changes). This includes users who authored change logs for this flow version.
         * @summary Get Contributors
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorsApiV1FlowVersionsContributorsGet(flowVersionId: string, options?: any): AxiosPromise<FlowVersionContributors> {
            return localVarFp.getContributorsApiV1FlowVersionsContributorsGet(flowVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Of Flow Version
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: any): AxiosPromise<FlowDbShallow> {
            return localVarFp.getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet(id, ifMatch, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Version
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionApiV1FlowVersionsIdGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: any): AxiosPromise<FlowVersionDb> {
            return localVarFp.getFlowVersionApiV1FlowVersionsIdGet(id, ifMatch, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Version Changes
         * @param {string} flowVersionId 
         * @param {string} [afterEtag] 
         * @param {string} [beforeEtag] 
         * @param {number} [skip] 
         * @param {number} [maxLimit] 
         * @param {number} [aggregationTime] 
         * @param {boolean} [includeLogic] 
         * @param {boolean} [includeReviewComments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet(flowVersionId: string, afterEtag?: string, beforeEtag?: string, skip?: number, maxLimit?: number, aggregationTime?: number, includeLogic?: boolean, includeReviewComments?: boolean, options?: any): AxiosPromise<Array<ChangeLogDb>> {
            return localVarFp.getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet(flowVersionId, afterEtag, beforeEtag, skip, maxLimit, aggregationTime, includeLogic, includeReviewComments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Version Mockable Nodes
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet(flowVersionId: string, options?: any): AxiosPromise<Array<NodeDb>> {
            return localVarFp.getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet(flowVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Version Revision
         * @param {string} flowVersionId 
         * @param {string} etag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet(flowVersionId: string, etag: string, options?: any): AxiosPromise<FlowVersionV2> {
            return localVarFp.getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet(flowVersionId, etag, options).then((request) => request(axios, basePath));
        },
        /**
         * Get revision connect nodes. Used on the exporter to get the connect nodes of a specific revision, without exposing more than necessary information to the reviewer. This allows us to check only the workspace resource permission.
         * @summary Get Flow Version Revision Connect Nodes
         * @param {string} flowVersionId 
         * @param {string} etag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet(flowVersionId: string, etag: string, options?: any): AxiosPromise<Array<ConnectNodeBasic>> {
            return localVarFp.getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet(flowVersionId, etag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow Version V2
         * @param {string} id 
         * @param {any} [ifMatch] 
         * @param {any} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowVersionV2ApiV2FlowVersionsIdGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: any): AxiosPromise<FlowVersionV2> {
            return localVarFp.getFlowVersionV2ApiV2FlowVersionsIdGet(id, ifMatch, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Flow Version
         * @param {string} id 
         * @param {string} byEtag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFlowVersionApiV2FlowVersionsIdPut(id: string, byEtag: string, options?: any): AxiosPromise<FlowVersionV2> {
            return localVarFp.putFlowVersionApiV2FlowVersionsIdPut(id, byEtag, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a flow version Supports deep partial updates of the inner graph resource using a JSON MERGE PATCH see https://bit.ly/3mOv0ac
         * @summary Update Flow Version
         * @param {string} id 
         * @param {FlowVersionUpdate} flowVersionUpdate 
         * @param {boolean} [enableTrafficPolicies] 
         * @param {string} [session] 
         * @param {string} [ifMatch] 
         * @param {string} [xIfMatch] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowVersionApiV1FlowVersionsIdPatch(id: string, flowVersionUpdate: FlowVersionUpdate, enableTrafficPolicies?: boolean, session?: string, ifMatch?: string, xIfMatch?: string, ifNoneMatch?: string, options?: any): AxiosPromise<FlowVersionDb> {
            return localVarFp.updateFlowVersionApiV1FlowVersionsIdPatch(id, flowVersionUpdate, enableTrafficPolicies, session, ifMatch, xIfMatch, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowVersionsApi - object-oriented interface
 * @export
 * @class FlowVersionsApi
 * @extends {BaseAPI}
 */
export class FlowVersionsApi extends BaseAPI {
    /**
     * 
     * @summary Create Flow Version
     * @param {FlowVersionCreate} flowVersionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public createFlowVersionApiV1FlowVersionsPost(flowVersionCreate: FlowVersionCreate, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).createFlowVersionApiV1FlowVersionsPost(flowVersionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Flow Version
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public deleteFlowVersionApiV1FlowVersionsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).deleteFlowVersionApiV1FlowVersionsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate
     * @param {string} id 
     * @param {Data} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public duplicateApiV1FlowVersionsIdDuplicatePost(id: string, data: Data, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).duplicateApiV1FlowVersionsIdDuplicatePost(id, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of user IDs who have contributed to the flow version (made changes). This includes users who authored change logs for this flow version.
     * @summary Get Contributors
     * @param {string} flowVersionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getContributorsApiV1FlowVersionsContributorsGet(flowVersionId: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getContributorsApiV1FlowVersionsContributorsGet(flowVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Of Flow Version
     * @param {string} id 
     * @param {any} [ifMatch] 
     * @param {any} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowOfFlowVersionApiV1FlowVersionsIdFlowGet(id, ifMatch, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Version
     * @param {string} id 
     * @param {any} [ifMatch] 
     * @param {any} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowVersionApiV1FlowVersionsIdGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowVersionApiV1FlowVersionsIdGet(id, ifMatch, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Version Changes
     * @param {string} flowVersionId 
     * @param {string} [afterEtag] 
     * @param {string} [beforeEtag] 
     * @param {number} [skip] 
     * @param {number} [maxLimit] 
     * @param {number} [aggregationTime] 
     * @param {boolean} [includeLogic] 
     * @param {boolean} [includeReviewComments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet(flowVersionId: string, afterEtag?: string, beforeEtag?: string, skip?: number, maxLimit?: number, aggregationTime?: number, includeLogic?: boolean, includeReviewComments?: boolean, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowVersionChangesApiV2FlowVersionsFlowVersionIdChangesGet(flowVersionId, afterEtag, beforeEtag, skip, maxLimit, aggregationTime, includeLogic, includeReviewComments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Version Mockable Nodes
     * @param {string} flowVersionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet(flowVersionId: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowVersionMockableNodesApiV2FlowVersionsFlowVersionIdMockableNodesGet(flowVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Version Revision
     * @param {string} flowVersionId 
     * @param {string} etag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet(flowVersionId: string, etag: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowVersionRevisionApiV2FlowVersionsFlowVersionIdRevisionEtagGet(flowVersionId, etag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get revision connect nodes. Used on the exporter to get the connect nodes of a specific revision, without exposing more than necessary information to the reviewer. This allows us to check only the workspace resource permission.
     * @summary Get Flow Version Revision Connect Nodes
     * @param {string} flowVersionId 
     * @param {string} etag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet(flowVersionId: string, etag: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowVersionRevisionConnectNodesApiV2FlowVersionsFlowVersionIdRevisionEtagGraphConnectNodesGet(flowVersionId, etag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow Version V2
     * @param {string} id 
     * @param {any} [ifMatch] 
     * @param {any} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public getFlowVersionV2ApiV2FlowVersionsIdGet(id: string, ifMatch?: any, ifNoneMatch?: any, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).getFlowVersionV2ApiV2FlowVersionsIdGet(id, ifMatch, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Flow Version
     * @param {string} id 
     * @param {string} byEtag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public putFlowVersionApiV2FlowVersionsIdPut(id: string, byEtag: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).putFlowVersionApiV2FlowVersionsIdPut(id, byEtag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a flow version Supports deep partial updates of the inner graph resource using a JSON MERGE PATCH see https://bit.ly/3mOv0ac
     * @summary Update Flow Version
     * @param {string} id 
     * @param {FlowVersionUpdate} flowVersionUpdate 
     * @param {boolean} [enableTrafficPolicies] 
     * @param {string} [session] 
     * @param {string} [ifMatch] 
     * @param {string} [xIfMatch] 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowVersionsApi
     */
    public updateFlowVersionApiV1FlowVersionsIdPatch(id: string, flowVersionUpdate: FlowVersionUpdate, enableTrafficPolicies?: boolean, session?: string, ifMatch?: string, xIfMatch?: string, ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return FlowVersionsApiFp(this.configuration).updateFlowVersionApiV1FlowVersionsIdPatch(id, flowVersionUpdate, enableTrafficPolicies, session, ifMatch, xIfMatch, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FlowsApi - axios parameter creator
 * @export
 */
export const FlowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Flow
         * @param {FlowCreatePopulated} flowCreatePopulated 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowApiV1FlowsPost: async (flowCreatePopulated: FlowCreatePopulated, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowCreatePopulated' is not null or undefined
            assertParamExists('createFlowApiV1FlowsPost', 'flowCreatePopulated', flowCreatePopulated)
            const localVarPath = `/api/v1/flows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowCreatePopulated, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Flow
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowApiV1FlowsFlowIdDelete: async (flowId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('deleteFlowApiV1FlowsFlowIdDelete', 'flowId', flowId)
            const localVarPath = `/api/v1/flows/{flow_id}`
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Default Version Flow Docs
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet: async (flowId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet', 'flowId', flowId)
            const localVarPath = `/api/v1/flows/{flow_id}/docs`
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the active traffic policy summary for a flow. Only includes the information necessary for routing based on traffic policies.
         * @summary Get Flow Active Policy Summary
         * @param {string} workspaceId 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet: async (workspaceId: string, slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet', 'workspaceId', workspaceId)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet', 'slug', slug)
            const localVarPath = `/api/v1/flows/workspace_id/{workspace_id}/slug/{slug}/active_traffic_policy_summary`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Flow
         * @param {string} id 
         * @param {boolean} [includeArchivedFlowVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowApiV1FlowsIdGet: async (id: string, includeArchivedFlowVersions?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFlowApiV1FlowsIdGet', 'id', id)
            const localVarPath = `/api/v1/flows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (includeArchivedFlowVersions !== undefined) {
                localVarQueryParameter['include_archived_flow_versions'] = includeArchivedFlowVersions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of flows.  The `filter[type][one_of]` parameter can be used to filter flows by their type. It accepts a list of strings. - If the parameter is not provided, only flows with no type (i.e., type is NULL) are returned. - To fetch flows with no type, you can also pass `filter[type][one_of]=none`. - To fetch flows of a specific type, pass the type name (e.g., `filter[type][one_of]=case_flow`). - To fetch flows of multiple types, you can use a comma-separated list of types   (e.g., `filter[type][one_of]=case_flow,none`).  The `include_schemas` parameter controls whether flow version schemas are included: - If True, returns FlowVersionDbShallowWithSchemas (includes input_schema, output_schema) - If False (default), returns FlowVersionDbShallow (excludes schemas for better performance)
         * @summary Get Flows
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [workspaceId] 
         * @param {string} [flowFolderId] 
         * @param {GetFlowsApiV1FlowsGetOrderByEnum} [orderBy] 
         * @param {boolean} [includeInternalFlows] 
         * @param {boolean} [includeSchemas] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowsApiV1FlowsGet: async (skip?: number, limit?: number, workspaceId?: string, flowFolderId?: string, orderBy?: GetFlowsApiV1FlowsGetOrderByEnum, includeInternalFlows?: boolean, includeSchemas?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/flows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (workspaceId !== undefined) {
                localVarQueryParameter['workspace_id'] = workspaceId;
            }

            if (flowFolderId !== undefined) {
                localVarQueryParameter['flow_folder_id'] = flowFolderId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (includeInternalFlows !== undefined) {
                localVarQueryParameter['include_internal_flows'] = includeInternalFlows;
            }

            if (includeSchemas !== undefined) {
                localVarQueryParameter['include_schemas'] = includeSchemas;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Published Flows Using Resource
         * @param {string} workspaceId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet: async (workspaceId: string, resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet', 'workspaceId', workspaceId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet', 'resourceId', resourceId)
            const localVarPath = `/api/v1/flows/published_using_connect_resource/workspace/{workspace_id}/resource/{resource_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Versioned Flow Docs
         * @param {string} flowId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet: async (flowId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet', 'flowId', flowId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet', 'versionId', versionId)
            const localVarPath = `/api/v1/flows/{flow_id}/versions/{version_id}/docs`
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Workspace Flow By Id
         * @param {string} workspaceId 
         * @param {string} flowId 
         * @param {string} [versionNameFilter] 
         * @param {string} [versionIdFilter] 
         * @param {boolean} [defaultVersionFilter] 
         * @param {boolean} [defaultSandboxVersionFilter] 
         * @param {string} [minFlowVersionEtagFilter] 
         * @param {boolean} [shallow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet: async (workspaceId: string, flowId: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet', 'workspaceId', workspaceId)
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet', 'flowId', flowId)
            const localVarPath = `/api/v1/flows/workspace_id/{workspace_id}/id/{flow_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (versionNameFilter !== undefined) {
                localVarQueryParameter['version_name_filter'] = versionNameFilter;
            }

            if (versionIdFilter !== undefined) {
                localVarQueryParameter['version_id_filter'] = versionIdFilter;
            }

            if (defaultVersionFilter !== undefined) {
                localVarQueryParameter['default_version_filter'] = defaultVersionFilter;
            }

            if (defaultSandboxVersionFilter !== undefined) {
                localVarQueryParameter['default_sandbox_version_filter'] = defaultSandboxVersionFilter;
            }

            if (minFlowVersionEtagFilter !== undefined) {
                localVarQueryParameter['min_flow_version_etag_filter'] = minFlowVersionEtagFilter;
            }

            if (shallow !== undefined) {
                localVarQueryParameter['shallow'] = shallow;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Workspace Flow By Slug
         * @param {string} workspaceId 
         * @param {string} slug 
         * @param {string} [versionNameFilter] 
         * @param {string} [versionIdFilter] 
         * @param {boolean} [defaultVersionFilter] 
         * @param {boolean} [defaultSandboxVersionFilter] 
         * @param {string} [minFlowVersionEtagFilter] 
         * @param {boolean} [shallow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet: async (workspaceId: string, slug: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet', 'workspaceId', workspaceId)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet', 'slug', slug)
            const localVarPath = `/api/v1/flows/workspace_id/{workspace_id}/slug/{slug}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (versionNameFilter !== undefined) {
                localVarQueryParameter['version_name_filter'] = versionNameFilter;
            }

            if (versionIdFilter !== undefined) {
                localVarQueryParameter['version_id_filter'] = versionIdFilter;
            }

            if (defaultVersionFilter !== undefined) {
                localVarQueryParameter['default_version_filter'] = defaultVersionFilter;
            }

            if (defaultSandboxVersionFilter !== undefined) {
                localVarQueryParameter['default_sandbox_version_filter'] = defaultSandboxVersionFilter;
            }

            if (minFlowVersionEtagFilter !== undefined) {
                localVarQueryParameter['min_flow_version_etag_filter'] = minFlowVersionEtagFilter;
            }

            if (shallow !== undefined) {
                localVarQueryParameter['shallow'] = shallow;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Copy Flow
         * @param {string} flowId 
         * @param {FlowDuplicate} flowDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCopyFlowApiV1FlowsFlowIdCopyPost: async (flowId: string, flowDuplicate: FlowDuplicate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('postCopyFlowApiV1FlowsFlowIdCopyPost', 'flowId', flowId)
            // verify required parameter 'flowDuplicate' is not null or undefined
            assertParamExists('postCopyFlowApiV1FlowsFlowIdCopyPost', 'flowDuplicate', flowDuplicate)
            const localVarPath = `/api/v1/flows/{flow_id}/copy`
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowDuplicate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Copy Flow Sample Data
         * @param {string} flowId 
         * @param {DatasetsDuplicate} datasetsDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost: async (flowId: string, datasetsDuplicate: DatasetsDuplicate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost', 'flowId', flowId)
            // verify required parameter 'datasetsDuplicate' is not null or undefined
            assertParamExists('postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost', 'datasetsDuplicate', datasetsDuplicate)
            const localVarPath = `/api/v1/flows/{flow_id}/copy/sample_data`
                .replace(`{${"flow_id"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datasetsDuplicate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Flow
         * @param {string} id 
         * @param {FlowUpdate} flowUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowApiV1FlowsIdPatch: async (id: string, flowUpdate: FlowUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFlowApiV1FlowsIdPatch', 'id', id)
            // verify required parameter 'flowUpdate' is not null or undefined
            assertParamExists('updateFlowApiV1FlowsIdPatch', 'flowUpdate', flowUpdate)
            const localVarPath = `/api/v1/flows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowsApi - functional programming interface
 * @export
 */
export const FlowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Flow
         * @param {FlowCreatePopulated} flowCreatePopulated 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFlowApiV1FlowsPost(flowCreatePopulated: FlowCreatePopulated, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFlowApiV1FlowsPost(flowCreatePopulated, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.createFlowApiV1FlowsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Flow
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFlowApiV1FlowsFlowIdDelete(flowId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFlowApiV1FlowsFlowIdDelete(flowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.deleteFlowApiV1FlowsFlowIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Default Version Flow Docs
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet(flowId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet(flowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the active traffic policy summary for a flow. Only includes the information necessary for routing based on traffic policies.
         * @summary Get Flow Active Policy Summary
         * @param {string} workspaceId 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet(workspaceId: string, slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowDbActivePolicySummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet(workspaceId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Flow
         * @param {string} id 
         * @param {boolean} [includeArchivedFlowVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowApiV1FlowsIdGet(id: string, includeArchivedFlowVersions?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowDbShallowSansLinkedFlows>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowApiV1FlowsIdGet(id, includeArchivedFlowVersions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getFlowApiV1FlowsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of flows.  The `filter[type][one_of]` parameter can be used to filter flows by their type. It accepts a list of strings. - If the parameter is not provided, only flows with no type (i.e., type is NULL) are returned. - To fetch flows with no type, you can also pass `filter[type][one_of]=none`. - To fetch flows of a specific type, pass the type name (e.g., `filter[type][one_of]=case_flow`). - To fetch flows of multiple types, you can use a comma-separated list of types   (e.g., `filter[type][one_of]=case_flow,none`).  The `include_schemas` parameter controls whether flow version schemas are included: - If True, returns FlowVersionDbShallowWithSchemas (includes input_schema, output_schema) - If False (default), returns FlowVersionDbShallow (excludes schemas for better performance)
         * @summary Get Flows
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [workspaceId] 
         * @param {string} [flowFolderId] 
         * @param {GetFlowsApiV1FlowsGetOrderByEnum} [orderBy] 
         * @param {boolean} [includeInternalFlows] 
         * @param {boolean} [includeSchemas] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowsApiV1FlowsGet(skip?: number, limit?: number, workspaceId?: string, flowFolderId?: string, orderBy?: GetFlowsApiV1FlowsGetOrderByEnum, includeInternalFlows?: boolean, includeSchemas?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FlowDbShallowNoTrafficPolicies>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowsApiV1FlowsGet(skip, limit, workspaceId, flowFolderId, orderBy, includeInternalFlows, includeSchemas, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getFlowsApiV1FlowsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Published Flows Using Resource
         * @param {string} workspaceId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet(workspaceId: string, resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FlowDbShallow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet(workspaceId, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Versioned Flow Docs
         * @param {string} flowId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet(flowId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet(flowId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Workspace Flow By Id
         * @param {string} workspaceId 
         * @param {string} flowId 
         * @param {string} [versionNameFilter] 
         * @param {string} [versionIdFilter] 
         * @param {boolean} [defaultVersionFilter] 
         * @param {boolean} [defaultSandboxVersionFilter] 
         * @param {string} [minFlowVersionEtagFilter] 
         * @param {boolean} [shallow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet(workspaceId: string, flowId: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowDbDataplane>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet(workspaceId, flowId, versionNameFilter, versionIdFilter, defaultVersionFilter, defaultSandboxVersionFilter, minFlowVersionEtagFilter, shallow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Workspace Flow By Slug
         * @param {string} workspaceId 
         * @param {string} slug 
         * @param {string} [versionNameFilter] 
         * @param {string} [versionIdFilter] 
         * @param {boolean} [defaultVersionFilter] 
         * @param {boolean} [defaultSandboxVersionFilter] 
         * @param {string} [minFlowVersionEtagFilter] 
         * @param {boolean} [shallow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet(workspaceId: string, slug: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowDbDataplane>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet(workspaceId, slug, versionNameFilter, versionIdFilter, defaultVersionFilter, defaultSandboxVersionFilter, minFlowVersionEtagFilter, shallow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Copy Flow
         * @param {string} flowId 
         * @param {FlowDuplicate} flowDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCopyFlowApiV1FlowsFlowIdCopyPost(flowId: string, flowDuplicate: FlowDuplicate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopyFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCopyFlowApiV1FlowsFlowIdCopyPost(flowId, flowDuplicate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.postCopyFlowApiV1FlowsFlowIdCopyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Copy Flow Sample Data
         * @param {string} flowId 
         * @param {DatasetsDuplicate} datasetsDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost(flowId: string, datasetsDuplicate: DatasetsDuplicate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost(flowId, datasetsDuplicate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Flow
         * @param {string} id 
         * @param {FlowUpdate} flowUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFlowApiV1FlowsIdPatch(id: string, flowUpdate: FlowUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFlowApiV1FlowsIdPatch(id, flowUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FlowsApi.updateFlowApiV1FlowsIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FlowsApi - factory interface
 * @export
 */
export const FlowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlowsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Flow
         * @param {FlowCreatePopulated} flowCreatePopulated 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowApiV1FlowsPost(flowCreatePopulated: FlowCreatePopulated, options?: any): AxiosPromise<FlowDb> {
            return localVarFp.createFlowApiV1FlowsPost(flowCreatePopulated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Flow
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFlowApiV1FlowsFlowIdDelete(flowId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFlowApiV1FlowsFlowIdDelete(flowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Default Version Flow Docs
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet(flowId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet(flowId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the active traffic policy summary for a flow. Only includes the information necessary for routing based on traffic policies.
         * @summary Get Flow Active Policy Summary
         * @param {string} workspaceId 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet(workspaceId: string, slug: string, options?: any): AxiosPromise<FlowDbActivePolicySummary> {
            return localVarFp.getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet(workspaceId, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Flow
         * @param {string} id 
         * @param {boolean} [includeArchivedFlowVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowApiV1FlowsIdGet(id: string, includeArchivedFlowVersions?: boolean, options?: any): AxiosPromise<FlowDbShallowSansLinkedFlows> {
            return localVarFp.getFlowApiV1FlowsIdGet(id, includeArchivedFlowVersions, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of flows.  The `filter[type][one_of]` parameter can be used to filter flows by their type. It accepts a list of strings. - If the parameter is not provided, only flows with no type (i.e., type is NULL) are returned. - To fetch flows with no type, you can also pass `filter[type][one_of]=none`. - To fetch flows of a specific type, pass the type name (e.g., `filter[type][one_of]=case_flow`). - To fetch flows of multiple types, you can use a comma-separated list of types   (e.g., `filter[type][one_of]=case_flow,none`).  The `include_schemas` parameter controls whether flow version schemas are included: - If True, returns FlowVersionDbShallowWithSchemas (includes input_schema, output_schema) - If False (default), returns FlowVersionDbShallow (excludes schemas for better performance)
         * @summary Get Flows
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {string} [workspaceId] 
         * @param {string} [flowFolderId] 
         * @param {GetFlowsApiV1FlowsGetOrderByEnum} [orderBy] 
         * @param {boolean} [includeInternalFlows] 
         * @param {boolean} [includeSchemas] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowsApiV1FlowsGet(skip?: number, limit?: number, workspaceId?: string, flowFolderId?: string, orderBy?: GetFlowsApiV1FlowsGetOrderByEnum, includeInternalFlows?: boolean, includeSchemas?: boolean, options?: any): AxiosPromise<Array<FlowDbShallowNoTrafficPolicies>> {
            return localVarFp.getFlowsApiV1FlowsGet(skip, limit, workspaceId, flowFolderId, orderBy, includeInternalFlows, includeSchemas, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Published Flows Using Resource
         * @param {string} workspaceId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet(workspaceId: string, resourceId: string, options?: any): AxiosPromise<Array<FlowDbShallow>> {
            return localVarFp.getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet(workspaceId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Versioned Flow Docs
         * @param {string} flowId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet(flowId: string, versionId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet(flowId, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Workspace Flow By Id
         * @param {string} workspaceId 
         * @param {string} flowId 
         * @param {string} [versionNameFilter] 
         * @param {string} [versionIdFilter] 
         * @param {boolean} [defaultVersionFilter] 
         * @param {boolean} [defaultSandboxVersionFilter] 
         * @param {string} [minFlowVersionEtagFilter] 
         * @param {boolean} [shallow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet(workspaceId: string, flowId: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options?: any): AxiosPromise<FlowDbDataplane> {
            return localVarFp.getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet(workspaceId, flowId, versionNameFilter, versionIdFilter, defaultVersionFilter, defaultSandboxVersionFilter, minFlowVersionEtagFilter, shallow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Workspace Flow By Slug
         * @param {string} workspaceId 
         * @param {string} slug 
         * @param {string} [versionNameFilter] 
         * @param {string} [versionIdFilter] 
         * @param {boolean} [defaultVersionFilter] 
         * @param {boolean} [defaultSandboxVersionFilter] 
         * @param {string} [minFlowVersionEtagFilter] 
         * @param {boolean} [shallow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet(workspaceId: string, slug: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options?: any): AxiosPromise<FlowDbDataplane> {
            return localVarFp.getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet(workspaceId, slug, versionNameFilter, versionIdFilter, defaultVersionFilter, defaultSandboxVersionFilter, minFlowVersionEtagFilter, shallow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Copy Flow
         * @param {string} flowId 
         * @param {FlowDuplicate} flowDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCopyFlowApiV1FlowsFlowIdCopyPost(flowId: string, flowDuplicate: FlowDuplicate, options?: any): AxiosPromise<CopyFlowResponse> {
            return localVarFp.postCopyFlowApiV1FlowsFlowIdCopyPost(flowId, flowDuplicate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Copy Flow Sample Data
         * @param {string} flowId 
         * @param {DatasetsDuplicate} datasetsDuplicate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost(flowId: string, datasetsDuplicate: DatasetsDuplicate, options?: any): AxiosPromise<any> {
            return localVarFp.postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost(flowId, datasetsDuplicate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Flow
         * @param {string} id 
         * @param {FlowUpdate} flowUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFlowApiV1FlowsIdPatch(id: string, flowUpdate: FlowUpdate, options?: any): AxiosPromise<any> {
            return localVarFp.updateFlowApiV1FlowsIdPatch(id, flowUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowsApi - object-oriented interface
 * @export
 * @class FlowsApi
 * @extends {BaseAPI}
 */
export class FlowsApi extends BaseAPI {
    /**
     * 
     * @summary Create Flow
     * @param {FlowCreatePopulated} flowCreatePopulated 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public createFlowApiV1FlowsPost(flowCreatePopulated: FlowCreatePopulated, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).createFlowApiV1FlowsPost(flowCreatePopulated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Flow
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public deleteFlowApiV1FlowsFlowIdDelete(flowId: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).deleteFlowApiV1FlowsFlowIdDelete(flowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Default Version Flow Docs
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet(flowId: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getDefaultVersionFlowDocsApiV1FlowsFlowIdDocsGet(flowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the active traffic policy summary for a flow. Only includes the information necessary for routing based on traffic policies.
     * @summary Get Flow Active Policy Summary
     * @param {string} workspaceId 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet(workspaceId: string, slug: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getFlowActivePolicySummaryApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugActiveTrafficPolicySummaryGet(workspaceId, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Flow
     * @param {string} id 
     * @param {boolean} [includeArchivedFlowVersions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getFlowApiV1FlowsIdGet(id: string, includeArchivedFlowVersions?: boolean, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getFlowApiV1FlowsIdGet(id, includeArchivedFlowVersions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of flows.  The `filter[type][one_of]` parameter can be used to filter flows by their type. It accepts a list of strings. - If the parameter is not provided, only flows with no type (i.e., type is NULL) are returned. - To fetch flows with no type, you can also pass `filter[type][one_of]=none`. - To fetch flows of a specific type, pass the type name (e.g., `filter[type][one_of]=case_flow`). - To fetch flows of multiple types, you can use a comma-separated list of types   (e.g., `filter[type][one_of]=case_flow,none`).  The `include_schemas` parameter controls whether flow version schemas are included: - If True, returns FlowVersionDbShallowWithSchemas (includes input_schema, output_schema) - If False (default), returns FlowVersionDbShallow (excludes schemas for better performance)
     * @summary Get Flows
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {string} [workspaceId] 
     * @param {string} [flowFolderId] 
     * @param {GetFlowsApiV1FlowsGetOrderByEnum} [orderBy] 
     * @param {boolean} [includeInternalFlows] 
     * @param {boolean} [includeSchemas] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getFlowsApiV1FlowsGet(skip?: number, limit?: number, workspaceId?: string, flowFolderId?: string, orderBy?: GetFlowsApiV1FlowsGetOrderByEnum, includeInternalFlows?: boolean, includeSchemas?: boolean, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getFlowsApiV1FlowsGet(skip, limit, workspaceId, flowFolderId, orderBy, includeInternalFlows, includeSchemas, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Published Flows Using Resource
     * @param {string} workspaceId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet(workspaceId: string, resourceId: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getPublishedFlowsUsingResourceApiV1FlowsPublishedUsingConnectResourceWorkspaceWorkspaceIdResourceResourceIdGet(workspaceId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Versioned Flow Docs
     * @param {string} flowId 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet(flowId: string, versionId: string, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getVersionedFlowDocsApiV1FlowsFlowIdVersionsVersionIdDocsGet(flowId, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Workspace Flow By Id
     * @param {string} workspaceId 
     * @param {string} flowId 
     * @param {string} [versionNameFilter] 
     * @param {string} [versionIdFilter] 
     * @param {boolean} [defaultVersionFilter] 
     * @param {boolean} [defaultSandboxVersionFilter] 
     * @param {string} [minFlowVersionEtagFilter] 
     * @param {boolean} [shallow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet(workspaceId: string, flowId: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getWorkspaceFlowByIdApiV1FlowsWorkspaceIdWorkspaceIdIdFlowIdGet(workspaceId, flowId, versionNameFilter, versionIdFilter, defaultVersionFilter, defaultSandboxVersionFilter, minFlowVersionEtagFilter, shallow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Workspace Flow By Slug
     * @param {string} workspaceId 
     * @param {string} slug 
     * @param {string} [versionNameFilter] 
     * @param {string} [versionIdFilter] 
     * @param {boolean} [defaultVersionFilter] 
     * @param {boolean} [defaultSandboxVersionFilter] 
     * @param {string} [minFlowVersionEtagFilter] 
     * @param {boolean} [shallow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet(workspaceId: string, slug: string, versionNameFilter?: string, versionIdFilter?: string, defaultVersionFilter?: boolean, defaultSandboxVersionFilter?: boolean, minFlowVersionEtagFilter?: string, shallow?: boolean, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).getWorkspaceFlowBySlugApiV1FlowsWorkspaceIdWorkspaceIdSlugSlugGet(workspaceId, slug, versionNameFilter, versionIdFilter, defaultVersionFilter, defaultSandboxVersionFilter, minFlowVersionEtagFilter, shallow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Copy Flow
     * @param {string} flowId 
     * @param {FlowDuplicate} flowDuplicate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public postCopyFlowApiV1FlowsFlowIdCopyPost(flowId: string, flowDuplicate: FlowDuplicate, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).postCopyFlowApiV1FlowsFlowIdCopyPost(flowId, flowDuplicate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Copy Flow Sample Data
     * @param {string} flowId 
     * @param {DatasetsDuplicate} datasetsDuplicate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost(flowId: string, datasetsDuplicate: DatasetsDuplicate, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).postCopyFlowSampleDataApiV1FlowsFlowIdCopySampleDataPost(flowId, datasetsDuplicate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Flow
     * @param {string} id 
     * @param {FlowUpdate} flowUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowsApi
     */
    public updateFlowApiV1FlowsIdPatch(id: string, flowUpdate: FlowUpdate, options?: RawAxiosRequestConfig) {
        return FlowsApiFp(this.configuration).updateFlowApiV1FlowsIdPatch(id, flowUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetFlowsApiV1FlowsGetOrderByEnum {
    UPDATED_AT_TRAVERSED = 'updated_at_traversed',
    NAME = 'name'
}


/**
 * FoldersApi - axios parameter creator
 * @export
 */
export const FoldersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Folder
         * @param {FlowFolderCreate} flowFolderCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolderApiV1FoldersPost: async (flowFolderCreate: FlowFolderCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowFolderCreate' is not null or undefined
            assertParamExists('createFolderApiV1FoldersPost', 'flowFolderCreate', flowFolderCreate)
            const localVarPath = `/api/v1/folders/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowFolderCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolderApiV1FoldersFolderIdDelete: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteFolderApiV1FoldersFolderIdDelete', 'folderId', folderId)
            const localVarPath = `/api/v1/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query folders for a workspace.
         * @summary Get Folders
         * @param {string} workspaceId 
         * @param {boolean} [includeInternalFlowsInCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersApiV1FoldersWorkspaceIdGet: async (workspaceId: string, includeInternalFlowsInCount?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getFoldersApiV1FoldersWorkspaceIdGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v1/folders/{workspace_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (includeInternalFlowsInCount !== undefined) {
                localVarQueryParameter['include_internal_flows_in_count'] = includeInternalFlowsInCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Folder
         * @param {string} folderId 
         * @param {FlowFolderUpdate} flowFolderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolderApiV1FoldersFolderIdPatch: async (folderId: string, flowFolderUpdate: FlowFolderUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('updateFolderApiV1FoldersFolderIdPatch', 'folderId', folderId)
            // verify required parameter 'flowFolderUpdate' is not null or undefined
            assertParamExists('updateFolderApiV1FoldersFolderIdPatch', 'flowFolderUpdate', flowFolderUpdate)
            const localVarPath = `/api/v1/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowFolderUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FoldersApi - functional programming interface
 * @export
 */
export const FoldersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FoldersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Folder
         * @param {FlowFolderCreate} flowFolderCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolderApiV1FoldersPost(flowFolderCreate: FlowFolderCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowFolderDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolderApiV1FoldersPost(flowFolderCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.createFolderApiV1FoldersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolderApiV1FoldersFolderIdDelete(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolderApiV1FoldersFolderIdDelete(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.deleteFolderApiV1FoldersFolderIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query folders for a workspace.
         * @summary Get Folders
         * @param {string} workspaceId 
         * @param {boolean} [includeInternalFlowsInCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFoldersApiV1FoldersWorkspaceIdGet(workspaceId: string, includeInternalFlowsInCount?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowFolderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFoldersApiV1FoldersWorkspaceIdGet(workspaceId, includeInternalFlowsInCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.getFoldersApiV1FoldersWorkspaceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Folder
         * @param {string} folderId 
         * @param {FlowFolderUpdate} flowFolderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFolderApiV1FoldersFolderIdPatch(folderId: string, flowFolderUpdate: FlowFolderUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowFolderDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFolderApiV1FoldersFolderIdPatch(folderId, flowFolderUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.updateFolderApiV1FoldersFolderIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FoldersApi - factory interface
 * @export
 */
export const FoldersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FoldersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Folder
         * @param {FlowFolderCreate} flowFolderCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolderApiV1FoldersPost(flowFolderCreate: FlowFolderCreate, options?: any): AxiosPromise<FlowFolderDb> {
            return localVarFp.createFolderApiV1FoldersPost(flowFolderCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolderApiV1FoldersFolderIdDelete(folderId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteFolderApiV1FoldersFolderIdDelete(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query folders for a workspace.
         * @summary Get Folders
         * @param {string} workspaceId 
         * @param {boolean} [includeInternalFlowsInCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoldersApiV1FoldersWorkspaceIdGet(workspaceId: string, includeInternalFlowsInCount?: boolean, options?: any): AxiosPromise<FlowFolderListResponse> {
            return localVarFp.getFoldersApiV1FoldersWorkspaceIdGet(workspaceId, includeInternalFlowsInCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Folder
         * @param {string} folderId 
         * @param {FlowFolderUpdate} flowFolderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolderApiV1FoldersFolderIdPatch(folderId: string, flowFolderUpdate: FlowFolderUpdate, options?: any): AxiosPromise<FlowFolderDb> {
            return localVarFp.updateFolderApiV1FoldersFolderIdPatch(folderId, flowFolderUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FoldersApi - object-oriented interface
 * @export
 * @class FoldersApi
 * @extends {BaseAPI}
 */
export class FoldersApi extends BaseAPI {
    /**
     * 
     * @summary Create Folder
     * @param {FlowFolderCreate} flowFolderCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public createFolderApiV1FoldersPost(flowFolderCreate: FlowFolderCreate, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).createFolderApiV1FoldersPost(flowFolderCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public deleteFolderApiV1FoldersFolderIdDelete(folderId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).deleteFolderApiV1FoldersFolderIdDelete(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query folders for a workspace.
     * @summary Get Folders
     * @param {string} workspaceId 
     * @param {boolean} [includeInternalFlowsInCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public getFoldersApiV1FoldersWorkspaceIdGet(workspaceId: string, includeInternalFlowsInCount?: boolean, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).getFoldersApiV1FoldersWorkspaceIdGet(workspaceId, includeInternalFlowsInCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Folder
     * @param {string} folderId 
     * @param {FlowFolderUpdate} flowFolderUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public updateFolderApiV1FoldersFolderIdPatch(folderId: string, flowFolderUpdate: FlowFolderUpdate, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).updateFolderApiV1FoldersFolderIdPatch(folderId, flowFolderUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Keepalive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keepaliveApiV2KeepaliveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/keepalive/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Keepalive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async keepaliveApiV2KeepaliveGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.keepaliveApiV2KeepaliveGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.keepaliveApiV2KeepaliveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @summary Keepalive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keepaliveApiV2KeepaliveGet(options?: any): AxiosPromise<any> {
            return localVarFp.keepaliveApiV2KeepaliveGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @summary Keepalive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public keepaliveApiV2KeepaliveGet(options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).keepaliveApiV2KeepaliveGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ManifestBuilderApi - axios parameter creator
 * @export
 */
export const ManifestBuilderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Promote a flow version to an integration manifest by compiling it and triggering the GitHub workflow.  This endpoint: 1. Retrieves the flow version from the database 2. Compiles it into a manifest using the Connect Service 3. Extracts the provider name from the manifest 4. Generates a unique branch name 5. Triggers a GitHub workflow to create the manifest file  This endpoint requires proper GitHub App credentials to be configured.
         * @summary Promote a flow version to a manifest
         * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost: async (promoteFlowVersionRequest: PromoteFlowVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoteFlowVersionRequest' is not null or undefined
            assertParamExists('promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost', 'promoteFlowVersionRequest', promoteFlowVersionRequest)
            const localVarPath = `/api/v2/manifest-builder/promote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promoteFlowVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Manifest
         * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadManifestApiV2ManifestBuilderUploadPost: async (promoteFlowVersionRequest: PromoteFlowVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promoteFlowVersionRequest' is not null or undefined
            assertParamExists('uploadManifestApiV2ManifestBuilderUploadPost', 'promoteFlowVersionRequest', promoteFlowVersionRequest)
            const localVarPath = `/api/v2/manifest-builder/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promoteFlowVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManifestBuilderApi - functional programming interface
 * @export
 */
export const ManifestBuilderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManifestBuilderApiAxiosParamCreator(configuration)
    return {
        /**
         * Promote a flow version to an integration manifest by compiling it and triggering the GitHub workflow.  This endpoint: 1. Retrieves the flow version from the database 2. Compiles it into a manifest using the Connect Service 3. Extracts the provider name from the manifest 4. Generates a unique branch name 5. Triggers a GitHub workflow to create the manifest file  This endpoint requires proper GitHub App credentials to be configured.
         * @summary Promote a flow version to a manifest
         * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(promoteFlowVersionRequest: PromoteFlowVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoteFlowVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(promoteFlowVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManifestBuilderApi.promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Manifest
         * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadManifestApiV2ManifestBuilderUploadPost(promoteFlowVersionRequest: PromoteFlowVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadManifestApiV2ManifestBuilderUploadPost(promoteFlowVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManifestBuilderApi.uploadManifestApiV2ManifestBuilderUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManifestBuilderApi - factory interface
 * @export
 */
export const ManifestBuilderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManifestBuilderApiFp(configuration)
    return {
        /**
         * Promote a flow version to an integration manifest by compiling it and triggering the GitHub workflow.  This endpoint: 1. Retrieves the flow version from the database 2. Compiles it into a manifest using the Connect Service 3. Extracts the provider name from the manifest 4. Generates a unique branch name 5. Triggers a GitHub workflow to create the manifest file  This endpoint requires proper GitHub App credentials to be configured.
         * @summary Promote a flow version to a manifest
         * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(promoteFlowVersionRequest: PromoteFlowVersionRequest, options?: any): AxiosPromise<PromoteFlowVersionResponse> {
            return localVarFp.promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(promoteFlowVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Manifest
         * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadManifestApiV2ManifestBuilderUploadPost(promoteFlowVersionRequest: PromoteFlowVersionRequest, options?: any): AxiosPromise<object> {
            return localVarFp.uploadManifestApiV2ManifestBuilderUploadPost(promoteFlowVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManifestBuilderApi - object-oriented interface
 * @export
 * @class ManifestBuilderApi
 * @extends {BaseAPI}
 */
export class ManifestBuilderApi extends BaseAPI {
    /**
     * Promote a flow version to an integration manifest by compiling it and triggering the GitHub workflow.  This endpoint: 1. Retrieves the flow version from the database 2. Compiles it into a manifest using the Connect Service 3. Extracts the provider name from the manifest 4. Generates a unique branch name 5. Triggers a GitHub workflow to create the manifest file  This endpoint requires proper GitHub App credentials to be configured.
     * @summary Promote a flow version to a manifest
     * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestBuilderApi
     */
    public promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(promoteFlowVersionRequest: PromoteFlowVersionRequest, options?: RawAxiosRequestConfig) {
        return ManifestBuilderApiFp(this.configuration).promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(promoteFlowVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Manifest
     * @param {PromoteFlowVersionRequest} promoteFlowVersionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManifestBuilderApi
     */
    public uploadManifestApiV2ManifestBuilderUploadPost(promoteFlowVersionRequest: PromoteFlowVersionRequest, options?: RawAxiosRequestConfig) {
        return ManifestBuilderApiFp(this.configuration).uploadManifestApiV2ManifestBuilderUploadPost(promoteFlowVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ModuleOperationsApi - axios parameter creator
 * @export
 */
export const ModuleOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new operation to modify an existing module.
         * @summary Create a module operation
         * @param {ModuleOperationCreateRequest} moduleOperationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModuleOperationApiV1ModuleOperationsPost: async (moduleOperationCreateRequest: ModuleOperationCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleOperationCreateRequest' is not null or undefined
            assertParamExists('createModuleOperationApiV1ModuleOperationsPost', 'moduleOperationCreateRequest', moduleOperationCreateRequest)
            const localVarPath = `/api/v1/module_operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleOperationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModuleOperationsApi - functional programming interface
 * @export
 */
export const ModuleOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModuleOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new operation to modify an existing module.
         * @summary Create a module operation
         * @param {ModuleOperationCreateRequest} moduleOperationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createModuleOperationApiV1ModuleOperationsPost(moduleOperationCreateRequest: ModuleOperationCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleOperationCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createModuleOperationApiV1ModuleOperationsPost(moduleOperationCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModuleOperationsApi.createModuleOperationApiV1ModuleOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModuleOperationsApi - factory interface
 * @export
 */
export const ModuleOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModuleOperationsApiFp(configuration)
    return {
        /**
         * Create a new operation to modify an existing module.
         * @summary Create a module operation
         * @param {ModuleOperationCreateRequest} moduleOperationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModuleOperationApiV1ModuleOperationsPost(moduleOperationCreateRequest: ModuleOperationCreateRequest, options?: any): AxiosPromise<ModuleOperationCreateResponse> {
            return localVarFp.createModuleOperationApiV1ModuleOperationsPost(moduleOperationCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModuleOperationsApi - object-oriented interface
 * @export
 * @class ModuleOperationsApi
 * @extends {BaseAPI}
 */
export class ModuleOperationsApi extends BaseAPI {
    /**
     * Create a new operation to modify an existing module.
     * @summary Create a module operation
     * @param {ModuleOperationCreateRequest} moduleOperationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModuleOperationsApi
     */
    public createModuleOperationApiV1ModuleOperationsPost(moduleOperationCreateRequest: ModuleOperationCreateRequest, options?: RawAxiosRequestConfig) {
        return ModuleOperationsApiFp(this.configuration).createModuleOperationApiV1ModuleOperationsPost(moduleOperationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ModulesApi - axios parameter creator
 * @export
 */
export const ModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new module for a workspace.
         * @summary Create a module
         * @param {ModuleCreateRequest} moduleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModuleApiV1ModulesPost: async (moduleCreateRequest: ModuleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleCreateRequest' is not null or undefined
            assertParamExists('createModuleApiV1ModulesPost', 'moduleCreateRequest', moduleCreateRequest)
            const localVarPath = `/api/v1/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a module by ID. Supports ?include=active_operations,latest_successful_operation,all_operations.
         * @summary Get a single module
         * @param {string} moduleId 
         * @param {string} [include] Comma-separated relationships to include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModuleApiV1ModulesModuleIdGet: async (moduleId: string, include?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('getModuleApiV1ModulesModuleIdGet', 'moduleId', moduleId)
            const localVarPath = `/api/v1/modules/{module_id}`
                .replace(`{${"module_id"}}`, encodeURIComponent(String(moduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get modules. If filter[workspace_id] is provided, returns modules for that workspace. Otherwise, returns modules across all workspaces the user has access to. Supports ?include=active_operations,latest_successful_operation,all_operations.
         * @summary List modules
         * @param {string} [filterWorkspaceId] Optional workspace ID to filter by
         * @param {string} [include] Comma-separated relationships to include
         * @param {number} [pageOffset] Number of records to skip
         * @param {number} [pageLimit] Maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModulesApiV1ModulesGet: async (filterWorkspaceId?: string, include?: string, pageOffset?: number, pageLimit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (filterWorkspaceId !== undefined) {
                localVarQueryParameter['filter[workspace_id]'] = filterWorkspaceId;
            }

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (pageOffset !== undefined) {
                localVarQueryParameter['page[offset]'] = pageOffset;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page[limit]'] = pageLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModulesApi - functional programming interface
 * @export
 */
export const ModulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModulesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new module for a workspace.
         * @summary Create a module
         * @param {ModuleCreateRequest} moduleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createModuleApiV1ModulesPost(moduleCreateRequest: ModuleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createModuleApiV1ModulesPost(moduleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesApi.createModuleApiV1ModulesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a module by ID. Supports ?include=active_operations,latest_successful_operation,all_operations.
         * @summary Get a single module
         * @param {string} moduleId 
         * @param {string} [include] Comma-separated relationships to include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModuleApiV1ModulesModuleIdGet(moduleId: string, include?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModuleApiV1ModulesModuleIdGet(moduleId, include, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesApi.getModuleApiV1ModulesModuleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get modules. If filter[workspace_id] is provided, returns modules for that workspace. Otherwise, returns modules across all workspaces the user has access to. Supports ?include=active_operations,latest_successful_operation,all_operations.
         * @summary List modules
         * @param {string} [filterWorkspaceId] Optional workspace ID to filter by
         * @param {string} [include] Comma-separated relationships to include
         * @param {number} [pageOffset] Number of records to skip
         * @param {number} [pageLimit] Maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listModulesApiV1ModulesGet(filterWorkspaceId?: string, include?: string, pageOffset?: number, pageLimit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listModulesApiV1ModulesGet(filterWorkspaceId, include, pageOffset, pageLimit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModulesApi.listModulesApiV1ModulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModulesApi - factory interface
 * @export
 */
export const ModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModulesApiFp(configuration)
    return {
        /**
         * Create a new module for a workspace.
         * @summary Create a module
         * @param {ModuleCreateRequest} moduleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModuleApiV1ModulesPost(moduleCreateRequest: ModuleCreateRequest, options?: any): AxiosPromise<ModuleCreateResponse> {
            return localVarFp.createModuleApiV1ModulesPost(moduleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a module by ID. Supports ?include=active_operations,latest_successful_operation,all_operations.
         * @summary Get a single module
         * @param {string} moduleId 
         * @param {string} [include] Comma-separated relationships to include
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModuleApiV1ModulesModuleIdGet(moduleId: string, include?: string, options?: any): AxiosPromise<ModuleResponse> {
            return localVarFp.getModuleApiV1ModulesModuleIdGet(moduleId, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Get modules. If filter[workspace_id] is provided, returns modules for that workspace. Otherwise, returns modules across all workspaces the user has access to. Supports ?include=active_operations,latest_successful_operation,all_operations.
         * @summary List modules
         * @param {string} [filterWorkspaceId] Optional workspace ID to filter by
         * @param {string} [include] Comma-separated relationships to include
         * @param {number} [pageOffset] Number of records to skip
         * @param {number} [pageLimit] Maximum number of records to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModulesApiV1ModulesGet(filterWorkspaceId?: string, include?: string, pageOffset?: number, pageLimit?: number, options?: any): AxiosPromise<ModuleListResponse> {
            return localVarFp.listModulesApiV1ModulesGet(filterWorkspaceId, include, pageOffset, pageLimit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModulesApi - object-oriented interface
 * @export
 * @class ModulesApi
 * @extends {BaseAPI}
 */
export class ModulesApi extends BaseAPI {
    /**
     * Create a new module for a workspace.
     * @summary Create a module
     * @param {ModuleCreateRequest} moduleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public createModuleApiV1ModulesPost(moduleCreateRequest: ModuleCreateRequest, options?: RawAxiosRequestConfig) {
        return ModulesApiFp(this.configuration).createModuleApiV1ModulesPost(moduleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a module by ID. Supports ?include=active_operations,latest_successful_operation,all_operations.
     * @summary Get a single module
     * @param {string} moduleId 
     * @param {string} [include] Comma-separated relationships to include
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public getModuleApiV1ModulesModuleIdGet(moduleId: string, include?: string, options?: RawAxiosRequestConfig) {
        return ModulesApiFp(this.configuration).getModuleApiV1ModulesModuleIdGet(moduleId, include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get modules. If filter[workspace_id] is provided, returns modules for that workspace. Otherwise, returns modules across all workspaces the user has access to. Supports ?include=active_operations,latest_successful_operation,all_operations.
     * @summary List modules
     * @param {string} [filterWorkspaceId] Optional workspace ID to filter by
     * @param {string} [include] Comma-separated relationships to include
     * @param {number} [pageOffset] Number of records to skip
     * @param {number} [pageLimit] Maximum number of records to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public listModulesApiV1ModulesGet(filterWorkspaceId?: string, include?: string, pageOffset?: number, pageLimit?: number, options?: RawAxiosRequestConfig) {
        return ModulesApiFp(this.configuration).listModulesApiV1ModulesGet(filterWorkspaceId, include, pageOffset, pageLimit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OutcomeTypesApi - axios parameter creator
 * @export
 */
export const OutcomeTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clear Outcome Type Reports
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete', 'id', id)
            const localVarPath = `/api/v1/outcome_types/{id}/clear_reports`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Outcome Type
         * @param {OutcomeTypeCreate} outcomeTypeCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeTypeApiV1OutcomeTypesPost: async (outcomeTypeCreate: OutcomeTypeCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outcomeTypeCreate' is not null or undefined
            assertParamExists('createOutcomeTypeApiV1OutcomeTypesPost', 'outcomeTypeCreate', outcomeTypeCreate)
            const localVarPath = `/api/v1/outcome_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outcomeTypeCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Outcome Types For Flow
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeTypesForFlowApiV1OutcomeTypesGet: async (flowId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getOutcomeTypesForFlowApiV1OutcomeTypesGet', 'flowId', flowId)
            const localVarPath = `/api/v1/outcome_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch Outcome Type
         * @param {string} id 
         * @param {OutcomeTypePatch} outcomeTypePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOutcomeTypeApiV1OutcomeTypesIdPatch: async (id: string, outcomeTypePatch: OutcomeTypePatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchOutcomeTypeApiV1OutcomeTypesIdPatch', 'id', id)
            // verify required parameter 'outcomeTypePatch' is not null or undefined
            assertParamExists('patchOutcomeTypeApiV1OutcomeTypesIdPatch', 'outcomeTypePatch', outcomeTypePatch)
            const localVarPath = `/api/v1/outcome_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(outcomeTypePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start Outcome Type Deletion
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete', 'id', id)
            const localVarPath = `/api/v1/outcome_types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutcomeTypesApi - functional programming interface
 * @export
 */
export const OutcomeTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutcomeTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clear Outcome Type Reports
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutcomeTypesApi.clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Outcome Type
         * @param {OutcomeTypeCreate} outcomeTypeCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOutcomeTypeApiV1OutcomeTypesPost(outcomeTypeCreate: OutcomeTypeCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutcomeType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOutcomeTypeApiV1OutcomeTypesPost(outcomeTypeCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutcomeTypesApi.createOutcomeTypeApiV1OutcomeTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Outcome Types For Flow
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutcomeTypesForFlowApiV1OutcomeTypesGet(flowId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OutcomeType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutcomeTypesForFlowApiV1OutcomeTypesGet(flowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutcomeTypesApi.getOutcomeTypesForFlowApiV1OutcomeTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch Outcome Type
         * @param {string} id 
         * @param {OutcomeTypePatch} outcomeTypePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOutcomeTypeApiV1OutcomeTypesIdPatch(id: string, outcomeTypePatch: OutcomeTypePatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutcomeType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOutcomeTypeApiV1OutcomeTypesIdPatch(id, outcomeTypePatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutcomeTypesApi.patchOutcomeTypeApiV1OutcomeTypesIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start Outcome Type Deletion
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutcomeTypesApi.startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutcomeTypesApi - factory interface
 * @export
 */
export const OutcomeTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutcomeTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Clear Outcome Type Reports
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Outcome Type
         * @param {OutcomeTypeCreate} outcomeTypeCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOutcomeTypeApiV1OutcomeTypesPost(outcomeTypeCreate: OutcomeTypeCreate, options?: any): AxiosPromise<OutcomeType> {
            return localVarFp.createOutcomeTypeApiV1OutcomeTypesPost(outcomeTypeCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Outcome Types For Flow
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeTypesForFlowApiV1OutcomeTypesGet(flowId: string, options?: any): AxiosPromise<Array<OutcomeType>> {
            return localVarFp.getOutcomeTypesForFlowApiV1OutcomeTypesGet(flowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch Outcome Type
         * @param {string} id 
         * @param {OutcomeTypePatch} outcomeTypePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOutcomeTypeApiV1OutcomeTypesIdPatch(id: string, outcomeTypePatch: OutcomeTypePatch, options?: any): AxiosPromise<OutcomeType> {
            return localVarFp.patchOutcomeTypeApiV1OutcomeTypesIdPatch(id, outcomeTypePatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start Outcome Type Deletion
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OutcomeTypesApi - object-oriented interface
 * @export
 * @class OutcomeTypesApi
 * @extends {BaseAPI}
 */
export class OutcomeTypesApi extends BaseAPI {
    /**
     * 
     * @summary Clear Outcome Type Reports
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeTypesApi
     */
    public clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete(id: string, options?: RawAxiosRequestConfig) {
        return OutcomeTypesApiFp(this.configuration).clearOutcomeTypeReportsApiV1OutcomeTypesIdClearReportsDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Outcome Type
     * @param {OutcomeTypeCreate} outcomeTypeCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeTypesApi
     */
    public createOutcomeTypeApiV1OutcomeTypesPost(outcomeTypeCreate: OutcomeTypeCreate, options?: RawAxiosRequestConfig) {
        return OutcomeTypesApiFp(this.configuration).createOutcomeTypeApiV1OutcomeTypesPost(outcomeTypeCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Outcome Types For Flow
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeTypesApi
     */
    public getOutcomeTypesForFlowApiV1OutcomeTypesGet(flowId: string, options?: RawAxiosRequestConfig) {
        return OutcomeTypesApiFp(this.configuration).getOutcomeTypesForFlowApiV1OutcomeTypesGet(flowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch Outcome Type
     * @param {string} id 
     * @param {OutcomeTypePatch} outcomeTypePatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeTypesApi
     */
    public patchOutcomeTypeApiV1OutcomeTypesIdPatch(id: string, outcomeTypePatch: OutcomeTypePatch, options?: RawAxiosRequestConfig) {
        return OutcomeTypesApiFp(this.configuration).patchOutcomeTypeApiV1OutcomeTypesIdPatch(id, outcomeTypePatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start Outcome Type Deletion
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeTypesApi
     */
    public startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return OutcomeTypesApiFp(this.configuration).startOutcomeTypeDeletionApiV1OutcomeTypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReviewsApi - axios parameter creator
 * @export
 */
export const ReviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Review
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewApiV1ReviewsGet: async (flowVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getReviewApiV1ReviewsGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v1/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowVersionId !== undefined) {
                localVarQueryParameter['flow_version_id'] = flowVersionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch Reviews
         * @param {string} reviewId 
         * @param {ReviewUpsert} reviewUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReviewsApiV1ReviewsReviewIdPatch: async (reviewId: string, reviewUpsert: ReviewUpsert, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('patchReviewsApiV1ReviewsReviewIdPatch', 'reviewId', reviewId)
            // verify required parameter 'reviewUpsert' is not null or undefined
            assertParamExists('patchReviewsApiV1ReviewsReviewIdPatch', 'reviewUpsert', reviewUpsert)
            const localVarPath = `/api/v1/reviews/{review_id}`
                .replace(`{${"review_id"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewUpsert, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReviewsApi - functional programming interface
 * @export
 */
export const ReviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Review
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewApiV1ReviewsGet(flowVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewApiV1ReviewsGet(flowVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.getReviewApiV1ReviewsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch Reviews
         * @param {string} reviewId 
         * @param {ReviewUpsert} reviewUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchReviewsApiV1ReviewsReviewIdPatch(reviewId: string, reviewUpsert: ReviewUpsert, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchReviewsApiV1ReviewsReviewIdPatch(reviewId, reviewUpsert, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewsApi.patchReviewsApiV1ReviewsReviewIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReviewsApi - factory interface
 * @export
 */
export const ReviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReviewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Review
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewApiV1ReviewsGet(flowVersionId: string, options?: any): AxiosPromise<ReviewDb> {
            return localVarFp.getReviewApiV1ReviewsGet(flowVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch Reviews
         * @param {string} reviewId 
         * @param {ReviewUpsert} reviewUpsert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReviewsApiV1ReviewsReviewIdPatch(reviewId: string, reviewUpsert: ReviewUpsert, options?: any): AxiosPromise<ReviewDb> {
            return localVarFp.patchReviewsApiV1ReviewsReviewIdPatch(reviewId, reviewUpsert, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReviewsApi - object-oriented interface
 * @export
 * @class ReviewsApi
 * @extends {BaseAPI}
 */
export class ReviewsApi extends BaseAPI {
    /**
     * 
     * @summary Get Review
     * @param {string} flowVersionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public getReviewApiV1ReviewsGet(flowVersionId: string, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).getReviewApiV1ReviewsGet(flowVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch Reviews
     * @param {string} reviewId 
     * @param {ReviewUpsert} reviewUpsert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReviewsApi
     */
    public patchReviewsApiV1ReviewsReviewIdPatch(reviewId: string, reviewUpsert: ReviewUpsert, options?: RawAxiosRequestConfig) {
        return ReviewsApiFp(this.configuration).patchReviewsApiV1ReviewsReviewIdPatch(reviewId, reviewUpsert, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TableSerializationApi - axios parameter creator
 * @export
 */
export const TableSerializationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Decision Table Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet: async (flowVersionId: string, nodeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet', 'nodeId', nodeId)
            const localVarPath = `/api/v1/table_serialization/flow_versions/{flow_version_id}/nodes/{node_id}/decision_table/export`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Matrix Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet: async (flowVersionId: string, nodeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet', 'nodeId', nodeId)
            const localVarPath = `/api/v1/table_serialization/flow_versions/{flow_version_id}/nodes/{node_id}/matrix/export`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import Decision Table Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost: async (flowVersionId: string, nodeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost', 'flowVersionId', flowVersionId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost', 'nodeId', nodeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost', 'file', file)
            const localVarPath = `/api/v1/table_serialization/flow_versions/{flow_version_id}/nodes/{node_id}/decision_table/import`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import Matrix Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost: async (flowVersionId: string, nodeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost', 'flowVersionId', flowVersionId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost', 'nodeId', nodeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost', 'file', file)
            const localVarPath = `/api/v1/table_serialization/flow_versions/{flow_version_id}/nodes/{node_id}/matrix/import`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TableSerializationApi - functional programming interface
 * @export
 */
export const TableSerializationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TableSerializationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Decision Table Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(flowVersionId: string, nodeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(flowVersionId, nodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableSerializationApi.exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Matrix Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(flowVersionId: string, nodeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(flowVersionId, nodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableSerializationApi.exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import Decision Table Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(flowVersionId: string, nodeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecisionTableNodeMeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(flowVersionId, nodeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableSerializationApi.importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import Matrix Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(flowVersionId: string, nodeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixTableNodeMeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(flowVersionId, nodeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableSerializationApi.importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TableSerializationApi - factory interface
 * @export
 */
export const TableSerializationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TableSerializationApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Decision Table Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(flowVersionId: string, nodeId: string, options?: any): AxiosPromise<any> {
            return localVarFp.exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(flowVersionId, nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Matrix Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(flowVersionId: string, nodeId: string, options?: any): AxiosPromise<any> {
            return localVarFp.exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(flowVersionId, nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import Decision Table Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(flowVersionId: string, nodeId: string, file: File, options?: any): AxiosPromise<DecisionTableNodeMeta> {
            return localVarFp.importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(flowVersionId, nodeId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import Matrix Csv
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(flowVersionId: string, nodeId: string, file: File, options?: any): AxiosPromise<MatrixTableNodeMeta> {
            return localVarFp.importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(flowVersionId, nodeId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TableSerializationApi - object-oriented interface
 * @export
 * @class TableSerializationApi
 * @extends {BaseAPI}
 */
export class TableSerializationApi extends BaseAPI {
    /**
     * 
     * @summary Export Decision Table Csv
     * @param {string} flowVersionId 
     * @param {string} nodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TableSerializationApi
     */
    public exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(flowVersionId: string, nodeId: string, options?: RawAxiosRequestConfig) {
        return TableSerializationApiFp(this.configuration).exportDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableExportGet(flowVersionId, nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Matrix Csv
     * @param {string} flowVersionId 
     * @param {string} nodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TableSerializationApi
     */
    public exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(flowVersionId: string, nodeId: string, options?: RawAxiosRequestConfig) {
        return TableSerializationApiFp(this.configuration).exportMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixExportGet(flowVersionId, nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import Decision Table Csv
     * @param {string} flowVersionId 
     * @param {string} nodeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TableSerializationApi
     */
    public importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(flowVersionId: string, nodeId: string, file: File, options?: RawAxiosRequestConfig) {
        return TableSerializationApiFp(this.configuration).importDecisionTableCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdDecisionTableImportPost(flowVersionId, nodeId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import Matrix Csv
     * @param {string} flowVersionId 
     * @param {string} nodeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TableSerializationApi
     */
    public importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(flowVersionId: string, nodeId: string, file: File, options?: RawAxiosRequestConfig) {
        return TableSerializationApiFp(this.configuration).importMatrixCsvApiV1TableSerializationFlowVersionsFlowVersionIdNodesNodeIdMatrixImportPost(flowVersionId, nodeId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrafficPoliciesApi - axios parameter creator
 * @export
 */
export const TrafficPoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate Traffic Policy
         * @param {string} trafficPolicyId 
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost: async (trafficPolicyId: string, flowId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trafficPolicyId' is not null or undefined
            assertParamExists('activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost', 'trafficPolicyId', trafficPolicyId)
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost', 'flowId', flowId)
            const localVarPath = `/api/v1/traffic_policies/{traffic_policy_id}/activate`
                .replace(`{${"traffic_policy_id"}}`, encodeURIComponent(String(trafficPolicyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Traffic Policy
         * @param {TrafficPolicyCreateService} trafficPolicyCreateService 
         * @param {boolean} [activate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficPolicyApiV1TrafficPoliciesPost: async (trafficPolicyCreateService: TrafficPolicyCreateService, activate?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trafficPolicyCreateService' is not null or undefined
            assertParamExists('createTrafficPolicyApiV1TrafficPoliciesPost', 'trafficPolicyCreateService', trafficPolicyCreateService)
            const localVarPath = `/api/v1/traffic_policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (activate !== undefined) {
                localVarQueryParameter['activate'] = activate;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trafficPolicyCreateService, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Traffic Policy
         * @param {string} trafficPolicyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet: async (trafficPolicyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trafficPolicyId' is not null or undefined
            assertParamExists('getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet', 'trafficPolicyId', trafficPolicyId)
            const localVarPath = `/api/v1/traffic_policies/{traffic_policy_id}`
                .replace(`{${"traffic_policy_id"}}`, encodeURIComponent(String(trafficPolicyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Flow Traffic Policies
         * @param {string} flowId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlowTrafficPoliciesApiV1TrafficPoliciesGet: async (flowId: string, skip?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('listFlowTrafficPoliciesApiV1TrafficPoliciesGet', 'flowId', flowId)
            const localVarPath = `/api/v1/traffic_policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrafficPoliciesApi - functional programming interface
 * @export
 */
export const TrafficPoliciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrafficPoliciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate Traffic Policy
         * @param {string} trafficPolicyId 
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost(trafficPolicyId: string, flowId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficPolicyInDB>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost(trafficPolicyId, flowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrafficPoliciesApi.activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Traffic Policy
         * @param {TrafficPolicyCreateService} trafficPolicyCreateService 
         * @param {boolean} [activate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrafficPolicyApiV1TrafficPoliciesPost(trafficPolicyCreateService: TrafficPolicyCreateService, activate?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficPolicyInDB>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrafficPolicyApiV1TrafficPoliciesPost(trafficPolicyCreateService, activate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrafficPoliciesApi.createTrafficPolicyApiV1TrafficPoliciesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Traffic Policy
         * @param {string} trafficPolicyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet(trafficPolicyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrafficPolicyInDB>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet(trafficPolicyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrafficPoliciesApi.getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Flow Traffic Policies
         * @param {string} flowId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFlowTrafficPoliciesApiV1TrafficPoliciesGet(flowId: string, skip?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrafficPolicyInDB>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFlowTrafficPoliciesApiV1TrafficPoliciesGet(flowId, skip, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrafficPoliciesApi.listFlowTrafficPoliciesApiV1TrafficPoliciesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrafficPoliciesApi - factory interface
 * @export
 */
export const TrafficPoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrafficPoliciesApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate Traffic Policy
         * @param {string} trafficPolicyId 
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost(trafficPolicyId: string, flowId: string, options?: any): AxiosPromise<TrafficPolicyInDB> {
            return localVarFp.activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost(trafficPolicyId, flowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Traffic Policy
         * @param {TrafficPolicyCreateService} trafficPolicyCreateService 
         * @param {boolean} [activate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrafficPolicyApiV1TrafficPoliciesPost(trafficPolicyCreateService: TrafficPolicyCreateService, activate?: boolean, options?: any): AxiosPromise<TrafficPolicyInDB> {
            return localVarFp.createTrafficPolicyApiV1TrafficPoliciesPost(trafficPolicyCreateService, activate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Traffic Policy
         * @param {string} trafficPolicyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet(trafficPolicyId: string, options?: any): AxiosPromise<TrafficPolicyInDB> {
            return localVarFp.getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet(trafficPolicyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Flow Traffic Policies
         * @param {string} flowId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFlowTrafficPoliciesApiV1TrafficPoliciesGet(flowId: string, skip?: number, limit?: number, options?: any): AxiosPromise<Array<TrafficPolicyInDB>> {
            return localVarFp.listFlowTrafficPoliciesApiV1TrafficPoliciesGet(flowId, skip, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrafficPoliciesApi - object-oriented interface
 * @export
 * @class TrafficPoliciesApi
 * @extends {BaseAPI}
 */
export class TrafficPoliciesApi extends BaseAPI {
    /**
     * 
     * @summary Activate Traffic Policy
     * @param {string} trafficPolicyId 
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficPoliciesApi
     */
    public activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost(trafficPolicyId: string, flowId: string, options?: RawAxiosRequestConfig) {
        return TrafficPoliciesApiFp(this.configuration).activateTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdActivatePost(trafficPolicyId, flowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Traffic Policy
     * @param {TrafficPolicyCreateService} trafficPolicyCreateService 
     * @param {boolean} [activate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficPoliciesApi
     */
    public createTrafficPolicyApiV1TrafficPoliciesPost(trafficPolicyCreateService: TrafficPolicyCreateService, activate?: boolean, options?: RawAxiosRequestConfig) {
        return TrafficPoliciesApiFp(this.configuration).createTrafficPolicyApiV1TrafficPoliciesPost(trafficPolicyCreateService, activate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Traffic Policy
     * @param {string} trafficPolicyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficPoliciesApi
     */
    public getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet(trafficPolicyId: string, options?: RawAxiosRequestConfig) {
        return TrafficPoliciesApiFp(this.configuration).getTrafficPolicyApiV1TrafficPoliciesTrafficPolicyIdGet(trafficPolicyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Flow Traffic Policies
     * @param {string} flowId 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrafficPoliciesApi
     */
    public listFlowTrafficPoliciesApiV1TrafficPoliciesGet(flowId: string, skip?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return TrafficPoliciesApiFp(this.configuration).listFlowTrafficPoliciesApiV1TrafficPoliciesGet(flowId, skip, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypingApi - axios parameter creator
 * @export
 */
export const TypingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Node Types
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {boolean} [isLoopNode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet: async (flowVersionId: string, nodeId: string, isLoopNode?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet', 'flowVersionId', flowVersionId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet', 'nodeId', nodeId)
            const localVarPath = `/api/v1/types/flow_versions/{flow_version_id}/nodes/{node_id}`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (isLoopNode !== undefined) {
                localVarQueryParameter['is_loop_node'] = isLoopNode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Schemas Types
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet: async (flowVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowVersionId' is not null or undefined
            assertParamExists('getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet', 'flowVersionId', flowVersionId)
            const localVarPath = `/api/v1/types/flow_versions/{flow_version_id}/`
                .replace(`{${"flow_version_id"}}`, encodeURIComponent(String(flowVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypingApi - functional programming interface
 * @export
 */
export const TypingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Node Types
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {boolean} [isLoopNode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet(flowVersionId: string, nodeId: string, isLoopNode?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeTypingInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet(flowVersionId, nodeId, isLoopNode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Schemas Types
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet(flowVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet(flowVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingApi.getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypingApi - factory interface
 * @export
 */
export const TypingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypingApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Node Types
         * @param {string} flowVersionId 
         * @param {string} nodeId 
         * @param {boolean} [isLoopNode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet(flowVersionId: string, nodeId: string, isLoopNode?: boolean, options?: any): AxiosPromise<NodeTypingInfo> {
            return localVarFp.getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet(flowVersionId, nodeId, isLoopNode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Schemas Types
         * @param {string} flowVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet(flowVersionId: string, options?: any): AxiosPromise<TypingInfo> {
            return localVarFp.getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet(flowVersionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TypingApi - object-oriented interface
 * @export
 * @class TypingApi
 * @extends {BaseAPI}
 */
export class TypingApi extends BaseAPI {
    /**
     * 
     * @summary Get Node Types
     * @param {string} flowVersionId 
     * @param {string} nodeId 
     * @param {boolean} [isLoopNode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet(flowVersionId: string, nodeId: string, isLoopNode?: boolean, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).getNodeTypesApiV1TypesFlowVersionsFlowVersionIdNodesNodeIdGet(flowVersionId, nodeId, isLoopNode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Schemas Types
     * @param {string} flowVersionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingApi
     */
    public getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet(flowVersionId: string, options?: RawAxiosRequestConfig) {
        return TypingApiFp(this.configuration).getSchemasTypesApiV1TypesFlowVersionsFlowVersionIdGet(flowVersionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ViewfilterApi - axios parameter creator
 * @export
 */
export const ViewfilterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Filter
         * @param {string} workspaceId 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterApiV1ViewfilterGet: async (workspaceId: string, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getFilterApiV1ViewfilterGet', 'workspaceId', workspaceId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getFilterApiV1ViewfilterGet', 'type', type)
            const localVarPath = `/api/v1/viewfilter/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (workspaceId !== undefined) {
                localVarQueryParameter['workspace_id'] = workspaceId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Filter
         * @param {string} id 
         * @param {ViewFilter} viewFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFilterApiV1ViewfilterIdPut: async (id: string, viewFilter: ViewFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putFilterApiV1ViewfilterIdPut', 'id', id)
            // verify required parameter 'viewFilter' is not null or undefined
            assertParamExists('putFilterApiV1ViewfilterIdPut', 'viewFilter', viewFilter)
            const localVarPath = `/api/v1/viewfilter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(viewFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewfilterApi - functional programming interface
 * @export
 */
export const ViewfilterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewfilterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Filter
         * @param {string} workspaceId 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterApiV1ViewfilterGet(workspaceId: string, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewFilter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterApiV1ViewfilterGet(workspaceId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewfilterApi.getFilterApiV1ViewfilterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Filter
         * @param {string} id 
         * @param {ViewFilter} viewFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFilterApiV1ViewfilterIdPut(id: string, viewFilter: ViewFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewFilter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFilterApiV1ViewfilterIdPut(id, viewFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewfilterApi.putFilterApiV1ViewfilterIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewfilterApi - factory interface
 * @export
 */
export const ViewfilterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewfilterApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Filter
         * @param {string} workspaceId 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterApiV1ViewfilterGet(workspaceId: string, type: string, options?: any): AxiosPromise<ViewFilter> {
            return localVarFp.getFilterApiV1ViewfilterGet(workspaceId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Filter
         * @param {string} id 
         * @param {ViewFilter} viewFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFilterApiV1ViewfilterIdPut(id: string, viewFilter: ViewFilter, options?: any): AxiosPromise<ViewFilter> {
            return localVarFp.putFilterApiV1ViewfilterIdPut(id, viewFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ViewfilterApi - object-oriented interface
 * @export
 * @class ViewfilterApi
 * @extends {BaseAPI}
 */
export class ViewfilterApi extends BaseAPI {
    /**
     * 
     * @summary Get Filter
     * @param {string} workspaceId 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewfilterApi
     */
    public getFilterApiV1ViewfilterGet(workspaceId: string, type: string, options?: RawAxiosRequestConfig) {
        return ViewfilterApiFp(this.configuration).getFilterApiV1ViewfilterGet(workspaceId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Filter
     * @param {string} id 
     * @param {ViewFilter} viewFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewfilterApi
     */
    public putFilterApiV1ViewfilterIdPut(id: string, viewFilter: ViewFilter, options?: RawAxiosRequestConfig) {
        return ViewfilterApiFp(this.configuration).putFilterApiV1ViewfilterIdPut(id, viewFilter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhooksApi - axios parameter creator
 * @export
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Webhooks
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhooksApiV1WebhooksKeyDelete: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('deleteWebhooksApiV1WebhooksKeyDelete', 'key', key)
            const localVarPath = `/api/v1/webhooks/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Webhooks
         * @param {ResourceType} [resourceType] 
         * @param {string} [resourceId] 
         * @param {string} [workspaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhooksApiV1WebhooksGet: async (resourceType?: ResourceType, resourceId?: string, workspaceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resource_id'] = resourceId;
            }

            if (workspaceId !== undefined) {
                localVarQueryParameter['workspace_id'] = workspaceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Webhook
         * @param {string} key 
         * @param {Webhook} webhook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWebhookApiV1WebhooksKeyPut: async (key: string, webhook: Webhook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('setWebhookApiV1WebhooksKeyPut', 'key', key)
            // verify required parameter 'webhook' is not null or undefined
            assertParamExists('setWebhookApiV1WebhooksKeyPut', 'webhook', webhook)
            const localVarPath = `/api/v1/webhooks/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webhook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Webhooks
         * @param {string} key 
         * @param {WebhookUpdate} webhookUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhooksApiV1WebhooksKeyPatch: async (key: string, webhookUpdate: WebhookUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateWebhooksApiV1WebhooksKeyPatch', 'key', key)
            // verify required parameter 'webhookUpdate' is not null or undefined
            assertParamExists('updateWebhooksApiV1WebhooksKeyPatch', 'webhookUpdate', webhookUpdate)
            const localVarPath = `/api/v1/webhooks/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webhookUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 * @export
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Webhooks
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebhooksApiV1WebhooksKeyDelete(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebhooksApiV1WebhooksKeyDelete(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.deleteWebhooksApiV1WebhooksKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Webhooks
         * @param {ResourceType} [resourceType] 
         * @param {string} [resourceId] 
         * @param {string} [workspaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebhooksApiV1WebhooksGet(resourceType?: ResourceType, resourceId?: string, workspaceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Webhook>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebhooksApiV1WebhooksGet(resourceType, resourceId, workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.listWebhooksApiV1WebhooksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Webhook
         * @param {string} key 
         * @param {Webhook} webhook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWebhookApiV1WebhooksKeyPut(key: string, webhook: Webhook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Webhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWebhookApiV1WebhooksKeyPut(key, webhook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.setWebhookApiV1WebhooksKeyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Webhooks
         * @param {string} key 
         * @param {WebhookUpdate} webhookUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWebhooksApiV1WebhooksKeyPatch(key: string, webhookUpdate: WebhookUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Webhook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWebhooksApiV1WebhooksKeyPatch(key, webhookUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.updateWebhooksApiV1WebhooksKeyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhooksApi - factory interface
 * @export
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Webhooks
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebhooksApiV1WebhooksKeyDelete(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWebhooksApiV1WebhooksKeyDelete(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Webhooks
         * @param {ResourceType} [resourceType] 
         * @param {string} [resourceId] 
         * @param {string} [workspaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhooksApiV1WebhooksGet(resourceType?: ResourceType, resourceId?: string, workspaceId?: string, options?: any): AxiosPromise<Array<Webhook>> {
            return localVarFp.listWebhooksApiV1WebhooksGet(resourceType, resourceId, workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Webhook
         * @param {string} key 
         * @param {Webhook} webhook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWebhookApiV1WebhooksKeyPut(key: string, webhook: Webhook, options?: any): AxiosPromise<Webhook> {
            return localVarFp.setWebhookApiV1WebhooksKeyPut(key, webhook, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Webhooks
         * @param {string} key 
         * @param {WebhookUpdate} webhookUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebhooksApiV1WebhooksKeyPatch(key: string, webhookUpdate: WebhookUpdate, options?: any): AxiosPromise<Webhook> {
            return localVarFp.updateWebhooksApiV1WebhooksKeyPatch(key, webhookUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
export class WebhooksApi extends BaseAPI {
    /**
     * 
     * @summary Delete Webhooks
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public deleteWebhooksApiV1WebhooksKeyDelete(key: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).deleteWebhooksApiV1WebhooksKeyDelete(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Webhooks
     * @param {ResourceType} [resourceType] 
     * @param {string} [resourceId] 
     * @param {string} [workspaceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public listWebhooksApiV1WebhooksGet(resourceType?: ResourceType, resourceId?: string, workspaceId?: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).listWebhooksApiV1WebhooksGet(resourceType, resourceId, workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Webhook
     * @param {string} key 
     * @param {Webhook} webhook 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public setWebhookApiV1WebhooksKeyPut(key: string, webhook: Webhook, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).setWebhookApiV1WebhooksKeyPut(key, webhook, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Webhooks
     * @param {string} key 
     * @param {WebhookUpdate} webhookUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public updateWebhooksApiV1WebhooksKeyPatch(key: string, webhookUpdate: WebhookUpdate, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).updateWebhooksApiV1WebhooksKeyPatch(key, webhookUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkspacesApi - axios parameter creator
 * @export
 */
export const WorkspacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Workspace
         * @param {WorkspaceCreate} workspaceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceApiV1WorkspacesPost: async (workspaceCreate: WorkspaceCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceCreate' is not null or undefined
            assertParamExists('createWorkspaceApiV1WorkspacesPost', 'workspaceCreate', workspaceCreate)
            const localVarPath = `/api/v1/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Workspace
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete', 'workspaceId', workspaceId)
            const localVarPath = `/api/v1/workspaces/{workspace_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Media Url
         * @param {string} filePath 
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet: async (filePath: string, workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet', 'filePath', filePath)
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v1/workspaces/{workspace_id}/media/{file_path}`
                .replace(`{${"file_path"}}`, encodeURIComponent(String(filePath)))
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Workspace
         * @param {string} workspaceId 
         * @param {boolean} [includeSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceApiV1WorkspacesWorkspaceIdGet: async (workspaceId: string, includeSettings?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getWorkspaceApiV1WorkspacesWorkspaceIdGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v1/workspaces/{workspace_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (includeSettings !== undefined) {
                localVarQueryParameter['include_settings'] = includeSettings;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Workspaces
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [includeSettings] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesApiV1WorkspacesGet: async (skip?: number, limit?: number, includeSettings?: boolean, includeInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (includeSettings !== undefined) {
                localVarQueryParameter['include_settings'] = includeSettings;
            }

            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoApiV1WorkspacesInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workspaces/_info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidate Workspace Cache
         * @param {string} workspaceId 
         * @param {string} realm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost: async (workspaceId: string, realm: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost', 'workspaceId', workspaceId)
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost', 'realm', realm)
            const localVarPath = `/api/v1/workspaces/{workspace_id}/_invalidate_cache/{realm}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"realm"}}`, encodeURIComponent(String(realm)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidate Workspace Cache Key
         * @param {string} workspaceId 
         * @param {string} realm 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost: async (workspaceId: string, realm: string, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost', 'workspaceId', workspaceId)
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost', 'realm', realm)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost', 'key', key)
            const localVarPath = `/api/v1/workspaces/{workspace_id}/_invalidate_cache/{realm}/{key}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)))
                .replace(`{${"realm"}}`, encodeURIComponent(String(realm)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Workspace
         * @param {string} workspaceId 
         * @param {WorkspacePatch} workspacePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceApiV1WorkspacesWorkspaceIdPatch: async (workspaceId: string, workspacePatch: WorkspacePatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('updateWorkspaceApiV1WorkspacesWorkspaceIdPatch', 'workspaceId', workspaceId)
            // verify required parameter 'workspacePatch' is not null or undefined
            assertParamExists('updateWorkspaceApiV1WorkspacesWorkspaceIdPatch', 'workspacePatch', workspacePatch)
            const localVarPath = `/api/v1/workspaces/{workspace_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspacePatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspacesApi - functional programming interface
 * @export
 */
export const WorkspacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspacesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Workspace
         * @param {WorkspaceCreate} workspaceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspaceApiV1WorkspacesPost(workspaceCreate: WorkspaceCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceDataplane>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkspaceApiV1WorkspacesPost(workspaceCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.createWorkspaceApiV1WorkspacesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Workspace
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Media Url
         * @param {string} filePath 
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(filePath: string, workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(filePath, workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Workspace
         * @param {string} workspaceId 
         * @param {boolean} [includeSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceApiV1WorkspacesWorkspaceIdGet(workspaceId: string, includeSettings?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceDataplane>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceApiV1WorkspacesWorkspaceIdGet(workspaceId, includeSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.getWorkspaceApiV1WorkspacesWorkspaceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Workspaces
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [includeSettings] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacesApiV1WorkspacesGet(skip?: number, limit?: number, includeSettings?: boolean, includeInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkspaceDataplane>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacesApiV1WorkspacesGet(skip, limit, includeSettings, includeInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.getWorkspacesApiV1WorkspacesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoApiV1WorkspacesInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoApiV1WorkspacesInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.infoApiV1WorkspacesInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invalidate Workspace Cache
         * @param {string} workspaceId 
         * @param {string} realm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost(workspaceId: string, realm: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost(workspaceId, realm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invalidate Workspace Cache Key
         * @param {string} workspaceId 
         * @param {string} realm 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost(workspaceId: string, realm: string, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost(workspaceId, realm, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Workspace
         * @param {string} workspaceId 
         * @param {WorkspacePatch} workspacePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkspaceApiV1WorkspacesWorkspaceIdPatch(workspaceId: string, workspacePatch: WorkspacePatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceDataplane>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkspaceApiV1WorkspacesWorkspaceIdPatch(workspaceId, workspacePatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.updateWorkspaceApiV1WorkspacesWorkspaceIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkspacesApi - factory interface
 * @export
 */
export const WorkspacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspacesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Workspace
         * @param {WorkspaceCreate} workspaceCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceApiV1WorkspacesPost(workspaceCreate: WorkspaceCreate, options?: any): AxiosPromise<WorkspaceDataplane> {
            return localVarFp.createWorkspaceApiV1WorkspacesPost(workspaceCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Workspace
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete(workspaceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Media Url
         * @param {string} filePath 
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(filePath: string, workspaceId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(filePath, workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Workspace
         * @param {string} workspaceId 
         * @param {boolean} [includeSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceApiV1WorkspacesWorkspaceIdGet(workspaceId: string, includeSettings?: boolean, options?: any): AxiosPromise<WorkspaceDataplane> {
            return localVarFp.getWorkspaceApiV1WorkspacesWorkspaceIdGet(workspaceId, includeSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Workspaces
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [includeSettings] 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesApiV1WorkspacesGet(skip?: number, limit?: number, includeSettings?: boolean, includeInactive?: boolean, options?: any): AxiosPromise<Array<WorkspaceDataplane>> {
            return localVarFp.getWorkspacesApiV1WorkspacesGet(skip, limit, includeSettings, includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoApiV1WorkspacesInfoGet(options?: any): AxiosPromise<WorkspaceInfo> {
            return localVarFp.infoApiV1WorkspacesInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidate Workspace Cache
         * @param {string} workspaceId 
         * @param {string} realm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost(workspaceId: string, realm: string, options?: any): AxiosPromise<any> {
            return localVarFp.invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost(workspaceId, realm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidate Workspace Cache Key
         * @param {string} workspaceId 
         * @param {string} realm 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost(workspaceId: string, realm: string, key: string, options?: any): AxiosPromise<any> {
            return localVarFp.invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost(workspaceId, realm, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Workspace
         * @param {string} workspaceId 
         * @param {WorkspacePatch} workspacePatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceApiV1WorkspacesWorkspaceIdPatch(workspaceId: string, workspacePatch: WorkspacePatch, options?: any): AxiosPromise<WorkspaceDataplane> {
            return localVarFp.updateWorkspaceApiV1WorkspacesWorkspaceIdPatch(workspaceId, workspacePatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspacesApi - object-oriented interface
 * @export
 * @class WorkspacesApi
 * @extends {BaseAPI}
 */
export class WorkspacesApi extends BaseAPI {
    /**
     * 
     * @summary Create Workspace
     * @param {WorkspaceCreate} workspaceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public createWorkspaceApiV1WorkspacesPost(workspaceCreate: WorkspaceCreate, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).createWorkspaceApiV1WorkspacesPost(workspaceCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Workspace
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).deleteWorkspaceApiV1WorkspacesWorkspaceIdDelete(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Media Url
     * @param {string} filePath 
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(filePath: string, workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).getMediaUrlApiV1WorkspacesWorkspaceIdMediaFilePathGet(filePath, workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Workspace
     * @param {string} workspaceId 
     * @param {boolean} [includeSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public getWorkspaceApiV1WorkspacesWorkspaceIdGet(workspaceId: string, includeSettings?: boolean, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).getWorkspaceApiV1WorkspacesWorkspaceIdGet(workspaceId, includeSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Workspaces
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [includeSettings] 
     * @param {boolean} [includeInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public getWorkspacesApiV1WorkspacesGet(skip?: number, limit?: number, includeSettings?: boolean, includeInactive?: boolean, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).getWorkspacesApiV1WorkspacesGet(skip, limit, includeSettings, includeInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public infoApiV1WorkspacesInfoGet(options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).infoApiV1WorkspacesInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidate Workspace Cache
     * @param {string} workspaceId 
     * @param {string} realm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost(workspaceId: string, realm: string, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).invalidateWorkspaceCacheApiV1WorkspacesWorkspaceIdInvalidateCacheRealmPost(workspaceId, realm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidate Workspace Cache Key
     * @param {string} workspaceId 
     * @param {string} realm 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost(workspaceId: string, realm: string, key: string, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).invalidateWorkspaceCacheKeyApiV1WorkspacesWorkspaceIdInvalidateCacheRealmKeyPost(workspaceId, realm, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Workspace
     * @param {string} workspaceId 
     * @param {WorkspacePatch} workspacePatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public updateWorkspaceApiV1WorkspacesWorkspaceIdPatch(workspaceId: string, workspacePatch: WorkspacePatch, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).updateWorkspaceApiV1WorkspacesWorkspaceIdPatch(workspaceId, workspacePatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkspacesV2Api - axios parameter creator
 * @export
 */
export const WorkspacesV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deployment callback for agents module
         * @summary Callback for agents module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost: async (workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost', 'workspaceId', workspaceId)
            // verify required parameter 'moduleDeployCallback' is not null or undefined
            assertParamExists('callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost', 'moduleDeployCallback', moduleDeployCallback)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/agents/callback`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleDeployCallback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deployment callback for case_management module
         * @summary Callback for case_management module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost: async (workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost', 'workspaceId', workspaceId)
            // verify required parameter 'moduleDeployCallback' is not null or undefined
            assertParamExists('callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost', 'moduleDeployCallback', moduleDeployCallback)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/case_management/callback`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleDeployCallback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deployment callback for connect module
         * @summary Callback for connect module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost: async (workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost', 'workspaceId', workspaceId)
            // verify required parameter 'moduleDeployCallback' is not null or undefined
            assertParamExists('callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost', 'moduleDeployCallback', moduleDeployCallback)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/connect/callback`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleDeployCallback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deployment callback for files module
         * @summary Callback for files module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost: async (workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost', 'workspaceId', workspaceId)
            // verify required parameter 'moduleDeployCallback' is not null or undefined
            assertParamExists('callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost', 'moduleDeployCallback', moduleDeployCallback)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/files/callback`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleDeployCallback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deployment callback for history module
         * @summary Callback for history module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost: async (workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost', 'workspaceId', workspaceId)
            // verify required parameter 'moduleDeployCallback' is not null or undefined
            assertParamExists('callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost', 'moduleDeployCallback', moduleDeployCallback)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/history/callback`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleDeployCallback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the agents module for the workspace
         * @summary Create agents module
         * @param {string} workspaceId 
         * @param {AgentsModuleCreateRequest} agentsModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut: async (workspaceId: string, agentsModuleCreateRequest: AgentsModuleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut', 'workspaceId', workspaceId)
            // verify required parameter 'agentsModuleCreateRequest' is not null or undefined
            assertParamExists('createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut', 'agentsModuleCreateRequest', agentsModuleCreateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/agents`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentsModuleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the case_management module for the workspace
         * @summary Create case_management module
         * @param {string} workspaceId 
         * @param {CaseManagementModuleCreateRequest} caseManagementModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut: async (workspaceId: string, caseManagementModuleCreateRequest: CaseManagementModuleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut', 'workspaceId', workspaceId)
            // verify required parameter 'caseManagementModuleCreateRequest' is not null or undefined
            assertParamExists('createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut', 'caseManagementModuleCreateRequest', caseManagementModuleCreateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/case_management`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseManagementModuleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the connect module for the workspace
         * @summary Create connect module
         * @param {string} workspaceId 
         * @param {ConnectModuleCreateRequest} connectModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut: async (workspaceId: string, connectModuleCreateRequest: ConnectModuleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut', 'workspaceId', workspaceId)
            // verify required parameter 'connectModuleCreateRequest' is not null or undefined
            assertParamExists('createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut', 'connectModuleCreateRequest', connectModuleCreateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/connect`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectModuleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the files module for the workspace
         * @summary Create files module
         * @param {string} workspaceId 
         * @param {FilesModuleCreateRequest} filesModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut: async (workspaceId: string, filesModuleCreateRequest: FilesModuleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut', 'workspaceId', workspaceId)
            // verify required parameter 'filesModuleCreateRequest' is not null or undefined
            assertParamExists('createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut', 'filesModuleCreateRequest', filesModuleCreateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/files`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filesModuleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create the history module for the workspace
         * @summary Create history module
         * @param {string} workspaceId 
         * @param {HistoryModuleCreateRequest} historyModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut: async (workspaceId: string, historyModuleCreateRequest: HistoryModuleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut', 'workspaceId', workspaceId)
            // verify required parameter 'historyModuleCreateRequest' is not null or undefined
            assertParamExists('createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut', 'historyModuleCreateRequest', historyModuleCreateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/history`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(historyModuleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the agents module for the workspace
         * @summary Get agents module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/agents`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the case_management module for the workspace
         * @summary Get case_management module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/case_management`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the connect module for the workspace
         * @summary Get connect module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/connect`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the files module for the workspace
         * @summary Get files module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/files`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the history module for the workspace
         * @summary Get history module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/history`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Modules
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesApiV2WorkspacesWorkspaceIdModulesGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getModulesApiV2WorkspacesWorkspaceIdModulesGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Workspace
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceApiV2WorkspacesWorkspaceIdGet: async (workspaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('getWorkspaceApiV2WorkspacesWorkspaceIdGet', 'workspaceId', workspaceId)
            const localVarPath = `/api/v2/workspaces/{workspace_id}`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Workspaces
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesApiV2WorkspacesGet: async (skip?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the agents module for the workspace
         * @summary Update agents module
         * @param {string} workspaceId 
         * @param {AgentsModuleUpdateRequest} agentsModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch: async (workspaceId: string, agentsModuleUpdateRequest: AgentsModuleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch', 'workspaceId', workspaceId)
            // verify required parameter 'agentsModuleUpdateRequest' is not null or undefined
            assertParamExists('updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch', 'agentsModuleUpdateRequest', agentsModuleUpdateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/agents`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentsModuleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the case_management module for the workspace
         * @summary Update case_management module
         * @param {string} workspaceId 
         * @param {CaseManagementModuleUpdateRequest} caseManagementModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch: async (workspaceId: string, caseManagementModuleUpdateRequest: CaseManagementModuleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch', 'workspaceId', workspaceId)
            // verify required parameter 'caseManagementModuleUpdateRequest' is not null or undefined
            assertParamExists('updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch', 'caseManagementModuleUpdateRequest', caseManagementModuleUpdateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/case_management`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseManagementModuleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the connect module for the workspace
         * @summary Update connect module
         * @param {string} workspaceId 
         * @param {ConnectModuleUpdateRequest} connectModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch: async (workspaceId: string, connectModuleUpdateRequest: ConnectModuleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch', 'workspaceId', workspaceId)
            // verify required parameter 'connectModuleUpdateRequest' is not null or undefined
            assertParamExists('updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch', 'connectModuleUpdateRequest', connectModuleUpdateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/connect`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectModuleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the files module for the workspace
         * @summary Update files module
         * @param {string} workspaceId 
         * @param {FilesModuleUpdateRequest} filesModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch: async (workspaceId: string, filesModuleUpdateRequest: FilesModuleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch', 'workspaceId', workspaceId)
            // verify required parameter 'filesModuleUpdateRequest' is not null or undefined
            assertParamExists('updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch', 'filesModuleUpdateRequest', filesModuleUpdateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/files`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filesModuleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the history module for the workspace
         * @summary Update history module
         * @param {string} workspaceId 
         * @param {HistoryModuleUpdateRequest} historyModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch: async (workspaceId: string, historyModuleUpdateRequest: HistoryModuleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch', 'workspaceId', workspaceId)
            // verify required parameter 'historyModuleUpdateRequest' is not null or undefined
            assertParamExists('updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch', 'historyModuleUpdateRequest', historyModuleUpdateRequest)
            const localVarPath = `/api/v2/workspaces/{workspace_id}/modules/history`
                .replace(`{${"workspace_id"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(historyModuleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspacesV2Api - functional programming interface
 * @export
 */
export const WorkspacesV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspacesV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * Deployment callback for agents module
         * @summary Callback for agents module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost(workspaceId, moduleDeployCallback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deployment callback for case_management module
         * @summary Callback for case_management module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost(workspaceId, moduleDeployCallback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deployment callback for connect module
         * @summary Callback for connect module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost(workspaceId, moduleDeployCallback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deployment callback for files module
         * @summary Callback for files module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost(workspaceId, moduleDeployCallback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deployment callback for history module
         * @summary Callback for history module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost(workspaceId, moduleDeployCallback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create the agents module for the workspace
         * @summary Create agents module
         * @param {string} workspaceId 
         * @param {AgentsModuleCreateRequest} agentsModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut(workspaceId: string, agentsModuleCreateRequest: AgentsModuleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiSchemasV2ModulesAgentsAgentsModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut(workspaceId, agentsModuleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create the case_management module for the workspace
         * @summary Create case_management module
         * @param {string} workspaceId 
         * @param {CaseManagementModuleCreateRequest} caseManagementModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut(workspaceId: string, caseManagementModuleCreateRequest: CaseManagementModuleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseManagementModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut(workspaceId, caseManagementModuleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create the connect module for the workspace
         * @summary Create connect module
         * @param {string} workspaceId 
         * @param {ConnectModuleCreateRequest} connectModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut(workspaceId: string, connectModuleCreateRequest: ConnectModuleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut(workspaceId, connectModuleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create the files module for the workspace
         * @summary Create files module
         * @param {string} workspaceId 
         * @param {FilesModuleCreateRequest} filesModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut(workspaceId: string, filesModuleCreateRequest: FilesModuleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiSchemasV2ModulesFilesFilesModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut(workspaceId, filesModuleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create the history module for the workspace
         * @summary Create history module
         * @param {string} workspaceId 
         * @param {HistoryModuleCreateRequest} historyModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut(workspaceId: string, historyModuleCreateRequest: HistoryModuleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut(workspaceId, historyModuleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the agents module for the workspace
         * @summary Get agents module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiSchemasV2ModulesAgentsAgentsModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the case_management module for the workspace
         * @summary Get case_management module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseManagementModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the connect module for the workspace
         * @summary Get connect module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the files module for the workspace
         * @summary Get files module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiSchemasV2ModulesFilesFilesModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the history module for the workspace
         * @summary Get history module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Modules
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModulesApiV2WorkspacesWorkspaceIdModulesGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Modules>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModulesApiV2WorkspacesWorkspaceIdModulesGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getModulesApiV2WorkspacesWorkspaceIdModulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Workspace
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceApiV2WorkspacesWorkspaceIdGet(workspaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceDb>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceApiV2WorkspacesWorkspaceIdGet(workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getWorkspaceApiV2WorkspacesWorkspaceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Workspaces
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacesApiV2WorkspacesGet(skip?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkspaceDb>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacesApiV2WorkspacesGet(skip, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.getWorkspacesApiV2WorkspacesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the agents module for the workspace
         * @summary Update agents module
         * @param {string} workspaceId 
         * @param {AgentsModuleUpdateRequest} agentsModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch(workspaceId: string, agentsModuleUpdateRequest: AgentsModuleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiSchemasV2ModulesAgentsAgentsModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch(workspaceId, agentsModuleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the case_management module for the workspace
         * @summary Update case_management module
         * @param {string} workspaceId 
         * @param {CaseManagementModuleUpdateRequest} caseManagementModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch(workspaceId: string, caseManagementModuleUpdateRequest: CaseManagementModuleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseManagementModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch(workspaceId, caseManagementModuleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the connect module for the workspace
         * @summary Update connect module
         * @param {string} workspaceId 
         * @param {ConnectModuleUpdateRequest} connectModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch(workspaceId: string, connectModuleUpdateRequest: ConnectModuleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch(workspaceId, connectModuleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the files module for the workspace
         * @summary Update files module
         * @param {string} workspaceId 
         * @param {FilesModuleUpdateRequest} filesModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch(workspaceId: string, filesModuleUpdateRequest: FilesModuleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowApiSchemasV2ModulesFilesFilesModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch(workspaceId, filesModuleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the history module for the workspace
         * @summary Update history module
         * @param {string} workspaceId 
         * @param {HistoryModuleUpdateRequest} historyModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch(workspaceId: string, historyModuleUpdateRequest: HistoryModuleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryModuleSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch(workspaceId, historyModuleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesV2Api.updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkspacesV2Api - factory interface
 * @export
 */
export const WorkspacesV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspacesV2ApiFp(configuration)
    return {
        /**
         * Deployment callback for agents module
         * @summary Callback for agents module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: any): AxiosPromise<void> {
            return localVarFp.callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(axios, basePath));
        },
        /**
         * Deployment callback for case_management module
         * @summary Callback for case_management module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: any): AxiosPromise<void> {
            return localVarFp.callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(axios, basePath));
        },
        /**
         * Deployment callback for connect module
         * @summary Callback for connect module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: any): AxiosPromise<void> {
            return localVarFp.callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(axios, basePath));
        },
        /**
         * Deployment callback for files module
         * @summary Callback for files module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: any): AxiosPromise<void> {
            return localVarFp.callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(axios, basePath));
        },
        /**
         * Deployment callback for history module
         * @summary Callback for history module
         * @param {string} workspaceId 
         * @param {ModuleDeployCallback} moduleDeployCallback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: any): AxiosPromise<void> {
            return localVarFp.callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the agents module for the workspace
         * @summary Create agents module
         * @param {string} workspaceId 
         * @param {AgentsModuleCreateRequest} agentsModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut(workspaceId: string, agentsModuleCreateRequest: AgentsModuleCreateRequest, options?: any): AxiosPromise<FlowApiSchemasV2ModulesAgentsAgentsModuleSpec> {
            return localVarFp.createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut(workspaceId, agentsModuleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the case_management module for the workspace
         * @summary Create case_management module
         * @param {string} workspaceId 
         * @param {CaseManagementModuleCreateRequest} caseManagementModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut(workspaceId: string, caseManagementModuleCreateRequest: CaseManagementModuleCreateRequest, options?: any): AxiosPromise<CaseManagementModuleSpec> {
            return localVarFp.createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut(workspaceId, caseManagementModuleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the connect module for the workspace
         * @summary Create connect module
         * @param {string} workspaceId 
         * @param {ConnectModuleCreateRequest} connectModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut(workspaceId: string, connectModuleCreateRequest: ConnectModuleCreateRequest, options?: any): AxiosPromise<ConnectModuleSpec> {
            return localVarFp.createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut(workspaceId, connectModuleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the files module for the workspace
         * @summary Create files module
         * @param {string} workspaceId 
         * @param {FilesModuleCreateRequest} filesModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut(workspaceId: string, filesModuleCreateRequest: FilesModuleCreateRequest, options?: any): AxiosPromise<FlowApiSchemasV2ModulesFilesFilesModuleSpec> {
            return localVarFp.createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut(workspaceId, filesModuleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create the history module for the workspace
         * @summary Create history module
         * @param {string} workspaceId 
         * @param {HistoryModuleCreateRequest} historyModuleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut(workspaceId: string, historyModuleCreateRequest: HistoryModuleCreateRequest, options?: any): AxiosPromise<HistoryModuleSpec> {
            return localVarFp.createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut(workspaceId, historyModuleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the agents module for the workspace
         * @summary Get agents module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet(workspaceId: string, options?: any): AxiosPromise<FlowApiSchemasV2ModulesAgentsAgentsModuleSpec> {
            return localVarFp.getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the case_management module for the workspace
         * @summary Get case_management module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet(workspaceId: string, options?: any): AxiosPromise<CaseManagementModuleSpec> {
            return localVarFp.getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the connect module for the workspace
         * @summary Get connect module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet(workspaceId: string, options?: any): AxiosPromise<ConnectModuleSpec> {
            return localVarFp.getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the files module for the workspace
         * @summary Get files module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet(workspaceId: string, options?: any): AxiosPromise<FlowApiSchemasV2ModulesFilesFilesModuleSpec> {
            return localVarFp.getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the history module for the workspace
         * @summary Get history module
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet(workspaceId: string, options?: any): AxiosPromise<HistoryModuleSpec> {
            return localVarFp.getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Modules
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModulesApiV2WorkspacesWorkspaceIdModulesGet(workspaceId: string, options?: any): AxiosPromise<Modules> {
            return localVarFp.getModulesApiV2WorkspacesWorkspaceIdModulesGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Workspace
         * @param {string} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceApiV2WorkspacesWorkspaceIdGet(workspaceId: string, options?: any): AxiosPromise<WorkspaceDb> {
            return localVarFp.getWorkspaceApiV2WorkspacesWorkspaceIdGet(workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Workspaces
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacesApiV2WorkspacesGet(skip?: number, limit?: number, options?: any): AxiosPromise<Array<WorkspaceDb>> {
            return localVarFp.getWorkspacesApiV2WorkspacesGet(skip, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the agents module for the workspace
         * @summary Update agents module
         * @param {string} workspaceId 
         * @param {AgentsModuleUpdateRequest} agentsModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch(workspaceId: string, agentsModuleUpdateRequest: AgentsModuleUpdateRequest, options?: any): AxiosPromise<FlowApiSchemasV2ModulesAgentsAgentsModuleSpec> {
            return localVarFp.updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch(workspaceId, agentsModuleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the case_management module for the workspace
         * @summary Update case_management module
         * @param {string} workspaceId 
         * @param {CaseManagementModuleUpdateRequest} caseManagementModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch(workspaceId: string, caseManagementModuleUpdateRequest: CaseManagementModuleUpdateRequest, options?: any): AxiosPromise<CaseManagementModuleSpec> {
            return localVarFp.updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch(workspaceId, caseManagementModuleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the connect module for the workspace
         * @summary Update connect module
         * @param {string} workspaceId 
         * @param {ConnectModuleUpdateRequest} connectModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch(workspaceId: string, connectModuleUpdateRequest: ConnectModuleUpdateRequest, options?: any): AxiosPromise<ConnectModuleSpec> {
            return localVarFp.updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch(workspaceId, connectModuleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the files module for the workspace
         * @summary Update files module
         * @param {string} workspaceId 
         * @param {FilesModuleUpdateRequest} filesModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch(workspaceId: string, filesModuleUpdateRequest: FilesModuleUpdateRequest, options?: any): AxiosPromise<FlowApiSchemasV2ModulesFilesFilesModuleSpec> {
            return localVarFp.updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch(workspaceId, filesModuleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the history module for the workspace
         * @summary Update history module
         * @param {string} workspaceId 
         * @param {HistoryModuleUpdateRequest} historyModuleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch(workspaceId: string, historyModuleUpdateRequest: HistoryModuleUpdateRequest, options?: any): AxiosPromise<HistoryModuleSpec> {
            return localVarFp.updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch(workspaceId, historyModuleUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspacesV2Api - object-oriented interface
 * @export
 * @class WorkspacesV2Api
 * @extends {BaseAPI}
 */
export class WorkspacesV2Api extends BaseAPI {
    /**
     * Deployment callback for agents module
     * @summary Callback for agents module
     * @param {string} workspaceId 
     * @param {ModuleDeployCallback} moduleDeployCallback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).callbackAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deployment callback for case_management module
     * @summary Callback for case_management module
     * @param {string} workspaceId 
     * @param {ModuleDeployCallback} moduleDeployCallback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).callbackCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deployment callback for connect module
     * @summary Callback for connect module
     * @param {string} workspaceId 
     * @param {ModuleDeployCallback} moduleDeployCallback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).callbackConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deployment callback for files module
     * @summary Callback for files module
     * @param {string} workspaceId 
     * @param {ModuleDeployCallback} moduleDeployCallback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).callbackFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deployment callback for history module
     * @summary Callback for history module
     * @param {string} workspaceId 
     * @param {ModuleDeployCallback} moduleDeployCallback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost(workspaceId: string, moduleDeployCallback: ModuleDeployCallback, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).callbackHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryCallbackPost(workspaceId, moduleDeployCallback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the agents module for the workspace
     * @summary Create agents module
     * @param {string} workspaceId 
     * @param {AgentsModuleCreateRequest} agentsModuleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut(workspaceId: string, agentsModuleCreateRequest: AgentsModuleCreateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).createAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPut(workspaceId, agentsModuleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the case_management module for the workspace
     * @summary Create case_management module
     * @param {string} workspaceId 
     * @param {CaseManagementModuleCreateRequest} caseManagementModuleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut(workspaceId: string, caseManagementModuleCreateRequest: CaseManagementModuleCreateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).createCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPut(workspaceId, caseManagementModuleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the connect module for the workspace
     * @summary Create connect module
     * @param {string} workspaceId 
     * @param {ConnectModuleCreateRequest} connectModuleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut(workspaceId: string, connectModuleCreateRequest: ConnectModuleCreateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).createConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPut(workspaceId, connectModuleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the files module for the workspace
     * @summary Create files module
     * @param {string} workspaceId 
     * @param {FilesModuleCreateRequest} filesModuleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut(workspaceId: string, filesModuleCreateRequest: FilesModuleCreateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).createFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPut(workspaceId, filesModuleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create the history module for the workspace
     * @summary Create history module
     * @param {string} workspaceId 
     * @param {HistoryModuleCreateRequest} historyModuleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut(workspaceId: string, historyModuleCreateRequest: HistoryModuleCreateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).createHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPut(workspaceId, historyModuleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the agents module for the workspace
     * @summary Get agents module
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the case_management module for the workspace
     * @summary Get case_management module
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the connect module for the workspace
     * @summary Get connect module
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the files module for the workspace
     * @summary Get files module
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the history module for the workspace
     * @summary Get history module
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Modules
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getModulesApiV2WorkspacesWorkspaceIdModulesGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getModulesApiV2WorkspacesWorkspaceIdModulesGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Workspace
     * @param {string} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getWorkspaceApiV2WorkspacesWorkspaceIdGet(workspaceId: string, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getWorkspaceApiV2WorkspacesWorkspaceIdGet(workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Workspaces
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public getWorkspacesApiV2WorkspacesGet(skip?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).getWorkspacesApiV2WorkspacesGet(skip, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the agents module for the workspace
     * @summary Update agents module
     * @param {string} workspaceId 
     * @param {AgentsModuleUpdateRequest} agentsModuleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch(workspaceId: string, agentsModuleUpdateRequest: AgentsModuleUpdateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).updateAgentsModuleApiV2WorkspacesWorkspaceIdModulesAgentsPatch(workspaceId, agentsModuleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the case_management module for the workspace
     * @summary Update case_management module
     * @param {string} workspaceId 
     * @param {CaseManagementModuleUpdateRequest} caseManagementModuleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch(workspaceId: string, caseManagementModuleUpdateRequest: CaseManagementModuleUpdateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).updateCaseManagementModuleApiV2WorkspacesWorkspaceIdModulesCaseManagementPatch(workspaceId, caseManagementModuleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the connect module for the workspace
     * @summary Update connect module
     * @param {string} workspaceId 
     * @param {ConnectModuleUpdateRequest} connectModuleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch(workspaceId: string, connectModuleUpdateRequest: ConnectModuleUpdateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).updateConnectModuleApiV2WorkspacesWorkspaceIdModulesConnectPatch(workspaceId, connectModuleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the files module for the workspace
     * @summary Update files module
     * @param {string} workspaceId 
     * @param {FilesModuleUpdateRequest} filesModuleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch(workspaceId: string, filesModuleUpdateRequest: FilesModuleUpdateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).updateFilesModuleApiV2WorkspacesWorkspaceIdModulesFilesPatch(workspaceId, filesModuleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the history module for the workspace
     * @summary Update history module
     * @param {string} workspaceId 
     * @param {HistoryModuleUpdateRequest} historyModuleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesV2Api
     */
    public updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch(workspaceId: string, historyModuleUpdateRequest: HistoryModuleUpdateRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesV2ApiFp(this.configuration).updateHistoryModuleApiV2WorkspacesWorkspaceIdModulesHistoryPatch(workspaceId, historyModuleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



